<template>
  <div class="card">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center mb-10">
        <h4 class="card-title mb-0">VZ to LXD Migration</h4>
        <!-- Top Migration Leaders -->
        <div v-if="topMigrationLeaders.length > 0" class="top-migration-leaders d-flex flex-column">
          <p class="mb-2 ml-4 fw-600">Top Migration Leaders</p>
          <div class="leaders-bar">
            <img
              v-for="(leader, index) in topMigrationLeaders"
              :key="index"
              :id="'leader-avatar-' + index"
              class="leader-avatar"
              :src="`https://www.gravatar.com/avatar/${emailHashGravatar(leader.email)}?s=100`"
              :alt="leader.name"
            />
          </div>
        </div>
      </div>
      <!-- Status Count -->
      <div v-if="activeTab !== 'settings'" class="row mb-3 mt-2 mb-10" style="display: flex; align-items: stretch; flex-wrap: nowrap;">
        <div class="col-md-2" style="display: flex; flex: 0 0 auto; min-width: 0;">
          <div class="status-item status-item-pending" style="width: 100%;">
            <i class="fa fa-clock-o status-icon status-icon-pending"></i>
            <div class="status-content">
              <div class="status-label">Total Pending</div>
              <div class="status-count">
                <i v-if="allRecordsLoading" class="fa fa-spin fa-spinner status-label"></i>
                <span v-else>{{ pendingCount }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2" style="display: flex; flex: 0 0 auto; min-width: 0;">
          <div class="status-item status-item-cf-red" style="width: 100%;">
            <i class="fa fa-cloud status-icon status-icon-cf-red"></i>
            <div class="status-content">
              <div class="status-label">Pending Plans With DNS Provided</div>
              <div class="status-count">
                <i v-if="allRecordsLoading" class="fa fa-spin fa-spinner status-label"></i>
                <span v-else>{{ greenCFCount }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2" style="display: flex; flex: 0 0 auto; min-width: 0;">
          <div class="status-item status-item-cf-green" style="width: 100%;">
            <i class="fa fa-cloud status-icon status-icon-cf-green"></i>
            <div class="status-content">
              <div class="status-label">Pending Plans Without DNS Provided</div>
              <div class="status-count">
                <i v-if="allRecordsLoading" class="fa fa-spin fa-spinner status-label"></i>
                <span v-else>{{ nonGreenCFCount }}</span>
              </div>
            </div>
          </div>
        </div>
        dded <div class="col-md-2" style="display: flex; flex: 0 0 auto; min-width: 0;">
          <div class="status-item status-item-inprogress" style="width: 100%;">
            <i class="fa fa-spinner status-icon status-icon-inprogress"></i>
            <div class="status-content">
              <div class="status-label">In Progress</div>
              <div class="status-count">
                <i v-if="allRecordsLoading" class="fa fa-spin fa-spinner status-label"></i>
                <span v-else>{{ inProgressCount }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2" style="display: flex; flex: 0 0 auto; min-width: 0;">
          <div class="status-item status-item-complete" style="width: 100%;">
            <i class="fa fa-check-circle status-icon status-icon-complete"></i>
            <div class="status-content">
              <div class="status-label">Complete</div>
              <div class="status-count">
                <i v-if="allRecordsLoading" class="fa fa-spin fa-spinner status-label"></i>
                <span v-else>{{ completeCount }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2" style="display: flex; flex: 0 0 auto; min-width: 0;">
          <div class="status-item status-item-deferred" style="width: 100%;">
            <i class="fa fa-pause status-icon status-icon-deferred"></i>
            <div class="status-content">
              <div class="status-label">Deferred</div>
              <div class="status-count">
                <i v-if="allRecordsLoading" class="fa fa-spin fa-spinner status-label"></i>
                <span v-else>{{ deferredCount }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul class="nav nav-tabs" id="migrationTabs" role="tablist">
        <li class="nav-item">
          <a 
            class="nav-link" 
            :class="{ active: activeTab === 'pending' }"
            id="pending-tab"
            data-toggle="tab" 
            href="#pending" 
            role="tab" 
            aria-controls="pending" 
            @click="changeTab('pending')"
          >
            Pending
          </a>
        </li>
        <li class="nav-item">
          <a 
            class="nav-link" 
            :class="{ active: activeTab === 'in-progress' }"
            id="in-progress-tab"
            data-toggle="tab" 
            href="#in-progress" 
            role="tab" 
            aria-controls="in-progress" 
            @click="changeTab('in-progress')"
          >
            In Progress
          </a>
        </li>
        <li class="nav-item">
          <a 
            class="nav-link" 
            :class="{ active: activeTab === 'complete' }"
            id="complete-tab"
            data-toggle="tab" 
            href="#complete" 
            role="tab" 
            aria-controls="complete" 
            @click="changeTab('complete')"
          >
            Complete
          </a>
        </li>
        <li class="nav-item">
          <a 
            class="nav-link" 
            :class="{ active: activeTab === 'deferred' }"
            id="deferred-tab"
            data-toggle="tab" 
            href="#deferred" 
            role="tab" 
            aria-controls="deferred" 
            @click="changeTab('deferred')"
          >
            Deferred
          </a>
        </li>
        <li v-if="user.userType === 'super-admin'" class="nav-item">
          <a 
            class="nav-link" 
            :class="{ active: activeTab === 'settings' }"
            id="settings-tab"
            data-toggle="tab" 
            href="#settings" 
            role="tab" 
            aria-controls="settings" 
            @click="changeTab('settings')"
          >
            Settings
          </a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <!-- Filters Section -->
      <div class="row mb-3" v-if="activeTab !== 'settings'">
        <div class="col-md-12 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center mb-10">
            <!--            <label class="fw-600 mr-3 mb-0">FILTERS:</label>-->
            <div class="d-flex align-items-center mb-10">
            <div class="form-group mb-0 mr-5 ml-5">
                <label class="fw-600 mr-3 mb-0" style="color: #8c8c8c" for="">IP Group</label>
              <select v-model="selectedIpGroup" class="form-control">
                <option value="all">All IP Groups</option>
                <option value="Steadfast">Steadfast (Priority)</option>
                <option value="Cogent">Cogent</option>
                <option value="Other">Other / Internal</option>
              </select>
            </div>
            <div class="form-group mb-0 ml-5 mr-5">
                <label class="fw-600 mr-3 mb-0" style="color: #8c8c8c" for="">Racks</label>
                <select v-model="selectedRack" class="form-control">
                  <option value="all">All Racks</option>
                  <option v-for="node in availableRacks" :key="node" :value="node">{{ node }}</option>
              </select>
            </div>
              <div class="form-group mb-0 ml-5 mr-5">
                <label class="fw-600 mr-3 mb-0" style="color: #8c8c8c" for="">Nodes</label>
              <select v-model="selectedNode" class="form-control">
                <option value="all">All Nodes</option>
                <option v-for="node in availableNodes" :key="node" :value="node">{{ node }}</option>
              </select>
            </div>
              <div class="form-group mb-0 ml-5 mr-5">
                <label class="fw-600 mr-3 mb-0" style="color: #8c8c8c" for="">DNS Ticket</label>
                <select v-model="dnsTicketCreated" class="form-control" style="width: 100px">
                  <option value="all">All</option>
                  <option :value="true">Yes</option>
                  <option :value="false">No</option>
                </select>
          </div>
              <div class="form-group mb-0 ml-5 mr-5">
                <label class="fw-600 mr-3 mb-0" style="color: #8c8c8c" for="">DNS Provided</label>
                <select v-model="dnsProvided" class="form-control" style="width: 100px">
                  <option value="all">All</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
        </div>
            </div>

            <button class="btn btn-sm ml-3 mt-20" @click="resetFilters">Reset</button>
          </div>
          <input v-if="activeTab === 'pending'" v-model="selectedSearch" style="width: 20%" placeholder="Search By Hostname, IP, Service ID" type="text" class="form-control">
        </div>
        <!-- Plans filter row -->
        <div class="col-md-6 mb-10" v-click-outside="() => showPlansDropdown = false">
          <div class="plans-card" :class="{ 'plans-card--open': showPlansDropdown }">
            <!-- Header -->
            <div class="plans-card-header" @click="showPlansDropdown = !showPlansDropdown">
              <div class="plans-card-header-left">
<!--                <span class="plans-card-icon">-->
<!--                  <i class="fa fa-filter"></i>-->
<!--                </span>-->
                <span class="plans-card-title">Plans</span>
                <!-- Selected plan chips preview when collapsed -->
                <transition name="plans-slide">
                  <div v-if="!showPlansDropdown && selectedPlans.length" class="plans-preview-chips">
                    <span
                      v-for="plan in selectedPlans"
                      :key="plan.value"
                      class="plans-preview-chip"
                    >{{ plan.label }}</span>
                  </div>
                </transition>
              </div>
              <div class="plans-card-header-right">
<!--                <span v-if="selectedPlans.length" class="plans-clear-x" @click.stop="selectedPlans = []" title="Clear all">-->
<!--                  <i class="fa fa-times"></i>-->
<!--                </span>-->
<!--                <span class="plans-chevron" :class="{ 'plans-chevron&#45;&#45;open': showPlansDropdown }">-->
<!--                  <i class="fa fa-chevron-down"></i>-->
<!--                </span>-->
              </div>
            </div>
            <!-- Body -->
            <transition name="plans-expand">
              <div v-show="showPlansDropdown" class="plans-card-body">
                <multiselect
                    ref="planMultiselect"
                  v-model="selectedPlans"
                  :options="planOptions"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="🔍  Search or pick plans…"
                  label="label"
                  track-by="value"
                  :preselect-first="false"
                  class="plans-multiselect"
                  open-direction="bottom"
                />
              </div>
            </transition>
          </div>
        </div>

        <div class="col-md-12">
          <div class="d-flex align-items-center mb-10 flex-wrap" style="gap: 4px">
            <label class="fw-600 mr-3 mb-0">Priority Filter:</label>
            <button
                v-for="(filter, index) in priorityFilers"
                :key="index"
                type="button"
                class="btn btn-sm priority-filter-btn"
                :class="getBootstrapButtonClass(filter)"
                @click="selectedPriorityFilter = selectedPriorityFilter === filter ? null : filter"
            >
              {{ filter }}
            </button>
            <!-- Team Morning -->
            <div class="team-filter-group">
              <button
                  type="button"
                  class="btn btn-sm priority-filter-btn"
                  :class="selectedTeamFilter === 'morning' ? 'btn-warning' : 'btn-warning btn-link'"
                  @click="selectedTeamFilter = selectedTeamFilter === 'morning' ? null : 'morning'"
              >
                <i class="fa fa-sun-o mr-1"></i> Team Morning
              </button>
            </div>

            <!-- Team Night -->
            <div class="team-filter-group">
              <button
                  type="button"
                  class="btn btn-sm priority-filter-btn"
                  :class="selectedTeamFilter === 'night' ? 'btn-secondary' : 'btn-secondary btn-link'"
                  @click="selectedTeamFilter = selectedTeamFilter === 'night' ? null : 'night'"
              >
                <i class="fa fa-moon-o mr-1"></i> Team Night
              </button>
            </div>
          </div>
        </div>
        <template v-if="activeTab === 'in-progress'">
          <div class="col-md-12">
            <div class="d-flex align-items-center mb-10 flex-wrap" style="gap: 4px">
              <label class="fw-600 mr-3 mb-0">Steps Filter:</label>
              <button
                  v-for="(step, index) in stepNames"
                  :key="index"
                  type="button"
                  class="btn btn-sm priority-filter-btn"
                  :class="getStepButtonClass(step)"
                  @click="selectedStep = selectedStep === step ? null : step"
              >
                {{ step }}
              </button>
            </div>
          </div>
        </template>
        <template v-if="activeTab !== 'pending'">
          <div class="col-md-12">
            <div class="d-flex align-items-center mb-10">
              <label class="fw-600 mr-3 mb-0">Checkin Filter:</label>
              <button :class="checkinFilter === 'all' ? 'btn-outlined-primary' : 'btn-link'"  @click="checkinFilter = 'all'" type="button" class="btn btn-primary btn-sm ml-5">
                <img class="rounded-circle" width="20px" height="20px" :src="`https://www.gravatar.com/avatar/${emailHashGravatar('')}?s=100`" />
                All
              </button>
              <button :class="checkinFilter === `${user.firstName} ${user.lastName}` ? 'btn-outlined-primary' : 'btn-link'" @click="checkinFilter = `${user.firstName} ${user.lastName}`" type="button" class="btn btn-primary btn-sm">
                <img class="rounded-circle" width="20px" height="20px" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(user.email)}?s=100`" />
                {{ user.firstName }}
              </button>

            </div>
          </div>
          <div class="col-md-10 mt-2">
            <label style="width: 13%" class="d-flex align-items-center"> Show
              <select id="grouped"
                      v-model="pPageSize" aria-describedby="grouped"
                      class="ml-5 custom-select custom-select-sm form-control form-control-sm datatable-dropdown" required>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option :value="activeTab === 'in-progress' ? inProgressData.length : activeTab === 'complete' ? completeData.length : deferredData.length">All</option>
              </select>
              <span class="ml-5">entries</span>
            </label>
          </div>
          <div class="col-md-2 d-flex align-items-center">
            <label for="">Search:</label>
            <input v-model="searchText" type="text" class="form-control ml-5">
          </div>
        </template>

      </div>
      <div class="tab-content" id="migrationTabContent">
        <!-- Pending Tab -->
        <div 
          class="tab-pane fade" 
          :class="{ 'show active': activeTab === 'pending' }"
          id="pending" 
          role="tabpanel" 
          aria-labelledby="pending-tab"
        >
          <table :class="{'table-responsive': !loader && filteredPendingData.length}" id="pending-table" class="table table-bordered" cellspacing="0" width="100%">
            <thead>
              <tr class="main-header">
              <th colspan="7" class="text-center">CONTAINER DETAILS</th>
              <th colspan="5" class="text-center">OPENVZ (SOURCE)</th>
                <th colspan="4" class="text-center">LXD (DESTINATION)</th>
              </tr>
              <tr class="sub-header">
                <th>Check In</th>
              <th width="10%" class="text-center">Hostname</th>
                <th class="text-center">Domains</th>
              <th class="text-center">DNS Provided</th>
                <th class="text-center">STATUS</th>
                <th class="text-center">PLAN</th>
                <th class="text-center">Preserve IP</th>
                <th class="text-center">IP</th>
              <th class="text-center">Rack</th>
                <th class="text-center">Node</th>
                <th class="text-center">Disk</th>
              <th class="text-center">Location</th>
                <th class="text-center">IP</th>
                <th class="text-center">Cluster</th>
                <th class="text-center">Node</th>
                <th class="text-center">Disk</th>
              </tr>
            </thead>
            <tbody v-show="!loader">
            <tr v-if="!filteredPendingData.length">
              <td colspan="15" class="text-center text-danger">No data exists</td>
            </tr>
              <template v-for="(item, index) in filteredPendingData">
                <tr
                  :key="`pending-${item.id}`"
                  :data-row-id="item.id"
                  class="clickable-row"
                  style="cursor: pointer;"
                >
                <td width="7%" @click.stop>
                    <button
                      v-if="!item.checkedIn"
                      class="btn btn-sm btn-outline-primary"
                      :disabled="checkInLoading[item.id]"
                      @click.stop="handleCheckIn(item)"
                    >
                      <i v-if="checkInLoading[item.id]" class="fa fa-spin fa-spinner mr-5"></i>
                      <span v-else>Check In</span>
                    </button>
                    <button
                      v-else
                      class="btn btn-sm btn-outline-warning"
                      :disabled="checkInLoading[item.id]"
                      @click.stop="handleCheckOut(item)"
                    >
                      <span v-if="checkInLoading[item.id]" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                      Check Out
                    </button>


                  </td>
                <td width="10%" class="text-center">
                    <span @click="doCopy(item.hostname)">{{ item.hostname }} <i class="ml-5 fa fa-copy text-primary"></i></span>
                  </td>
                  <td @click="expandedRows === item.id ? expandedRows = null : expandedRows = item.id" class="text-center" width="8%">
                    <span class="fw-500">{{ (item.domains && item.domains.length) || 0 }} Domain{{ (item.domains && item.domains.length) !== 1 ? 's' : '' }}</span>
                  <span v-if="item.dnsProvided === 'yes' || checkCFStatus(item)" class="ml-4"><i class="fa fa-check-circle text-success"></i></span>
                  <span v-else class="ml-4"><i class="fa fa-info-circle text-warning"></i></span>
                    <i class="fa ml-4" style="color: grey" :class="expandedRows === item.id ? 'fa-chevron-up' : 'fa-chevron-down'"></i>

                </td>
                <td class="text-center make-cursor-pointer">
                  <div class="d-flex" v-if="dnsProvider[item.id]">
                    <select class="form-control"  v-model="item.dnsProvided">
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                    <div class="ml-5">
                      <i v-if="dnsProviderLoader[item.id]" class="fa fa-spin fa-spinner text-primary"></i>
                      <i v-else @click="saveDnsProvider(item)" class="text-success fa fa-save"> </i>
                      <i @click="$set(dnsProvider, item.id, false)" class="text-danger fa fa-ban"> </i>
                    </div>

                  </div>
                  <span class="badge badge-pill badge-rounded" :class="item.dnsProvided === 'yes' || checkCFStatus(item) ? 'badge-success' : 'badge-danger'" v-else @click="!item.dnsProvided ? item.dnsProvided = checkCFStatus(item) ? 'yes' : 'no':  item.dnsProvided = item.dnsProvided;$set(dnsProvider, item.id, true)">{{item.dnsProvided ? item.dnsProvided : (checkCFStatus(item) ? 'yes' : 'no') }}</span>
                  </td>
                  <td class="text-center">
                    <span :class="getStatusClass(item.status)">{{ item.status }}</span>
                  </td>
                  <td class="text-center">
                    <a :href="`https://portal.bigscoots.com/admin/?cmd=accounts&action=edit&id=${item.serviceId}`" target="_blank">{{ item.planName.replace('WPO ', '') }}</a>
                  </td>
                  <td class="text-center">
                    <div class="d-flex justify-content-center align-items-center" v-if="preserveIpEdit[item.id]">
                      <select class="form-control" v-model="item.preserveIp">
                        <option :value="true">Yes</option>
                        <option :value="false">No</option>
                      </select>
                      <div class="ml-5">
                        <i v-if="preserveIpLoader[item.id]" class="fa fa-spin fa-spinner text-primary"></i>
                        <i
                          v-else
                          @click.stop="savePreserveIp(item)"
                          class="text-success fa fa-save"
                        ></i>
                        <i
                          @click.stop="$set(preserveIpEdit, item.id, false)"
                          class="text-danger fa fa-ban"
                        ></i>
                      </div>
                    </div>
                    <span
                      v-else
                      class="badge badge-pill badge-rounded"
                      :class="item.preserveIp ? 'badge-success' : 'badge-danger'"
                      @click.stop="lxdSettings.other.allowPreserveIpChange && (item.preserveIp = !!item.preserveIp, $set(preserveIpEdit, item.id, true))"
                    >
                      {{ item.preserveIp ? 'Yes' : 'No' }}

                    </span>
                  </td>
                  <td class="text-center"><span @click="doCopy(item.ip)">{{ item.ip }}</span> <br> <small>{{item.ipGroup}}</small></td>
                <td class="text-center">{{ item.rack }}</td>
                  <td class="text-center">{{ item.nodeName }}</td>
                  <td class="text-center">{{ item.vz && item.vz.hdd ? getVzDisk(item.vz.hdd) : '-' }}</td>
                <td class="text-center">{{ item.location }}</td>

                  <td class="text-center">
                    <span @click="doCopy(item.ip)" v-if="item.newLxdIpAfterPreserve && item.preserveIp">
                      <s >{{item.lxdIp || '-'}}</s>
                      <br> <small>{{item.ip}}</small>
                    </span>
                    <span v-else @click="doCopy(item.lxdIp)">{{item.lxdIp || '-'}}</span>
                  </td>
                  <td class="text-uppercase text-center">{{ item.lxdCluster || '-'}}</td>
                  <td class="text-center">{{ item.lxdNode || '-'}}</td>
                  <td class="text-center">{{ item.lxdDisk ? `${item.lxdDisk.disk_usage} / ${item.lxdDisk.disk}` : '-'}}</td></tr>
                <tr
                  v-if="expandedRows === item.id"
                  :key="`pending-expanded-${item.id || index}`"
                  :data-parent-id="item.id"
                  class="expanded-row"
                >
                <td colspan="16" class="p-4 bg-light">
                  <div class="d-flex">
                    <div class="make-cursor-pointer mb-10">
                      <template v-if="!addTargetHost[item.id]">
                        <button :disabled="!lxdSettings.other.allowDestinationChange" class="btn btn-default btn-sm" @click="$set(setLocation, item.id, true);" v-if="!setLocation[item.id] ">Set Destination Location</button>
                        <span v-if="!setLocation[item.id]"><br><small class="fw-600">Destination Location: <b class="text-primary">{{item.lxdCluster || 'IAD'}}</b> </small></span>
                      </template>

                      <div v-if="setLocation[item.id]" class="d-flex flex-column">
                        <div class="d-flex">
                          <div class="d-flex flex-column">
                            <label for="">Set Location</label>
                            <select v-model="item.newLxdCluster" name="" class="form-control" style="width: 200px" id="">
                              <option value="ORD">ORD</option>
                              <option value="EGV">EGV</option>
                              <option value="IAD">IAD</option>
                            </select>
                          </div>

                        </div>
                        <div class="mt-10  d-flex">
                          <button @click="saveLocation(item, index)" :disabled="setLocationLoader[item.id]" class="btn btn-primary btn-sm btn-link"><i :class="setLocationLoader[item.id] ? 'fa-spinner fa-spin' : 'fa-save'" class="fa mr-5"></i>Save</button>
                          <button @click="$set(setLocation, item.id, false)" class="btn btn-danger ml-10 btn-sm btn-link"><i  class="fa fa-ban mr-5"></i>Cancel</button>
                        </div>
                        <!--                        <small class="text-danger fw-600 mt-10" v-if="item.targetHostApiResponse && item.targetHostApiResponse.data && !item.targetHostApiResponse.data.success"><i class="fa fa-info-circle mr-2"></i>{{ item.targetHostApiResponse.data.message }}</small>-->
                      </div>
                    </div>
                    <div v-if="item.planName && (item.planName.includes('Enterprise') || item.planName.includes('Business') || item.planName.includes('Dedicated'))" class="make-cursor-pointer mb-10 ml-5">
                      <template v-if="!setLocation[item.id]">
                      <button class="btn btn-primary btn-sm" @click="$set(addTargetHost, item.id, true); item.targetHostKey = item.targetHost" title="Add/Edit Target Host" v-if="!addTargetHost[item.id] "><i :class="item.targetHost ? 'fa-pencil' : 'fa-plus'" class="fa mr-5"></i>Target Host</button>
                      <span v-if="item.targetHost && !addTargetHost[item.id]"><br><small class="fw-600">Target Host: <b class="text-primary">{{item.targetHost}}</b></small></span>

                      </template>

                      <div v-if="addTargetHost[item.id]" class="d-flex flex-column">
                        <div class="d-flex">
                          <div class="d-flex flex-column">
                            <label for="">Add Target Host</label>
                            <input   @keydown.space.prevent
                                     style="width: 200px" v-model="item.targetHostKey" type="text" class="form-control">
                          </div>

                        </div>
                        <div class="mt-10  d-flex">
                          <button @click="saveTargetHost(item, index)" :disabled="targetHostLoader[item.id]" class="btn btn-primary btn-sm btn-link"><i :class="targetHostLoader[item.id] ? 'fa-spinner fa-spin' : 'fa-save'" class="fa mr-5"></i>Save</button>
                          <button @click="$set(addTargetHost, item.id, false)" class="btn btn-danger ml-10 btn-sm btn-link"><i  class="fa fa-ban mr-5"></i>Cancel</button>
                        </div>
                        <small class="text-danger fw-600 mt-10" v-if="item.targetHostApiResponse && item.targetHostApiResponse.data && !item.targetHostApiResponse.data.success"><i class="fa fa-info-circle mr-2"></i>{{ item.targetHostApiResponse.data.message }}</small>
                      </div>
                    </div>
                    <div>
                      <button @click="loginAsUser(item)" class="ml-5 btn btn-sm btn-info"><i class="fa fa-user mr-5"></i>Login as user</button>
                      <button @click="deferMigration(item)" class="ml-5 btn btn-sm btn-warning"><i class="fa fa-pause mr-5"></i>Defer Migration</button>
                    </div>
                    </div>

                    <div v-if="item.domains && item.domains.length > 0" class="domain-list">
                      <table class="expanded-table">
                        <thead>
                        <tr>
                          <th>
                            <span class="d-inline-flex align-items-center">
                              Domain
                              <i
                                  data-toggle="tooltip"
                                  class="fa fa-copy text-primary mr-2 cursor-pointer ml-5"
                                  title="Copy all domains"
                                  @click="copyAllDomainsForItem(item)"
                                  style="font-size: 14px;"
                              ></i>
                              <i
                                  data-toggle="tooltip"
                                  class="fa fa-copy text-muted mr-2 cursor-pointer ml-5"
                                  title="Copy domains without active CF status"
                                  @click="copyDomainsWithoutCFForItem(item)"
                                  style="font-size: 14px;"
                              ></i>
                            </span>
                          </th>
                          <th>Tags</th>
                        <th>CF Status</th>
                        <th>
                          <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex flex-column align-items-center">
                              <div class="d-flex align-items-center">
                                <span class="mr-5">DNS Provider</span>
<!--                                <span-->
<!--                                    @click.stop="copyDomainsByNameserver(item, ns)"-->
<!--                                    v-for="(ns, nsIndex) in getUniqueNameservers(item)"-->
<!--                                    :key="nsIndex"-->
<!--                                    class="d-flex align-items-center mr-2 make-cursor-pointer"-->
<!--                                >-->
<!--                                    <span-->
<!--                                        class="badge badge-pill badge-rounded d-inline-flex align-items-center mb-0"-->
<!--                                        :style="{-->
<!--                                          fontSize: '12px',-->
<!--                                          fontWeight: '600',-->
<!--                                          backgroundColor: getNameserverColor(ns),-->
<!--                                          color: getTextColor(getNameserverColor(ns)),-->
<!--                                          border: `none`-->
<!--                                        }"-->
<!--                                    >-->
<!--                                      {{ ns }}-->
<!--                                      <i-->
<!--                                          class="fa fa-copy ml-2 cursor-pointer"-->
<!--                                          :title="`Copy all domains with nameserver: ${ns}`"-->
<!--                                          :style="{-->
<!--                                            fontSize: '11px',-->
<!--                                            opacity: '0.9',-->
<!--                                            color: getTextColor(getNameserverColor(ns))-->
<!--                                          }"-->
<!--                                          @mouseenter="$event.target.style.opacity = '1'"-->
<!--                                          @mouseleave="$event.target.style.opacity = '0.9'"-->
<!--                                      ></i>-->
<!--                                    </span>-->
<!--                                  </span>-->
                              </div>
                            </div>
                            <button :disabled="syncDomainLoader[item.id]" @click="syncDomains(item)" class="btn btn-default btn-sm"><i class="fa fa-spin fa-spinner mr-5" v-if="syncDomainLoader[item.id]"></i>Sync Domains</button>
                          </div>
                          </th>

                        </tr>
                        </thead>
                        <tbody>
                        <tr class=" p-2 mb-2 bg-white rounded border" v-for="(domain, domainIndex) in item.domains"
                            :key="domainIndex">
                          <td width="15%">{{domain.domain}}</td>
                          <td>
                            <span v-for="(row, index) in domain.tagCategories" :key="index" class="cursor-pointer">
                              <img v-if="row.tag.toLowerCase() === 'cloudflare'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../assets/img/cloudflare.png" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'bigscoots' && row.category.toLowerCase() === 'cfe'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/bigscoots_cf.png" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'bigscoots' && row.category.toLowerCase() === 'host'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/bigscoots.jpg" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'ezoic' && row.category.toLowerCase() === 'cache'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/ezoic_cache.png" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'ezoic' && row.category.toLowerCase() === 'ads'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/ezoic_ADS.png" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'sucuri'" :title="`${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/sucuri.png" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'squarespace'" :title="`${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/squarespace.png" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'nerdpress'" :title="`${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/nerdpress.png" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'wix'" :title="`${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/wix.png" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'shopify'" :title="`${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/shopify-tag.png" style="width: 20px !important;">
                            </span>
                          </td>
                          <td>
                            <i class="fa fa-cloud" :class="domain.cf ? 'text-success' : 'text-muted'"></i>
<!--                            <button :disabled="refreshCf[domain.id]" @click="refreshCF(domain, item)" class="btn btn-link btn-sm btn-default ml-10">-->
<!--                              <i v-if="refreshCf[domain.id]" class="fa fa-spin fa-spinner mr-10"></i>-->
<!--                              Refresh-->
<!--                            </button>-->
                        </td>
                        <td>
                            <span class="d-inline-flex align-items-center text-capitalize">
                              {{domain.dnsServer}}
                            </span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else class="text-muted">
                      No hosted domains
                    </div>
                  <div class="mt-10 d-flex">
                    <button @click="openCreateDnsTicketModal(item)" class="btn btn-primary btn-sm mr-2">
                      <i class="fa fa-ticket mr-2"></i>Create DNS Ticket
                    </button>
                    <button @click="openAddNoteModal(item)" class="btn btn-secondary btn-sm">
                      <i class="fa fa-sticky-note mr-2"></i>Add Note
                    </button>
                  </div>
                  <h6 class="mt-10">Tickets & Notes</h6>
                  <table class="table table-bordered mt-10 expanded-table">
                    <thead>
                    <tr>
                      <th>Ticket #</th>
                      <th>Status</th>
                      <th>Note</th>
                      <th class="text-center">Created By</th>
                      <th class="text-center">Created At</th>
                    </tr>

                    </thead>
                    <tbody>
                    <tr v-for="(row, stepIndex) in item.ticketAndNotes" :key="`step-${stepIndex}`">
                      <td width="30%">
                        <div v-if="row.ticketId" class="d-flex justify-content-between align-items-center">
                          <a target="_blank" :href="`https://www.bigscoots.com/portal/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${row.ticketId}`">{{row.ticketId}}</a>
                        </div>
                        <span v-else>-</span>
                      </td>
                      <td>
                        {{row.status || '-'}}
                      </td>
                      <td width="50%">
                        <div v-if="enableNoteInput[`${item.id}_${stepIndex}`]">
                          <input style="width: 300px" type="text" v-model="row.content" class="form-control">
                          <button :disabled="noteLoader[`${item.id}_${stepIndex}`]" @click="saveNoteInTable(item, stepIndex)" class="btn btn-primary btn-sm mt-10"><i class="fa fa-save"></i></button>
                          <button @click="$set(enableNoteInput, `${item.id}_${stepIndex}`, false)" class="btn btn-danger ml-5 btn-sm mt-10"><i class="fa fa-ban"></i></button>
                        </div>
                        <div v-else>
                          {{row.content}}
                          <i @click="$set(enableNoteInput, `${item.id}_${stepIndex}`, true)" class="fa fa-pencil ml-5 make-cursor-pointer text-primary"></i>
                        </div>
                      </td>
                      <td width="10%" class="text-center">
                        <img v-if="row.createdByEmail" class="rounded-circle" width="20px" height="20px" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.createdByEmail)}?s=100`" />
                      </td>
                      <td class="text-center">
                        <span v-if="row.createdAt" class="badge badge-success badge-pill badge-rounded">{{formatDate(row.createdAt)}}</span>
                      </td>
                    </tr>
                    </tbody>
                    <tbody v-if="!item.ticketAndNotes">
                    <tr>
                      <td colspan="3">
                        <div class="d-flex justify-content-center text-danger fw-600">No Tickets/Notes Exist!</div>

                      </td>
                    </tr>
                    </tbody>
                  </table>
                  </td>
                </tr>
              </template>
              <tr>
                <td colspan="16">
                  <div class="d-flex justify-content-between align-items-center">
                  <span class="fw-500 fs-16 mr-10 d-flex align-items-center">
                    Page {{ pageNumber + 1 }} of many
                    <span class="ml-30 d-flex align-items-center fw-500">rows per page
                      <div class="form-group mt-10 ml-10">
                        <select class="form-control" v-model="pageSize">
                          <option v-for="(search, index) in rowsPerPage" :selected="search.selected" :value="search.value" v-bind:key="index"> {{ search.value }}</option>
                        </select>
                      </div>
                    </span>
                  </span>
                  <span>
                    <button type="button" class="btn btn-light" :disabled="pageNumber === 0" @click="prevPage">Previous</button>
                    <button type="button" class="btn btn-light ml-10" :disabled="!hasNextPage" @click="nextPage">Next</button>
                  </span>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-if="loader">
              <tr>
              <td colspan="16" class="text-center">
                  <div class="loader"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- In Progress Tab -->
        <div 
          class="tab-pane fade" 
          :class="{ 'show active': activeTab === 'in-progress' }"
          id="in-progress" 
          role="tabpanel" 
          aria-labelledby="in-progress-tab"
        >
          <table id="in-progress-table" class="table  table-bordered" cellspacing="0" width="100%">
            <thead>
              <tr class="main-header">
              <th colspan="7" class="text-center">CONTAINER DETAILS</th>
              <th colspan="5" class="text-center">OPENVZ (SOURCE)</th>
                <th colspan="4" class="text-center">LXD (DESTINATION)</th>
              </tr>
              <tr class="sub-header">
                <th>Check In</th>
                <th class="text-center">Hostname</th>
                <th class="text-center">Domains</th>
              <th class="text-center">DNS Provided</th>
                <th class="text-center">Status</th>
                <th class="text-center">Plan</th>
                <th class="text-center">Preserve IP</th>
<!--                <th class="text-center">Actions</th>-->
                <th class="text-center">IP</th>
              <th class="text-center">Rack</th>
                <th class="text-center">Node</th>
                <th class="text-center">Disk</th>
              <th class="text-center">Location</th>
                <th class="text-center">IP</th>
                <th class="text-center">Cluster</th>
                <th class="text-center">Node</th>
                <th class="text-center">Disk</th>
              </tr>
            </thead>
            <tbody v-show="!loader">
              <template v-for="(item, index) in modifiedProgress">
                <tr 
                  :key="`inprogress-${item.id}`"
                  class="clickable-row"
                  style="cursor: pointer;"
                >
                  <td width="7%" @click.stop>
                    <button 
                      v-if="!item.checkedIn"
                      class="btn btn-sm btn-outline-primary" 
                      :disabled="checkInLoading[item.id]"
                      @click.stop="handleCheckIn(item)"
                    >
                      <span v-if="checkInLoading[item.id]" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                      Check In
                    </button>
                    <span v-else class="badge badge-pill badge-rounded badge-default">
                      <div class="d-flex align-items-center">
                        <img class="rounded-circle" width="20px" height="20px" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(item.checkedInByEmail)}?s=100`" />
                        <span class="ml-3">{{item.checkedInBy.split(' ')[0]}}</span>
                        <i v-if="!checkInLoading[item.id]" @click.stop="handleCheckOut(item)" class="fs-12 ml-3 fa fa-times-circle text-danger" title="Checkout" data-toggle="tooltip"></i>
                        <i v-if="checkInLoading[item.id]" class="ml-3 fa fa-spin fa-spinner text-primary" data-toggle="tooltip"></i>
                      </div>

                    </span>
                  </td>
                  <td class="text-center">
                    <span @click="doCopy(item.hostname)">{{ item.hostname }} <i
                        class="ml-5 fa fa-copy text-primary"></i></span>
                  </td>
                  <td @click="expandedRows === item.id ? expandedRows = null : expandedRows = item.id" class="text-center">
                    <span class="fw-500">{{ (item.domains && item.domains.length) || 0 }} Domain{{ (item.domains && item.domains.length) !== 1 ? 's' : '' }}</span>
                  <span v-if="item.dnsProvided === 'yes' || checkCFStatus(item)" class="ml-4"><i class="fa fa-check-circle text-success"></i></span>
                  <span v-else class="ml-4"><i class="fa fa-info-circle text-warning"></i></span>
                    <i class="fa ml-4" style="color: grey" :class="expandedRows === item.id ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  </td>
                <td class="text-center make-cursor-pointer">
                  <div class="d-flex" v-if="dnsProvider[item.id]">
                    <select class="form-control"  v-model="item.dnsProvided">
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                    <div class="ml-5">
                      <i v-if="dnsProviderLoader[item.id]" class="fa fa-spin fa-spinner text-primary"></i>
                      <i v-else @click="saveDnsProvider(item)" class="text-success fa fa-save"> </i>
                      <i @click="$set(dnsProvider, item.id, false)" class="text-danger fa fa-ban"> </i>
                    </div>

                  </div>
                  <span class="badge badge-pill badge-rounded" :class="(item.dnsProvided ? item.dnsProvided === 'yes' : checkCFStatus(item))  ? 'badge-success' : 'badge-danger'" v-else @click="!item.dnsProvided ? item.dnsProvided = checkCFStatus(item) ? 'yes' : 'no':  item.dnsProvided = item.dnsProvided;$set(dnsProvider, item.id, true)">{{item.dnsProvided ? item.dnsProvided : (checkCFStatus(item) ? 'yes' : 'no') }}</span>
                  </td>
                  <td class="text-center">
                  <span>{{getCurrentStep(item).name}} <i class="fa ml-2" :class="getCurrentStep(item).status === 'running' ? 'fa-spin fa-spinner text-primary' : (getCurrentStep(item).status === 'fail' ? 'fa-times-circle text-danger' : 'fa-info-circle text-warning')"></i></span>
                  </td>
                  <td class="text-center">
                    <a :href="`https://portal.bigscoots.com/admin/?cmd=accounts&action=edit&id=${item.serviceId}`" target="_blank">{{ item.planName.replace('WPO ', '') }}</a>
                  </td>
                  <td class="text-center">
                    <div class="d-flex justify-content-center align-items-center" v-if="preserveIpEdit[item.id]">
                      <select class="form-control" v-model="item.preserveIp">
                        <option :value="true">Yes</option>
                        <option :value="false">No</option>
                      </select>
                      <div class="ml-5">
                        <i v-if="preserveIpLoader[item.id]" class="fa fa-spin fa-spinner text-primary"></i>
                        <i
                          v-else
                          @click.stop="savePreserveIp(item)"
                          class="text-success fa fa-save"
                        ></i>
                        <i
                          @click.stop="$set(preserveIpEdit, item.id, false)"
                          class="text-danger fa fa-ban"
                        ></i>
                      </div>
                    </div>
                    <span
                      v-else
                      class="badge badge-pill badge-rounded"
                      :class="item.preserveIp ? 'badge-success' : 'badge-danger'"
                      @click.stop="lxdSettings.other.allowPreserveIpChange && (item.preserveIp = !!item.preserveIp, $set(preserveIpEdit, item.id, true))"
                    >
                      {{ item.preserveIp ? 'Yes' : 'No' }}
                    </span>
                  </td>
                  <td class="text-center"><span @click="doCopy(item.ip)">{{ item.ip }}</span>  <br><small>{{item.ipGroup}}</small></td>
                <td class="text-center">{{ item.rack }}</td>
                  <td class="text-center">{{ item.nodeName }}</td>
                  <td class="text-center">{{ item.vz && item.vz.hdd ? getVzDisk(item.vz.hdd) : '-' }}</td>
                <td class="text-center">{{ item.location }}</td>
                  <td class="text-center">
                    <span @click="doCopy(item.ip)" v-if="item.newLxdIpAfterPreserve && item.preserveIp">
                      <s >{{item.lxdIp || '-'}}</s>
                      <br> <small>{{item.ip}}</small>
                    </span>
                    <span v-else @click="doCopy(item.lxdIp)">{{item.lxdIp || '-'}}</span>
                  </td>
                  <td class="text-uppercase text-center">{{ item.lxdCluster || '-'}}</td>
                  <td class="text-center">{{ item.lxdNode || '-'}}</td>
                  <td class="text-center">{{ item.lxdDisk ? `${item.lxdDisk.disk_usage} / ${item.lxdDisk.disk}` : '-'}}</td>
                </tr>
                <tr 
                  v-if="expandedRows === item.id"
                  :key="`inprogress-expanded-${item.id || index}`"
                  class="expanded-row"
                >

                <td colspan="16" class="p-4 bg-light">
                  <div class="d-flex">
                    <div class="make-cursor-pointer mb-10 ">
                      <template v-if="!addTargetHost[item.id]">
                        <button :disabled="!lxdSettings.other.allowDestinationChange" class="btn btn-default btn-sm" @click="$set(setLocation, item.id, true);" v-if="!setLocation[item.id] ">Set Destination Location</button>
                        <span v-if="!setLocation[item.id]"><br><small class="fw-600">Destination Location: <b class="text-primary text-uppercase">{{item.lxdCluster || 'IAD'}}</b> </small></span>
                      </template>

                      <div v-if="setLocation[item.id]" class="d-flex flex-column">
                        <div class="d-flex">
                          <div class="d-flex flex-column">
                            <label for="">Set Location</label>
                            <select v-model="item.newLxdCluster" name="" class="form-control" style="width: 200px" id="">
                              <option value="ORD">ORD</option>
                              <option value="EGV">EGV</option>
                              <option value="IAD">IAD</option>
                            </select>
                          </div>

                        </div>
                        <div class="mt-10  d-flex">
                          <button @click="saveLocation(item, index)" :disabled="setLocationLoader[item.id]" class="btn btn-primary btn-sm btn-link"><i :class="setLocationLoader[item.id] ? 'fa-spinner fa-spin' : 'fa-save'" class="fa mr-5"></i>Save</button>
                          <button @click="$set(setLocation, item.id, false)" class="btn btn-danger ml-10 btn-sm btn-link"><i  class="fa fa-ban mr-5"></i>Cancel</button>
                        </div>
<!--                        <small class="text-danger fw-600 mt-10" v-if="item.targetHostApiResponse && item.targetHostApiResponse.data && !item.targetHostApiResponse.data.success"><i class="fa fa-info-circle mr-2"></i>{{ item.targetHostApiResponse.data.message }}</small>-->
                      </div>
                    </div>
                    <div v-if="item.planName && (item.planName.includes('Enterprise') || item.planName.includes('Business') || item.planName.includes('Dedicated'))" class="make-cursor-pointer mb-10 ml-5">
                      <template v-if="!setLocation[item.id]">
                      <button class="btn btn-primary btn-sm" @click="$set(addTargetHost, item.id, true); item.targetHostKey = item.targetHost" title="Add/Edit Target Host" v-if="!addTargetHost[item.id] "><i :class="!item.targetHost ? 'fa-plus' : 'fa-pencil'" class="fa mr-5"></i>Target Host</button>
                        <span v-if="item.targetHost && !addTargetHost[item.id]"><br><small class="fw-600">Target Host: <b class="text-primary">{{item.targetHost}}</b> <i @click="item.targetHostKey = ''; saveTargetHost(item, )" :class="{'fa-spin fa-spinner': targetHostLoader[item.id]}" class=" ml-5 fa fa-times-circle text-danger"></i></small></span>

                      </template>

                      <div v-if="addTargetHost[item.id]" class="d-flex flex-column">
                        <div class="d-flex">
                          <div class="d-flex flex-column">
                            <label for="">Add Target Host</label>
                            <input   @keydown.space.prevent
                                     style="width: 200px" v-model="item.targetHostKey" type="text" class="form-control">
                          </div>

                        </div>
                        <div class="mt-10  d-flex">
                          <button @click="saveTargetHost(item, index)" :disabled="targetHostLoader[item.id]" class="btn btn-primary btn-sm btn-link"><i :class="targetHostLoader[item.id] ? 'fa-spinner fa-spin' : 'fa-save'" class="fa mr-5"></i>Save</button>
                          <button @click="$set(addTargetHost, item.id, false)" class="btn btn-danger ml-10 btn-sm btn-link"><i  class="fa fa-ban mr-5"></i>Cancel</button>
                        </div>
                        <small class="text-danger fw-600 mt-10" v-if="item.targetHostApiResponse && item.targetHostApiResponse.data && !item.targetHostApiResponse.data.success"><i class="fa fa-info-circle mr-2"></i>{{ item.targetHostApiResponse.data.message }}</small>
                      </div>
                    </div>
                    <div>
                      <button @click="loginAsUser(item)" class="ml-5 btn btn-sm btn-info"><i class="fa fa-user mr-5"></i>Login as user</button>
                      <button @click="deferMigration(item)" class="ml-5 btn btn-sm btn-warning"><i class="fa fa-pause mr-5"></i>Defer Migration</button>
                    </div>
                  </div>

                    <div class="domain-list">
                      <table class="expanded-table table">
                        <thead>
                        <tr>
                          <th>
                            <span class="d-inline-flex align-items-center">
                              Domain
                              <i
                                  class="fa fa-copy text-primary mr-2 cursor-pointer ml-5"
                                  title="Copy all domains"
                                  @click="copyAllDomainsForItem(item)"
                                  style="font-size: 14px;"
                              ></i>
                              <i
                                  class="fa fa-copy text-muted mr-2 cursor-pointer ml-5"
                                  title="Copy domains without active CF status"
                                  @click="copyDomainsWithoutCFForItem(item)"
                                  style="font-size: 14px;"
                              ></i>
                            </span>
                          </th>
                          <th>Tags</th>
                          <th>CF Status</th>
                        <th>BS CF Ent</th>
                        <th>
                          <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex flex-column align-items-center">
                              <div class="d-flex align-items-center">
                                <span class="mr-5">DNS Provider</span>
<!--                                <span-->
<!--                                    @click.stop="copyDomainsByNameserver(item, ns)"-->
<!--                                    v-for="(ns, nsIndex) in getUniqueNameservers(item)"-->
<!--                                    :key="nsIndex"-->
<!--                                    class="d-flex align-items-center mr-2 make-cursor-pointer"-->
<!--                                >-->
<!--                                    <span-->
<!--                                        class="badge badge-pill badge-rounded d-inline-flex align-items-center mb-0"-->
<!--                                        :style="{-->
<!--                                          fontSize: '12px',-->
<!--                                          fontWeight: '600',-->
<!--                                          backgroundColor: getNameserverColor(ns),-->
<!--                                          color: getTextColor(getNameserverColor(ns)),-->
<!--                                          border: `none`-->
<!--                                        }"-->
<!--                                    >-->
<!--                                      {{ ns }}-->
<!--                                      <i-->
<!--                                          class="fa fa-copy ml-2 cursor-pointer"-->
<!--                                          :title="`Copy all domains with nameserver: ${ns}`"-->
<!--                                          :style="{-->
<!--                                            fontSize: '11px',-->
<!--                                            opacity: '0.9',-->
<!--                                            color: getTextColor(getNameserverColor(ns))-->
<!--                                          }"-->
<!--                                          @mouseenter="$event.target.style.opacity = '1'"-->
<!--                                          @mouseleave="$event.target.style.opacity = '0.9'"-->
<!--                                      ></i>-->
<!--                                    </span>-->
<!--                                  </span>-->
                              </div>
                            </div>
                            <button :disabled="syncDomainLoader[item.id]" @click="syncDomains(item)" class="btn btn-default btn-sm"><i class="fa fa-spin fa-spinner mr-5" v-if="syncDomainLoader[item.id]"></i>Sync Domains</button>
                          </div>
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class=" p-2 mb-2 bg-white rounded border" v-for="(domain, domainIndex) in item.domains"
                            :key="domainIndex">
                        <td width="25%" class="make-cursor-pointer">
                          <span>{{ domain.domain }}</span>
                        </td>
                          <td>
                            <div class="d-flex justify-content-between">
                              <span>
                               <span v-for="(row, index) in domain.tagCategories" :key="index" class="cursor-pointer">
                              <img v-if="row.tag.toLowerCase() === 'cloudflare'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../assets/img/cloudflare.png" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'bigscoots' && row.category.toLowerCase() === 'cfe'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/bigscoots_cf.png"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'bigscoots' && row.category.toLowerCase() === 'host'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/bigscoots.jpg"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'ezoic' && row.category.toLowerCase() === 'cache'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/ezoic_cache.png"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'ezoic' && row.category.toLowerCase() === 'ads'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/ezoic_ADS.png"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'sucuri'" :title="`${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/sucuri.png" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'squarespace'" :title="`${row.tag.toUpperCase()}`"
                                   alt=""
                                   class="" src="../../../../src/assets/img/squarespace.png"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'nerdpress'" :title="`${row.tag.toUpperCase()}`"
                                   alt=""
                                   class="" src="../../../../src/assets/img/nerdpress.png"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'wix'" :title="`${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/wix.png" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'shopify'" :title="`${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/shopify-tag.png"
                                   style="width: 20px !important;">
                            </span>
                              </span>
<!--                              <button class="btn btn-link btn-sm btn-default" :class="domain.tagCategories.length > 0 ? 'ml-10' : ''">Refresh</button>-->
                            </div>

                          </td>
                          <td >
                            <i class="fa fa-cloud" :class="domain.cf ? 'text-success' : 'text-muted'"></i>
<!--                            <button :disabled="refreshCf[domain.id]" @click="refreshCF(domain, item)" class="btn btn-link btn-sm btn-default ml-10">-->
<!--                              <i v-if="refreshCf[domain.id]" class="fa fa-spin fa-spinner mr-10"></i>-->
<!--                              Refresh-->
<!--                            </button>-->
                          </td>
                        <td width="25%" class="make-cursor-pointer">
                          <div class="d-flex flex-column">
                            <div class="d-flex align-items-center">
                              <span class="mr-10" :class="domain.cfEnt ? 'text-success' : ''"><i class="fa " :class="domain.cfEnt ? 'fa-check-circle' : ''"></i>{{!domain.cfEnt ? '-' : ''}}</span>
                              <template v-if="domain.cfEnt && !updateIp[domain.id]" class="d-flex align-items-center">
                                <span  class="mr-10 badge bg-light text-dark border mb-0">
                                  CF Ent IP: <strong>{{ domain.cfEntIp || 'N/A' }}</strong>
                                </span>
                                <i @click="$set(updateIp, domain.id, true)" class="fa fa-pencil text-primary mr-10"></i>
                                <i @click="getIp(item, domain)" :class="updateIpLoader[domain.id] ? 'fa-spin fa-spinner' : 'fa-refresh'" class="fa fa-refresh text-info"></i>
                              </template>
                              <div v-if="updateIp[domain.id]" class="d-flex">
                                <input @keydown.space.prevent v-model="domain.cfEntIp" type="text" class="form-control">
                                <span class="ml-5">
                                  <i @click="updateIP(item, domain)" :class="updateIpLoader[domain.id] ? 'fa-spin fa-spinner' : 'fa-save'" class="fa text-primary"></i>
                                  <i @click="$set(updateIp, domain.id, false)" class="fa fa-ban text-danger"></i>
                                </span>
                              </div>
                            </div>
                            <small v-if="domain.cfEntResp && !domain.cfEntResp.success" class="text-danger">Error: {{domain.cfEntResp}}</small>
                          </div>
                        </td>
                        <td>
                            <span class="d-inline-flex align-items-center text-capitalize">
                              {{domain.dnsServer}}
                            </span>
                        </td>
                        </tr>
                        <tr v-if=" !item.domains || item.domains.length === 0">
                          <td colspan="5" class="text-center text-danger fw-600">
                            No hosted domains

                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="mt-3 d-flex">
                      <button @click="openCreateDnsTicketModal(item)" class="btn btn-primary btn-sm mr-2">
                        <i class="fa fa-ticket mr-2"></i>Create DNS Ticket
                      </button>
                      <button @click="openAddNoteModal(item)" class="btn btn-secondary btn-sm">
                        <i class="fa fa-sticky-note mr-2"></i>Add Note
                      </button>
                    </div>
                    <h6 class="mt-10">Tickets & Notes</h6>
                    <table class="table table-bordered mt-10 expanded-table">
                      <thead>
                      <tr>
                        <th>Ticket #</th>
                        <th>Status</th>
                        <th>Note</th>
                        <th class="text-center">Created By</th>
                        <th class="text-center">Created At</th>
                      </tr>

                      </thead>
                      <tbody>
                      <tr v-for="(row, stepIndex) in item.ticketAndNotes" :key="`step-${stepIndex}`">
                        <td width="30%">
                          <div v-if="row.ticketId" class="d-flex justify-content-between align-items-center">
                            <a target="_blank" :href="`https://www.bigscoots.com/portal/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${row.ticketId}`">{{row.ticketId}}</a>
                          </div>
                          <span v-else>-</span>
                        </td>
                        <td>
                          {{row.status || '-'}}
                        </td>
                        <td width="50%">
                        <div v-if="enableNoteInput[`${item.id}_${stepIndex}`]">
                            <input style="width: 300px" type="text" v-model="row.content" class="form-control">
                          <button :disabled="noteLoader[`${item.id}_${stepIndex}`]" @click="saveNoteInTable(item, stepIndex)" class="btn btn-primary btn-sm mt-10"><i class="fa fa-save"></i></button>
                          <button @click="$set(enableNoteInput, `${item.id}_${stepIndex}`, false)" class="btn btn-danger ml-5 btn-sm mt-10"><i class="fa fa-ban"></i></button>
                          </div>
                          <div v-else>
                            {{row.content}}
                          <i @click="$set(enableNoteInput, `${item.id}_${stepIndex}`, true)" class="fa fa-pencil ml-5 make-cursor-pointer text-primary"></i>
                          </div>
                        </td>
                        <td width="10%" class="text-center">
                          <img v-if="row.createdByEmail" class="rounded-circle" width="20px" height="20px" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.createdByEmail)}?s=100`" />
                        </td>
                        <td class="text-center">
                          <span v-if="row.createdAt" class="badge badge-success badge-pill badge-rounded">{{formatDate(row.createdAt)}}</span>
                        </td>
                      </tr>
                      </tbody>
                      <tbody v-if="!item.ticketAndNotes">
                      <tr>
                        <td colspan="3">
                          <div class="d-flex justify-content-center text-danger fw-600">No Tickets/Notes Exist!</div>

                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <h6 class="mt-10">Steps</h6>
                    <table class="table table-bordered mt-10 expanded-table">
                      <thead>
                      <tr>
                        <th>Name</th>
                        <th class="text-center">Status</th>
                        <th class="text-center">Start</th>
                        <th class="text-center">End</th>
                        <th>Action</th>
                      </tr>

                      </thead>
                      <tbody>
                      <tr v-for="(row, stepIndex) in item.steps" :key="`step-${stepIndex}`">
                        <td width="40%">
                          <div class="d-flex justify-content-between align-items-center">
                            <span>{{row.name}}
                              <span v-if="row.name === 'Create LXD VM' && item.targetHost"><br><small>Target Host: <b>{{item.targetHost}}</b></small></span>
                            </span>
                          <div>
                            <button class="btn btn-sm btn-link btn-warning mr-5" v-if="stepName.includes(row.name) || secretEmails.includes(user.email)" @click="resetStep(item, row, stepIndex)">Reset</button>
                            <button class="btn btn-sm btn-link btn-success" v-if="stepName.includes(row.name) || secretEmails.includes(user.email)" @click="completeManually(item, row)">Complete</button>

                          </div>
                          </div>
                        </td>
                        <td class="text-center">
                          <i title="Complete" data-toggle="tooltip" class="fa fa-check-circle text-success" v-if="row.status === 'complete'"></i>
                          <i title="Failed" data-toggle="tooltip" class="fa fa-times-circle text-danger" v-else-if="row.status === 'fail'"></i>
                          <i title="Running" data-toggle="tooltip" class="fa fa-spin fa-spinner text-primary" v-else-if="row.status === 'running'"></i>
                          <i title="Pending" data-toggle="tooltip" class="fa fa-info-circle text-warning" v-else-if="row.status === 'pending'"></i>
                        </td>
                        <td class="text-center">
                          <span v-if="row.start" class="badge badge-pill badge-success">{{formatDate(row.start)}}</span>
                        </td>
                        <td class="text-center">
                          <span v-if="row.end" class="badge badge-pill badge-danger">{{formatDate(row.end)}}</span>
                        </td>
                        <td width="50%">
                          <div class="d-flex">
                            <div class="d-flex " v-if="row.status === 'complete' || (row.status === 'fail')">
                              <div class="d-flex flex-column">
                                <div class="json-container mb-10" v-if="seeResponse === `${item.id}_${stepIndex}`">{{row.apiResponse}}</div>
                                <a href="javascript:void(0)" @click="seeResponse === `${item.id}_${stepIndex}` ? seeResponse = null: seeResponse = `${item.id}_${stepIndex}`">{{ seeResponse === `${item.id}_${stepIndex}` ? "Hide" : "View" }}</a>
                              </div>
                              <a @click.stop="(row.name === 'Create LXD VM' && isCreateLxdVmRunningOnOtherItem(item)) ? null : handleAction(item, index, row.name)" class="ml-10 text-success" href="javascript:void(0)" :class="{ 'disabled opacity-50': row.name === 'Create LXD VM' && isCreateLxdVmRunningOnOtherItem(item) }" :style="(row.name === 'Create LXD VM' && isCreateLxdVmRunningOnOtherItem(item)) ? 'pointer-events: none;' : ''">Redo</a>
                              <a v-if="row.name === 'Suspend VZ'" href="javascript:void(0)" @click.stop="handleAction(item, index, row.name, row.name === 'Suspend VZ')" class="ml-10 text-danger">
                                {{ row.name === 'Suspend VZ' ? 'Resolve forcefully' : 'Retry' }}
                              </a>
                            </div>
                            <div v-else-if="row.status === 'fail'">
                              <button :disabled="action === row.name && selectedIndex === index" @click.stop="handleAction(item, index, row.name, row.name === 'Suspend VZ')" class="btn btn-sm btn-danger">
                              {{ row.name === 'Suspend VZ' ? 'Resolve forcefully' : 'Retry' }}
                            </button>

                            </div>
                            <div v-else-if="row.status === 'pending'">
                              <div v-if="row.name === 'Update Disk'">
                                <div class="d-flex align-items-center" v-if="updateDiskStep[`${item.id}_${stepIndex}`]">
                                  <span v-if="item.fetchingDisk" class="mr-5"><i class="fa fa-spin fa-spinner"></i></span>
                                  <input v-else min="0" type="number" v-model="item.updatedDisk" class="form-control mr-5">
                                  <button :disabled="action === row.name && selectedIndex === index || isStepDisabled(stepIndex, item)" @click.stop="handleAction(item, index, row.name)" class="btn btn-sm btn-link btn-default btn-outline-default ml-5"><i class="fa fa-save"></i></button>
                                  <button :disabled="action === row.name && selectedIndex === index || isStepDisabled(stepIndex, item)" @click.stop="$set(updateDiskStep, `${item.id}_${stepIndex}`, false)" class="btn btn-sm btn-link btn-danger btn-outline-danger ml-5"><i class="fa fa-ban"></i></button>
                                </div>
                                <template v-else >
                                  <button :disabled="action === row.name && selectedIndex === index || isStepDisabled(stepIndex, item)" @click.stop="openUpdateDisk(item, stepIndex)" class="btn btn-sm btn-primary">Update Disk</button>
                                  <button :disabled="action === row.name && selectedIndex === index || isStepDisabled(stepIndex, item)" @click.stop="handleAction(item, index, row.name, true)" class="btn btn-sm btn-danger ml-5">Resolve Forcefully</button>

                                </template>
                              </div>
                              <div v-else-if="row.name === 'Ensure old IP is accessible on new server'" class="d-flex align-items-center">
                                <div class="d-flex align-items-center" v-if="ensureOldIpEdit[`${item.id}_${stepIndex}`]">
                                  <select class="form-control" v-model="item.ensureOldIpAccessible" style="width: auto; min-width: 80px;">
                                    <option>Select</option>
                                    <option value="yes">Yes</option>
                                    <option value="no">No</option>
                                  </select>
                                  <div class="ml-5 flex-column d-flex">
                                    <i v-if="ensureOldIpLoader[`${item.id}_${stepIndex}`]" class="fa fa-spin fa-spinner text-primary mr-5"></i>
                                    <i v-else @click.stop="handleAction(item, stepIndex, row.name)" class="text-success fa fa-save mr-5 make-cursor-pointer"></i>
                                    <i @click.stop="item.ensureOldIpAccessible = 'no';$set(ensureOldIpEdit, `${item.id}_${stepIndex}`, false)" class="text-danger fa fa-ban make-cursor-pointer mt-5"></i>
                                  </div>
                                </div>
                                <template v-else>
                                  <button
                                      :disabled="action === row.name && selectedIndex === index || isStepDisabled(stepIndex, item)"
                                      class="btn btn-sm btn-success make-cursor-pointer"
                                      @click.stop="item.ensureOldIpAccessible = 'yes' ;handleAction(item, stepIndex, row.name)"
                                  >
                                    Looks Good
                                  </button>
                                </template>
                              </div>
                              <span v-if="row.name === 'Check if new server is ready'"
                                v-tippy-check-server
                                style="cursor:help; display:inline-flex; align-items:center; gap:6px; color:#f0a500;">
                                <i class="fa fa-spin fa-spinner"></i>
                              </span>
                              <button v-else-if="row.name !== 'Update Disk' && row.name !== 'Ensure old IP is accessible on new server'" :disabled="action === row.name && selectedIndex === index || isStepDisabled(stepIndex, item) || (row.name === 'Create LXD VM' && isCreateLxdVmRunningOnOtherItem(item)) || (row.name === 'Create LXD VM' && checkLxdSettings(item))" @click.stop="handleAction(item, index, row.name, false, true)" class="btn btn-sm btn-primary">{{getStartText(row)}}</button>
                              <button v-if="row.name === 'Check if new server is ready'" :disabled="checkingServer === item.id || isStepDisabled(stepIndex, item)" @click.stop="checkServerForcefully(item)" class="btn btn-sm btn-warning ml-5">
                                <i :class="checkingServer === item.id ? 'fa fa-spin fa-spinner' : 'fa fa-server'"></i>
                                {{ checkingServer === item.id ? 'Checking…' : 'Check Server Forcefully' }}
                              </button>
<!--                              <button v-if="row.name === 'Start Migration' && (user.email === 'khan@bigscoots.com' || user.email === 'justin@bigscoots.com' || user.email === 'sara@bigscoots.com')" :disabled="action === row.name && selectedIndex === index || isStepDisabled(stepIndex, item)" @click.stop="handleAction(item, index, row.name, false, true)" class="btn btn-sm btn-warning ml-5">Start Migration With New Script</button>-->
                              <i :id="`createVM${stepIndex}`" @mouseover="getTooltip(stepIndex, true, `We’ve temporarily paused migrations to ${item.lxdCluster ? item.lxdCluster.toUpperCase() : 'IAD'}.`)" @mouseleave="getTooltip(stepIndex, false, '')" class="fa fa-info-circle ml-10 make-cursor-pointer text-danger" v-if="row.name === 'Create LXD VM' && checkLxdSettings(item)"></i>
                              <i :id="`createVM${stepIndex}`" @mouseover="getTooltip(stepIndex, true, 'LXD VM creation is in progress for a different service. Please wait for the current process to complete before starting a new one.')" @mouseleave="getTooltip(stepIndex, false)" class="fa fa-info-circle ml-10 make-cursor-pointer text-danger"  v-else-if  ="row.name === 'Create LXD VM' && isCreateLxdVmRunningOnOtherItem(item)"></i>

                            </div>
                            <div v-else class="d-flex align-items-center">
                              <i class="fa fa-spin fa-spinner "></i>
                              <button v-if="row.name === 'Fetch Service Details' || row.name === 'Update Disk' || row.name === 'Update IP' || row.name === 'Create LXD VM' || row.name === 'Sync FTP & SSH'" @click.stop="handleAction(item, index, row.name)" class="btn btn-link btn-danger btn-sm ml-5">Retry</button>
                              <a @click="alertOnSlack(item)" v-if="row.name === 'Start Migration'" class="d-flex align-items-center make-cursor-pointer ml-5">
                                <i :class="{'fa-times text-danger': !item.alertForMigration, 'fa-check text-success': item.alertForMigration}" class="fa fs-20 mr-5"></i>
                                Alert me on Slack -
                                <span class="ml-5">{{ item.alertForMigration ? 'Enabled' : 'Disabled' }}</span>
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-if="loader">
              <tr>
              <td colspan="16" class="text-center">
                  <div class="loader"></div>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="filteredInProgressData.length > 0" class="row mt-2">
            <div class="col-md-12 d-flex justify-content-between align-items-center">
                    <span class="lh-3 pull-left">
                        Page {{ progress.pageNumber + 1 }} of {{ progressPageCount }}
                    </span>
              <section class="dataTables_paginate paging_full_numbers">
                <paginate
                    :clickHandler="progressGoToPage"
                    :nextText="'Next'"
                    :pageCount="progressPageCount"
                    :prevText="'Prev'"
                    containerClass="pagination"
                    next-class="page-item"
                    next-link-class="page-link"
                    page-class="page-item"
                    page-link-class="page-link"
                    prev-class="page-item"
                    prev-link-class="page-link">
                </paginate>
              </section>
            </div>
          </div>
          <div v-if="filteredInProgressData.length === 0 && !loader" class="customer-list-info">
            <div class="card-text text-center text-danger mb-3 font-weight-bold">
              No Data Exists!
            </div>
          </div>
        </div>
        
        <!-- Complete Tab -->
        <div 
          class="tab-pane fade" 
          :class="{ 'show active': activeTab === 'complete' }"
          id="complete" 
          role="tabpanel" 
          aria-labelledby="complete-tab"
        >
          <table id="complete-table" class="table  table-bordered" cellspacing="0" width="100%">
            <thead>
              <tr class="main-header">
              <th colspan="7" class="text-center">CONTAINER DETAILS</th>
              <th colspan="5" class="text-center">OPENVZ (SOURCE)</th>
                <th colspan="4" class="text-center">LXD (DESTINATION)</th>
              </tr>
              <tr class="sub-header">
                <th>Check In</th>
                <th class="text-center">Hostname</th>
                <th class="text-center">Domains</th>
              <th class="text-center">DNS Provided</th>
                <th class="text-center">Status</th>
                <th class="text-center">Plan</th>
                <th class="text-center">Preserve IP</th>
                <th class="text-center">IP</th>
              <th class="text-center">Rack</th>
                <th class="text-center">Node</th>
                <th class="text-center">Disk</th>
              <th class="text-center">Location</th>
                <th class="text-center">IP</th>
                <th class="text-center">Cluster</th>
                <th class="text-center">Node</th>
                <th class="text-center">Disk</th>
              </tr>
            </thead>
            <tbody v-show="!loader">
              <template v-for="(item, index) in modifiedComplete">
                <tr 
                  :key="`complete-${item.id || index}`"
                  class="clickable-row"
                  style="cursor: pointer;"
                >
                  <td @click.stop>
                    <span class="badge badge-pill badge-rounded badge-default">
                      <div class="d-flex align-items-center">
                        <img class="rounded-circle" width="20px" height="20px" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(item.checkedInByEmail)}?s=100`" />
                        <span class="ml-3">{{item.checkedInBy.split(' ')[0]}}</span>
                        </div>
                    </span>
                  </td>
                  <td class="text-center">
                    <span @click="doCopy(item.hostname)">{{ item.hostname }} <i class="ml-5 fa fa-copy text-primary"></i></span>

                  </td>
                  <td
                      @click="expandedRows === item.id ? expandedRows = null : expandedRows = item.id"
                      class="text-center">
                    <span class="fw-500">{{ (item.domains && item.domains.length) || 0 }} Domain{{ (item.domains && item.domains.length) !== 1 ? 's' : '' }}</span>
                    <i class="fa ml-4" style="color: grey" :class="expandedRows === item.id ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  </td>
                <td class="text-center">
                  <span class="badge badge-pill badge-rounded" :class="item.dnsProvided === 'yes' || checkCFStatus(item) ? 'badge-success' : 'badge-danger'">{{item.dnsProvided || checkCFStatus(item) ? 'yes' : 'no'}}</span>
                  </td>
                  <td class="text-center">
                    <span :class="getStatusClass(item.status)">{{ item.status }}</span>
                  </td>
                  <td class="text-center">
                    <a :href="`https://portal.bigscoots.com/admin/?cmd=accounts&action=edit&id=${item.serviceId}`" target="_blank">{{ item.planName.replace('WPO ', '') }}</a>
                  </td>
                <td class="text-center">
                  <span v-if="item.preserveIp" class="badge-pill badge badge-success">Yes</span>
                  <span v-else class="badge-pill badge badge-danger">No</span>
                </td>
                <td class="text-center"><span @click="doCopy(item.ip)">{{ item.ip }}</span> <br> <small>{{item.ipGroup}}</small></td>
                <td class="text-center">{{ item.rack }}</td>
                  <td class="text-center">{{ item.nodeName }}</td>
                  <td class="text-center">{{ item.vz && item.vz.hdd ? getVzDisk(item.vz.hdd) : '-' }}</td>
                <td class="text-center">{{ item.location }}</td>
                  <td class="text-center">
                    <span @click="doCopy(item.ip)" v-if="item.newLxdIpAfterPreserve && item.preserveIp">
                      <s >{{item.lxdIp || '-'}}</s>
                      <br> <small>{{item.ip}}</small>
                    </span>
                    <span v-else @click="doCopy(item.lxdIp)">{{item.lxdIp || '-'}}</span>
                  </td>
                  <td class="text-center text-uppercase">{{ item.lxdCluster || '-'}}</td>
                  <td class="text-center">{{ item.lxdNode || '-'}}</td>
                  <td class="text-center">{{ item.lxdDisk ? `${item.lxdDisk.disk_usage} / ${item.lxdDisk.disk}` : '-'}}</td>
                </tr>
                <tr 
                  v-if="expandedRows === item.id"
                  :key="`complete-expanded-${item.id || index}`"
                  class="expanded-row"
                >
                  <td colspan="16" class="p-4 bg-light">

                    <div v-if="item.domains && item.domains.length > 0" class="domain-list">
                      <table class="expanded-table">
                        <thead>
                        <tr>
                          <th>
                            <span class="d-inline-flex align-items-center">
                              Domain
                              <i
                                  class="fa fa-copy text-primary mr-2 cursor-pointer ml-5"
                                  title="Copy all domains"
                                  @click="copyAllDomainsForItem(item)"
                                  style="font-size: 14px;"
                              ></i>
                              <i
                                  class="fa fa-copy text-muted mr-2 cursor-pointer ml-5"
                                  title="Copy domains without active CF status"
                                  @click="copyDomainsWithoutCFForItem(item)"
                                  style="font-size: 14px;"
                              ></i>
                            </span>
                          </th>
                          <th>Tags</th>
                          <th>CF Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class=" p-2 mb-2 bg-white rounded border" v-for="(domain, domainIndex) in item.domains"
                            :key="domainIndex">
                          <td width="15%">{{ domain.domain }}</td>
                          <td>
                            <span v-for="(row, index) in domain.tagCategories" :key="index" class="cursor-pointer">
                              <img v-if="row.tag.toLowerCase() === 'cloudflare'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../assets/img/cloudflare.png" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'bigscoots' && row.category.toLowerCase() === 'cfe'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/bigscoots_cf.png"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'bigscoots' && row.category.toLowerCase() === 'host'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/bigscoots.jpg"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'ezoic' && row.category.toLowerCase() === 'cache'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/ezoic_cache.png"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'ezoic' && row.category.toLowerCase() === 'ads'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/ezoic_ADS.png"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'sucuri'" :title="`${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/sucuri.png" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'squarespace'" :title="`${row.tag.toUpperCase()}`"
                                   alt=""
                                   class="" src="../../../../src/assets/img/squarespace.png"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'nerdpress'" :title="`${row.tag.toUpperCase()}`"
                                   alt=""
                                   class="" src="../../../../src/assets/img/nerdpress.png"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'wix'" :title="`${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/wix.png" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'shopify'" :title="`${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/shopify-tag.png"
                                   style="width: 20px !important;">
                            </span>
                          </td>
                          <td>
                            <i class="fa fa-cloud" :class="domain.cf ? 'text-success' : 'text-muted'"></i>

                          </td>
                        </tr>
                        </tbody>
                      </table>
<!--                      <div class="mt-3 d-flex">-->
<!--                        <button @click="openCreateDnsTicketModal(item)" class="btn btn-primary btn-sm mr-2">-->
<!--                          <i class="fa fa-ticket mr-2"></i>Create DNS Ticket-->
<!--                        </button>-->
<!--                        <button @click="openAddNoteModal(item)" class="btn btn-secondary btn-sm">-->
<!--                          <i class="fa fa-sticky-note mr-2"></i>Add Note-->
<!--                        </button>-->
<!--                      </div>-->
                    </div>

                    <div v-else class="text-muted">
                      No hosted domains
                    </div>
                    <h6 class="mt-10">Tickets & Notes</h6>
                    <table class="table table-bordered mt-10 expanded-table">
                      <thead>
                      <tr>
                        <th>Ticket #</th>
                        <th>Status</th>
                        <th>Note</th>
                        <th class="text-center">Created By</th>
                        <th class="text-center">Created At</th>
                      </tr>

                      </thead>
                      <tbody>
                      <tr v-for="(row, stepIndex) in item.ticketAndNotes" :key="`step-${stepIndex}`">
                        <td width="30%">
                          <div v-if="row.ticketId" class="d-flex justify-content-between align-items-center">
                            <a target="_blank" :href="`https://www.bigscoots.com/portal/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${row.ticketId}`">{{row.ticketId}}</a>
                          </div>
                          <span v-else>-</span>
                        </td>
                        <td>
                          {{row.status || '-'}}
                        </td>
                        <td>
                        <div v-if="enableNoteInput[`${item.id}_${stepIndex}`]">
                            <input style="width: 300px" type="text" v-model="row.content" class="form-control">
                          <button :disabled="noteLoader[`${item.id}_${stepIndex}`]" @click="saveNoteInTable(item, stepIndex)" class="btn btn-primary btn-sm mt-10"><i class="fa fa-save"></i></button>
                          <button @click="$set(enableNoteInput, `${item.id}_${stepIndex}`, false)" class="btn btn-danger ml-5 btn-sm mt-10"><i class="fa fa-ban"></i></button>
                          </div>
                          <div v-else>
                            {{row.content}}
                          <i @click="$set(enableNoteInput, `${item.id}_${stepIndex}`, true)" class="fa fa-pencil ml-5 make-cursor-pointer text-primary"></i>
                          </div>
                        </td>
                        <td width="10%" class="text-center">
                          <img v-if="row.createdByEmail" class="rounded-circle" width="20px" height="20px" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.createdByEmail)}?s=100`" />
                        </td>
                        <td class="text-center">
                          <span v-if="row.createdAt" class="badge badge-success badge-pill badge-rounded">{{formatDate(row.createdAt)}}</span>
                        </td>
                      </tr>
                      </tbody>
                      <tbody v-if="!item.ticketAndNotes">
                      <tr>
                        <td colspan="3">
                          <div class="d-flex justify-content-center text-danger fw-600">No Tickets/Notes Exist!</div>

                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <h6 class="mt-10">Steps</h6>
                    <table class="table table-bordered mt-10 expanded-table">
                      <thead>
                      <tr>
                        <th>Name</th>
                        <th>Status</th>
                        <th class="text-center">Start</th>
                        <th class="text-center">End</th>
                        <th>Action</th>
                      </tr>

                      </thead>
                      <tbody>
                      <tr v-for="(row, stepIndex) in item.steps" :key="`step-${stepIndex}`">
                        <td>{{row.name}}</td>
                        <td>
                          <i title="Complete" data-toggle="tooltip" class="fa fa-check-circle text-success" v-if="row.status === 'complete'"></i>
                          <i title="Failed" data-toggle="tooltip" class="fa fa-times-circle text-danger" v-else-if="row.status === 'fail'"></i>
                          <i title="Running" data-toggle="tooltip" class="fa fa-spin fa-spinner text-primary" v-else-if="row.status === 'running'"></i>
                          <i title="Pending" data-toggle="tooltip" class="fa fa-info-circle text-warning" v-else-if="row.status === 'pending'"></i>
                        </td>
                        <td class="text-center">
                          <span v-if="row.start" class="badge badge-pill badge-success">{{formatDate(row.start)}}</span>
                        </td>
                        <td class="text-center">
                          <span v-if="row.end" class="badge badge-pill badge-danger">{{formatDate(row.end)}}</span>
                        </td>
                        <td>
                          <div class="d-flex">
                            <div class="d-flex flex-column" v-if="row.status === 'complete'">
                              <div class="json-container mb-10" v-if="seeResponse === `${item.id}_${stepIndex}`">{{row.apiResponse}}</div>
                              <a href="javascript:void(0)" @click="seeResponse === `${item.id}_${stepIndex}` ? seeResponse = null: seeResponse = `${item.id}_${stepIndex}`">{{ seeResponse === `${item.id}_${stepIndex}` ? "Hide" : "View" }}</a>
                            </div>
                            <div v-else-if="row.status === 'fail'">
                              <button :disabled="action === row.name && selectedIndex === index" @click.stop="handleAction(item, index, row.name, row.name === 'Suspend VZ')" class="btn btn-sm btn-danger">
                                {{ row.name === 'Suspend VZ' ? 'Resolve forcefully' : 'Retry' }}</button>
                            </div>
                            <div v-else>
                              <button :disabled="action === row.name && selectedIndex === index || isStepDisabled(stepIndex, item) || (row.name === 'Create LXD VM' && isCreateLxdVmRunningOnOtherItem(item))" @click.stop="handleAction(item, index, row.name)" class="btn btn-sm btn-primary" v-if="row.status === 'pending'">{{getStartText(row)}}</button>
                              <button :disabled="action === row.name && selectedIndex === index" @click.stop="handleAction(item, index, row.name)" class="btn btn-sm btn-primary" v-else-if="row.status === 'running'"><i class="fa fa-spin fa-spinner"></i></button>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-if="loader">
              <tr>
                <td colspan="16" class="text-center">
                  <div class="loader"></div>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="filteredCompleteData.length > 0" class="row mt-2">
            <div class="col-md-12 d-flex justify-content-between align-items-center">
                    <span class="lh-3 pull-left">
                        Page {{ complete.pageNumber + 1 }} of {{ completePageCount }}
                    </span>
              <section class="dataTables_paginate paging_full_numbers">
                <paginate
                    :clickHandler="completeGoToPage"
                    :nextText="'Next'"
                    :pageCount="completePageCount"
                    :prevText="'Prev'"
                    containerClass="pagination"
                    next-class="page-item"
                    next-link-class="page-link"
                    page-class="page-item"
                    page-link-class="page-link"
                    prev-class="page-item"
                    prev-link-class="page-link">
                </paginate>
              </section>
            </div>
          </div>
          <div v-if="filteredCompleteData.length === 0 && !loader" class="customer-list-info">
            <div class="card-text text-center text-danger mb-3 font-weight-bold">
              No Data Exists!
            </div>
          </div>
        </div>

        <!-- Deferred Tab -->
        <div 
          class="tab-pane fade" 
          :class="{ 'show active': activeTab === 'deferred' }"
          id="deferred" 
          role="tabpanel" 
          aria-labelledby="deferred-tab"
        >
          <table id="deferred-table" class="table  table-bordered" cellspacing="0" width="100%">
            <thead>
              <tr class="main-header">
              <th colspan="6" class="text-center">CONTAINER DETAILS</th>
              <th colspan="5" class="text-center">OPENVZ (SOURCE)</th>
                <th colspan="4" class="text-center">LXD (DESTINATION)</th>
              </tr>
              <tr>
                <th>Check In</th>
                <th class="text-center">Hostname</th>
                <th class="text-center">Domains</th>
              <th class="text-center">DNS Provided</th>
                <th class="text-center">Plan</th>
                <th class="text-center">IP</th>
              <th class="text-center">Rack</th>
                <th class="text-center">Node</th>
                <th class="text-center">Disk</th>
              <th class="text-center">Location</th>
                <th class="text-center">IP</th>
                <th class="text-center">Cluster</th>
                <th class="text-center">Node</th>
                <th class="text-center">Disk</th>
              </tr>
            </thead>
            <tbody v-show="!loader">
              <template v-for="(item, index) in modifiedDeferred">
                <tr
                    :key="`deferred-${item.id}`"
                    :data-row-id="item.id"
                    class="clickable-row"
                    style="cursor: pointer;"
                >
                  <td width="7%" @click.stop>
                    <button
                        v-if="!item.checkedIn"
                        class="btn btn-sm btn-outline-primary"
                        :disabled="checkInLoading[item.id]"
                        @click.stop="handleCheckIn(item)"
                    >
                      <i v-if="checkInLoading[item.id]" class="fa fa-spin fa-spinner mr-5"></i>
                      <span v-else>Check In</span>
                    </button>
                    <button
                        v-else
                        class="btn btn-sm btn-outline-warning"
                        :disabled="checkInLoading[item.id]"
                        @click.stop="handleCheckOut(item)"
                    >
                      <span v-if="checkInLoading[item.id]" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                      Check Out
                    </button>


                  </td>
                  <td width="10%" class="text-center">
                    <span @click="doCopy(item.hostname)">{{ item.hostname }} <i class="ml-5 fa fa-copy text-primary"></i></span>
                  </td>
                  <td @click="expandedRows === item.id ? expandedRows = null : expandedRows = item.id" class="text-center" width="8%">
                    <span class="fw-500">{{ (item.domains && item.domains.length) || 0 }} Domain{{ (item.domains && item.domains.length) !== 1 ? 's' : '' }}</span>
                    <span v-if="item.dnsProvided === 'yes' || checkCFStatus(item)" class="ml-4"><i class="fa fa-check-circle text-success"></i></span>
                    <span v-else class="ml-4"><i class="fa fa-info-circle text-warning"></i></span>
                    <i class="fa ml-4" style="color: grey" :class="expandedRows === item.id ? 'fa-chevron-up' : 'fa-chevron-down'"></i>

                  </td>
                  <td class="text-center make-cursor-pointer">
                    <div class="d-flex" v-if="dnsProvider[item.id]">
                      <select class="form-control"  v-model="item.dnsProvided">
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                      <div class="ml-5">
                        <i v-if="dnsProviderLoader[item.id]" class="fa fa-spin fa-spinner text-primary"></i>
                        <i v-else @click="saveDnsProvider(item)" class="text-success fa fa-save"> </i>
                        <i @click="$set(dnsProvider, item.id, false)" class="text-danger fa fa-ban"> </i>
                      </div>

                    </div>
                    <span class="badge badge-pill badge-rounded" :class="item.dnsProvided === 'yes' || checkCFStatus(item) ? 'badge-success' : 'badge-danger'" v-else @click="!item.dnsProvided ? item.dnsProvided = checkCFStatus(item) ? 'yes' : 'no':  item.dnsProvided = item.dnsProvided;$set(dnsProvider, item.id, true)">{{item.dnsProvided ? item.dnsProvided : (checkCFStatus(item) ? 'yes' : 'no') }}</span>
                  </td>
                  <td class="text-center">
                    <a :href="`https://portal.bigscoots.com/admin/?cmd=accounts&action=edit&id=${item.serviceId}`" target="_blank">{{ item.planName.replace('WPO ', '') }}</a>
                  </td>
                  <td class="text-center"><span @click="doCopy(item.ip)">{{ item.ip }}</span> <br> <small>{{item.ipGroup}}</small></td>
                  <td class="text-center">{{ item.rack }}</td>
                  <td class="text-center">{{ item.nodeName }}</td>
                  <td class="text-center">{{ item.vz && item.vz.hdd ? getVzDisk(item.vz.hdd) : '-' }}</td>
                  <td class="text-center">{{ item.location }}</td>

                  <td class="text-center"><span @click="doCopy(item.lxdIp)">{{ item.lxdIp || '-'}}</span></td>
                  <td class="text-uppercase text-center">{{ item.lxdCluster || '-'}}</td>
                  <td class="text-center">{{ item.lxdNode || '-'}}</td>
                  <td class="text-center">{{ item.lxdDisk ? `${item.lxdDisk.disk_usage} / ${item.lxdDisk.disk}` : '-'}}</td></tr>
                <tr
                    v-if="expandedRows === item.id"
                    :key="`deferred-expanded-${item.id || index}`"
                    class="expanded-row"
                >
                  <td colspan="15" class="p-4 bg-light">

                    <div v-if="item.domains && item.domains.length > 0" class="domain-list">
                      <table class="expanded-table">
                        <thead>
                        <tr>
                          <th>
                            <span class="d-inline-flex align-items-center">
                              Domain
                              <i
                                  class="fa fa-copy text-primary mr-2 cursor-pointer ml-5"
                                  title="Copy all domains"
                                  @click="copyAllDomainsForItem(item)"
                                  style="font-size: 14px;"
                              ></i>
                              <i
                                  class="fa fa-copy text-muted mr-2 cursor-pointer ml-5"
                                  title="Copy domains without active CF status"
                                  @click="copyDomainsWithoutCFForItem(item)"
                                  style="font-size: 14px;"
                              ></i>
                            </span>
                          </th>
                          <th>Tags</th>
                          <th>CF Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class=" p-2 mb-2 bg-white rounded border" v-for="(domain, domainIndex) in item.domains"
                            :key="domainIndex">
                          <td width="15%">{{ domain.domain }}</td>
                          <td>
                            <span v-for="(row, index) in domain.tagCategories" :key="index" class="cursor-pointer">
                              <img v-if="row.tag.toLowerCase() === 'cloudflare'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../assets/img/cloudflare.png" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'bigscoots' && row.category.toLowerCase() === 'cfe'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/bigscoots_cf.png"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'bigscoots' && row.category.toLowerCase() === 'host'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/bigscoots.jpg"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'ezoic' && row.category.toLowerCase() === 'cache'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/ezoic_cache.png"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'ezoic' && row.category.toLowerCase() === 'ads'"
                                   :title="`${row.category.toUpperCase()}: ${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/ezoic_ADS.png"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'sucuri'" :title="`${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/sucuri.png" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'squarespace'" :title="`${row.tag.toUpperCase()}`"
                                   alt=""
                                   class="" src="../../../../src/assets/img/squarespace.png"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'nerdpress'" :title="`${row.tag.toUpperCase()}`"
                                   alt=""
                                   class="" src="../../../../src/assets/img/nerdpress.png"
                                   style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'wix'" :title="`${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/wix.png" style="width: 20px !important;">
                              <img v-if="row.tag.toLowerCase() === 'shopify'" :title="`${row.tag.toUpperCase()}`" alt=""
                                   class="" src="../../../../src/assets/img/shopify-tag.png"
                                   style="width: 20px !important;">
                            </span>
                          </td>
                          <td>
                            <i class="fa fa-cloud" :class="domain.cf ? 'text-success' : 'text-muted'"></i>

                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <!--                      <div class="mt-3 d-flex">-->
                      <!--                        <button @click="openCreateDnsTicketModal(item)" class="btn btn-primary btn-sm mr-2">-->
                      <!--                          <i class="fa fa-ticket mr-2"></i>Create DNS Ticket-->
                      <!--                        </button>-->
                      <!--                        <button @click="openAddNoteModal(item)" class="btn btn-secondary btn-sm">-->
                      <!--                          <i class="fa fa-sticky-note mr-2"></i>Add Note-->
                      <!--                        </button>-->
                      <!--                      </div>-->
                    </div>

                    <div v-else class="text-muted">
                      No hosted domains
                    </div>
                    <h6 class="mt-10">Tickets & Notes</h6>
                    <div class="mt-10 d-flex">
                      <button @click="openCreateDnsTicketModal(item)" class="btn btn-primary btn-sm mr-2">
                        <i class="fa fa-ticket mr-2"></i>Create DNS Ticket
                      </button>
                      <button @click="openAddNoteModal(item)" class="btn btn-secondary btn-sm">
                        <i class="fa fa-sticky-note mr-2"></i>Add Note
                      </button>
                    </div>
                    <table class="table table-bordered mt-10 expanded-table">
                      <thead>
                      <tr>
                        <th>Ticket #</th>
                        <th>Status</th>
                        <th>Note</th>
                        <th class="text-center">Created By</th>
                        <th class="text-center">Created At</th>
                      </tr>

                      </thead>
                      <tbody>
                      <tr v-for="(row, stepIndex) in item.ticketAndNotes" :key="`step-${stepIndex}`">
                        <td width="30%">
                          <div v-if="row.ticketId" class="d-flex justify-content-between align-items-center">
                            <a target="_blank" :href="`https://www.bigscoots.com/portal/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${row.ticketId}`">{{row.ticketId}}</a>
                          </div>
                          <span v-else>-</span>
                        </td>
                        <td>
                          {{row.status || '-'}}
                        </td>
                        <td>
                          <div v-if="enableNoteInput[`${item.id}_${stepIndex}`]">
                            <input style="width: 300px" type="text" v-model="row.content" class="form-control">
                            <button :disabled="noteLoader[`${item.id}_${stepIndex}`]" @click="saveNoteInTable(item, stepIndex)" class="btn btn-primary btn-sm mt-10"><i class="fa fa-save"></i></button>
                            <button @click="$set(enableNoteInput, `${item.id}_${stepIndex}`, false)" class="btn btn-danger ml-5 btn-sm mt-10"><i class="fa fa-ban"></i></button>
                          </div>
                          <div v-else>
                            {{row.content}}
                            <i @click="$set(enableNoteInput, `${item.id}_${stepIndex}`, true)" class="fa fa-pencil ml-5 make-cursor-pointer text-primary"></i>
                          </div>
                        </td>
                        <td width="10%" class="text-center">
                          <img v-if="row.createdByEmail" class="rounded-circle" width="20px" height="20px" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.createdByEmail)}?s=100`" />
                        </td>
                        <td class="text-center">
                          <span v-if="row.createdAt" class="badge badge-success badge-pill badge-rounded">{{formatDate(row.createdAt)}}</span>
                        </td>
                      </tr>
                      </tbody>
                      <tbody v-if="!item.ticketAndNotes">
                      <tr>
                        <td colspan="3">
                          <div class="d-flex justify-content-center text-danger fw-600">No Tickets/Notes Exist!</div>

                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <h6 class="mt-10">Steps</h6>
                    <table class="table table-bordered mt-10 expanded-table">
                      <thead>
                      <tr>
                        <th>Name</th>
                        <th>Status</th>
                        <th class="text-center">Start</th>
                        <th class="text-center">End</th>
                        <th>Action</th>
                      </tr>

                      </thead>
                      <tbody>
                      <tr v-for="(row, stepIndex) in item.steps" :key="`step-${stepIndex}`">
                        <td>{{row.name}}</td>
                        <td>
                          <i title="Complete" data-toggle="tooltip" class="fa fa-check-circle text-success" v-if="row.status === 'complete'"></i>
                          <i title="Failed" data-toggle="tooltip" class="fa fa-times-circle text-danger" v-else-if="row.status === 'fail'"></i>
                          <i title="Running" data-toggle="tooltip" class="fa fa-spin fa-spinner text-primary" v-else-if="row.status === 'running'"></i>
                          <i title="Pending" data-toggle="tooltip" class="fa fa-info-circle text-warning" v-else-if="row.status === 'pending'"></i>
                        </td>
                        <td class="text-center">
                          <span v-if="row.start" class="badge badge-pill badge-success">{{formatDate(row.start)}}</span>
                        </td>
                        <td class="text-center">
                          <span v-if="row.end" class="badge badge-pill badge-danger">{{formatDate(row.end)}}</span>
                        </td>
                        <td>
                          <div class="d-flex">
                            <div class="d-flex flex-column" v-if="row.status === 'complete'">
                              <div class="json-container mb-10" v-if="seeResponse === `${item.id}_${stepIndex}`">{{row.apiResponse}}</div>
                              <a href="javascript:void(0)" @click="seeResponse === `${item.id}_${stepIndex}` ? seeResponse = null: seeResponse = `${item.id}_${stepIndex}`">{{ seeResponse === `${item.id}_${stepIndex}` ? "Hide" : "View" }}</a>
                            </div>
                            <div v-else-if="row.status === 'fail'">
                              <button :disabled="action === row.name && selectedIndex === index" @click.stop="handleAction(item, index, row.name, row.name === 'Suspend VZ')" class="btn btn-sm btn-danger">
                                {{ row.name === 'Suspend VZ' ? 'Resolve forcefully' : 'Retry' }}</button>
                            </div>
                            <div v-else>
<!--                              <button>Start Migration With New Script</button>-->
                              <button :disabled="action === row.name && selectedIndex === index || isStepDisabled(stepIndex, item) || (row.name === 'Create LXD VM' && isCreateLxdVmRunningOnOtherItem(item))" @click.stop="handleAction(item, index, row.name)" class="btn btn-sm btn-primary" v-if="row.status === 'pending'">{{getStartText(row)}}</button>
                              <button :disabled="action === row.name && selectedIndex === index" @click.stop="handleAction(item, index, row.name)" class="btn btn-sm btn-primary" v-else-if="row.status === 'running'"><i class="fa fa-spin fa-spinner"></i></button>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </template>
<!--              <tr v-if="!modifiedDeferred.length && !loader">-->
<!--                <td colspan="15" class="text-center text-danger">No data exists</td>-->
<!--              </tr>-->
            </tbody>
            <tbody v-if="loader">
              <tr>
                <td colspan="15" class="text-center">
                  <div class="loader"></div>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="filteredDeferredData.length > 0" class="row mt-2">
            <div class="col-md-12 d-flex justify-content-center">
              <section class="pagination-wrapper">
                <paginate
                    v-model="deferred.pageNumber"
                    :page-count="deferredPageCount"
                    :click-handler="function() {}"
                    :prev-text="'Previous'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'">
                </paginate>
              </section>
            </div>
          </div>
          <div v-if="filteredDeferredData.length === 0 && !loader" class="customer-list-info">
            <div class="card-text text-center text-danger mb-3 font-weight-bold">
              No Data Exists!
            </div>
          </div>
        </div>
        <!-- Settings Tab -->
        <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === 'settings' }"
            id="settings"
            role="tabpanel"
            aria-labelledby="settings-tab"
        >
          <!-- Row 1: IAD · EGV · Other -->
          <div class="row" style="align-items:stretch;">
            <div class="col-md-3 d-flex">
              <div class="card mb-3 w-100">
                <div class="card-header py-2">
                  <h6 class="mb-0">IAD</h6>
                </div>
                <div class="card-body">
                  <div class="form-group d-flex justify-content-between align-items-center">
                    <label class="mb-1">VPS Nodes </label>
                    <div class="d-flex">
                      <div class="mr-3">
                        <div v-if="!lxdLoader" class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : lxdSettings.iad.vpsNodes, 'bootstrap-switch-off bootstrap-switch-focused' : !lxdSettings.iad.vpsNodes }">
                          <div class="bootstrap-switch-container" @click="lxdSettings.iad.vpsNodes = !lxdSettings.iad.vpsNodes" >
                            <span class="bootstrap-switch-handle-on bootstrap-switch-primary">On</span>
                            <span class="bootstrap-switch-label"></span>
                            <span class="bootstrap-switch-handle-off bootstrap-switch-default">Off</span>
                          </div>
                        </div>
                        <i v-else class="fa fa-spin fa-spinner"></i>
                      </div>
                    </div>
                  </div>
                  <div class="form-group d-flex justify-content-between align-items-center">
                    <label class=" mb-1">WPO Nodes</label>
                    <div class="d-flex">
                      <div class="mr-3">
                        <div v-if="!lxdLoader" class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : lxdSettings.iad.wpoNodes, 'bootstrap-switch-off bootstrap-switch-focused' : !lxdSettings.iad.wpoNodes }">
                          <div class="bootstrap-switch-container" @click="lxdSettings.iad.wpoNodes = !lxdSettings.iad.wpoNodes">
                            <span class="bootstrap-switch-handle-on bootstrap-switch-primary">On</span>
                            <span class="bootstrap-switch-label"></span>
                            <span class="bootstrap-switch-handle-off bootstrap-switch-default">Off</span>
                          </div>
                        </div>
                        <i v-else class="fa fa-spin fa-spinner"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3 d-flex">
              <div class="card mb-3 w-100">
                <div class="card-header py-2">
                  <h6 class="mb-0">EGV</h6>
                </div>
                <div class="card-body">
                  <div class="form-group d-flex justify-content-between align-items-center">
                    <label class=" mb-1">VPS Nodes</label>
                    <div class="d-flex">
                      <div class="mr-3">
                        <div v-if="!lxdLoader" class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : lxdSettings.egv.vpsNodes, 'bootstrap-switch-off bootstrap-switch-focused' : !lxdSettings.egv.vpsNodes }">
                          <div class="bootstrap-switch-container" @click="lxdSettings.egv.vpsNodes = !lxdSettings.egv.vpsNodes" >
                            <span class="bootstrap-switch-handle-on bootstrap-switch-primary">On</span>
                            <span class="bootstrap-switch-label"></span>
                            <span class="bootstrap-switch-handle-off bootstrap-switch-default">Off</span>
                          </div>
                        </div>
                        <i v-else class="fa fa-spin fa-spinner"></i>
                      </div>
                    </div>
                  </div>
                  <div class="form-group d-flex justify-content-between align-items-center">
                    <label class=" mb-1">WPO Nodes</label>
                    <div class="d-flex">
                      <div class="mr-3">
                        <div v-if="!lxdLoader" class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : lxdSettings.egv.wpoNodes, 'bootstrap-switch-off bootstrap-switch-focused' : !lxdSettings.egv.wpoNodes }">
                          <div class="bootstrap-switch-container" @click="lxdSettings.egv.wpoNodes = !lxdSettings.egv.wpoNodes">
                            <span class="bootstrap-switch-handle-on bootstrap-switch-primary">On</span>
                            <span class="bootstrap-switch-label"></span>
                            <span class="bootstrap-switch-handle-off bootstrap-switch-default">Off</span>
                          </div>
                        </div>
                        <i v-else class="fa fa-spin fa-spinner"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 d-flex">
              <div class="card mb-3 w-100">
                <div class="card-header py-2 d-flex align-items-center" style="gap:6px;">
                  <i class="fa fa-sliders text-muted" style="font-size:13px;"></i>
                  <h6 class="mb-0">Other</h6>
                </div>
                <div class="card-body">
                  <div v-if="lxdLoader" class="text-center py-2">
                    <i class="fa fa-spin fa-spinner text-muted"></i>
                  </div>
                  <template v-else>
                    <div class="form-group d-flex justify-content-between align-items-center">
                      <label class="mb-0" style="font-size:13px;">Allow PreserveIP Change</label>
                      <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused': lxdSettings.other.allowPreserveIpChange, 'bootstrap-switch-off bootstrap-switch-focused': !lxdSettings.other.allowPreserveIpChange }">
                        <div class="bootstrap-switch-container" @click="lxdSettings.other.allowPreserveIpChange = !lxdSettings.other.allowPreserveIpChange">
                          <span class="bootstrap-switch-handle-on bootstrap-switch-primary">On</span>
                          <span class="bootstrap-switch-label"></span>
                          <span class="bootstrap-switch-handle-off bootstrap-switch-default">Off</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group d-flex justify-content-between align-items-center">
                      <label class="mb-0" style="font-size:13px;">Allow Destination Change</label>
                      <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused': lxdSettings.other.allowDestinationChange, 'bootstrap-switch-off bootstrap-switch-focused': !lxdSettings.other.allowDestinationChange }">
                        <div class="bootstrap-switch-container" @click="lxdSettings.other.allowDestinationChange = !lxdSettings.other.allowDestinationChange">
                          <span class="bootstrap-switch-handle-on bootstrap-switch-primary">On</span>
                          <span class="bootstrap-switch-label"></span>
                          <span class="bootstrap-switch-handle-off bootstrap-switch-default">Off</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group mb-0 d-flex justify-content-between align-items-center">
                      <label class="mb-0" style="font-size:13px;">Switch to New API</label>
                      <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused': lxdSettings.other.useNewApi, 'bootstrap-switch-off bootstrap-switch-focused': !lxdSettings.other.useNewApi }">
                        <div class="bootstrap-switch-container" @click="lxdSettings.other.useNewApi = !lxdSettings.other.useNewApi">
                          <span class="bootstrap-switch-handle-on bootstrap-switch-primary">On</span>
                          <span class="bootstrap-switch-label"></span>
                          <span class="bootstrap-switch-handle-off bootstrap-switch-default">Off</span>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <!-- Row 2: Racks for Teams -->
          <div class="row">
            <div class="col-md-12">
              <div class="card mb-3">
                <div class="card-header py-2 d-flex align-items-center" style="gap:6px;">
                  <i class="fa fa-server text-primary" style="font-size:13px;"></i>
                  <h6 class="mb-0">Racks for Teams</h6>
                </div>
                <div class="card-body">
                  <div v-if="lxdLoader" class="text-center py-2">
                    <i class="fa fa-spin fa-spinner text-muted"></i>
                  </div>
                  <template v-else>
                    <div class="d-flex" style="gap:16px;">
                      <!-- Morning -->
                      <div class="team-row team-row--morning flex-grow-1">
                        <div class="team-row__label">
                          <i class="fa fa-sun-o"></i>
                          <span>Morning</span>
                        </div>
                        <div class="team-row__fields">
                          <div class="team-row__field">
                            <label class="team-row__field-label">Rack</label>
                            <select v-model="lxdSettings.teams.morningRack" class="form-control form-control-sm team-row__select">
                              <option value="">— Rack —</option>
                              <option v-for="rack in availableRacks" :key="rack" :value="rack">{{ rack }}</option>
                            </select>
                          </div>
                          <div class="team-row__field team-row__field--dns">
                            <label class="team-row__field-label">DNS Provided</label>
                            <select v-model="lxdSettings.teams.morningDns" class="form-control form-control-sm team-row__select">
                              <option value="all">All</option>
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <!-- Night -->
                      <div class="team-row team-row--night flex-grow-1">
                        <div class="team-row__label">
                          <i class="fa fa-moon-o"></i>
                          <span>Night</span>
                        </div>
                        <div class="team-row__fields">
                          <div class="team-row__field">
                            <label class="team-row__field-label">Rack</label>
                            <select v-model="lxdSettings.teams.nightRack" class="form-control form-control-sm team-row__select">
                              <option value="">— Rack —</option>
                              <option v-for="rack in availableRacks" :key="rack" :value="rack">{{ rack }}</option>
                            </select>
                          </div>
                          <div class="team-row__field team-row__field--dns">
                            <label class="team-row__field-label">DNS Provided</label>
                            <select v-model="lxdSettings.teams.nightDns" class="form-control form-control-sm team-row__select">
                              <option value="all">All</option>
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 ml-20">
              <button :disabled="lxdSettingsSaving" @click="saveLxdSettings" class="btn btn-sm btn-outline-primary">Save
              <i v-if="lxdSettingsSaving" class="fa fa-spin fa-spinner ml-2"></i></button>
            </div>
          </div>
        </div>
      </div>
<!--      <div v-if="activeTab === 'pending' || activeTab === 'in-progress'" class="migration-rules ml-0 card mb-20">-->
<!--        <div class="card-body py-2 px-3">-->

<!--          <div class="d-flex align-items-center justify-content-center mb-1">-->
<!--            <span class="badge badge-info mr-2"><i class="fa fa-list"></i></span>-->
<!--            <h6 class="ml-2 text-uppercase small text-center">Migration Rules</h6>-->
<!--          </div>-->
<!--          <div class="row no-gutters small text-muted">-->
<!--            <div class="col-md-12">-->
<!--              <span class="badge badge-danger" style="text-transform: none; font-size: 11px"><i class="fa fa-info-circle mr-5"></i>Preserve IP is not supported for Source IPs from Steadfast.</span>-->
<!--            </div>-->
<!--            &lt;!&ndash; WPO Business &ndash;&gt;-->
<!--            <div class="col-md-6 pr-md-3 mb-2">-->
<!--              <div class="rules-pill mb-1">WPO Business / Mediavine Plan 3 (NOT STEADFAST)</div>-->
<!--              <small></small>-->
<!--              <ul class="mb-1 pl-3">-->
<!--                <li>-->
<!--                  <strong>DNS access available</strong> → Migrate to <strong>IAD</strong>-->
<!--                </li>-->
<!--                <li>-->
<!--                  <strong>No DNS access</strong> → Migrate to <strong>EGV</strong> with <strong>Preserve IP-->
<!--                  enabled</strong>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->

<!--            &lt;!&ndash; Other Plans &ndash;&gt;-->
<!--            <div class="col-md-6 pl-md-3">-->
<!--              <div class="rules-pill mb-1">All Other Plans (NOT STEADFAST)</div>-->
<!--              <div class="small text-muted mb-1">-->
<!--                (Starter / Pro / Journey / Mediavine 1 / Mediavine 2)-->
<!--              </div>-->
<!--              <ul class="mb-1 pl-3">-->
<!--                <li>-->
<!--                  <strong>DNS access available</strong> → Migrate to <strong>IAD</strong>-->
<!--                </li>-->
<!--                <li>-->
<!--                  <strong>No DNS access</strong> → Migrate to <strong>EGV</strong> with <strong>Preserve IP enabled</strong>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->


<!--          </div>-->
<!--        </div>-->
<!--      </div>-->


    </div>
    
    <!-- DNS Ticket Modal Component -->
    <dnsTicketModal @refreshData="refreshData" ref="dnsTicketModal" />

    <!-- Add Note Modal -->
    <div class="modal fade" id="addNoteModal" tabindex="-1" role="dialog" aria-labelledby="addNoteModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addNoteModalLabel">Add Note</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeAddNoteModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="noteContent">Note</label>
              <textarea class="form-control" id="noteContent" v-model="noteForm.content" rows="5" placeholder="Enter your note"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeAddNoteModal">Cancel</button>
            <button type="button" class="btn btn-primary" @click="saveNote" :disabled="savingNote">
              <i v-if="savingNote" class="fa fa-spin fa-spinner mr-2"></i>
              Save Note
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from '@/firebase/init'
import md5 from "crypto-js/md5";
import Paginate from 'vuejs-paginate'
import copyButtonMixin from "@/mixins/copyButtonMixin";
import multiSelect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';
import statisticsMixin from "@/mixins/statisticsMixin";
import swal from 'sweetalert2'

export default {
  name: "VzToLxd",
  directives: {
    clickOutside: {
      bind(el, binding) {
        el.__clickOutsideHandler__ = (e) => {
          if (!el.contains(e.target)) binding.value(e);
        };
        document.addEventListener('click', el.__clickOutsideHandler__);
      },
      unbind(el) {
        document.removeEventListener('click', el.__clickOutsideHandler__);
      },
    },
    tippyCheckServer: {
      inserted(el) {
        tippy(el, {
          content: 'Please allow up to 10 minutes for server to be fully ready. This step will be marked completed automatically once server is prepared. Please click "Check Server Forcefully" if you don\'t see it complete in ~10 minutes.',
          theme: 'dark',
          placement: 'top',
          maxWidth: 320,
        })
      },
      unbind(el) {
        if (el._tippy) el._tippy.destroy()
      },
    },
  },
  components: {
    Paginate,
    Multiselect: multiSelect,
    dnsTicketModal: () =>
        import(
            /* webpackChunkName: "dnsTicketModal" */ "../../../components/Admin/Tasks/dnsTicketModal.vue"
        )
  },
  mixins: [copyButtonMixin, statisticsMixin],
  data() {
    return {
      unsubscribeLxd: null,
      lxdSettings: {
        iad: {
          vpsNodes: false,
          wpoNodes: false
        },
        egv: {
          vpsNodes: false,
          wpoNodes: false
        },
        teams: {
          morningRack: '',
          nightRack: '',
          morningDns: 'all',
          nightDns: 'yes'
        },
        other: {
          allowPreserveIpChange: false,
          allowDestinationChange: false,
          useNewApi: false
        }
      },
      vpsNodesPlans: [],
      wpoNodesPlans: ['WPO Enterprise', 'WPO Business', 'WPO Dedicated', 'Mediavine Plan 3', 'Mediavine Enterprise'],
      secretEmails: ['khan@bigscoots.com', 'justin@bigscoots.com', 'prasul@bigscoots.com', 'les@bigscoots.com', 'sara@bigscoots.com'],
      stepName: ['Create LXD VM', 'Fetch Service Details', 'Suspend VZ', 'Start Migration'],
      updateIp: {},
      enableNoteInput: {},
      updateIpLoader: {},
      noteLoader: {},
      addTargetHost: {},
      setLocation: {},
      targetHostLoader: {},
      setLocationLoader: {},
      processingDomainList: [],
      pendingJobListener: null,
      steps: [
        { name: 'Create LXD VM', success: null, status: 'pending', apiResponse: {}},
        { name: 'Fetch Service Details', success: null, status: 'pending', apiResponse: {}},
        { name: 'Update Disk', success: null, status: 'pending', apiResponse: {}},
        { name: 'Check if new server is ready', success: null, status: 'pending', apiResponse: {}},
        { name: 'Capture Backup Cron', success: null, status: 'pending', apiResponse: {}},
        { name: 'Start Migration', success: null, status: 'pending', apiResponse: {}},
        { name: 'Update IP', success: null, status: 'pending', apiResponse: {}},
        { name: 'Patch Backups', success: null, status: 'pending', apiResponse: {}},
        { name: 'Suspend VZ', success: null, status: 'pending', apiResponse: {}},
        { name: 'Finish', success: null, status: 'pending', apiResponse: {}},
      ],
      preserveIpSteps: [
        { name: 'Create LXD VM', success: null, status: 'pending', apiResponse: {}},
        { name: 'Fetch Service Details', success: null, status: 'pending', apiResponse: {}},
        { name: 'Update Disk', success: null, status: 'pending', apiResponse: {}},
        { name: 'Check if new server is ready', success: null, status: 'pending', apiResponse: {}},
        { name: 'Start Migration', success: null, status: 'pending', apiResponse: {}},
        { name: 'Capture Backup Cron', success: null, status: 'pending', apiResponse: {}},
        { name: 'Shutdown VZ', success: null, status: 'pending', apiResponse: {}},
        { name: 'Suspend VZ', success: null, status: 'pending', apiResponse: {}},
        { name: 'Add OLD IP as Secondary', success: null, status: 'pending', apiResponse: {}},
        { name: 'Run ARPING', success: null, status: 'pending', apiResponse: {}},
        { name: 'Promote Secondary IP to Primary', success: null, status: 'pending', apiResponse: {}},
        { name: 'Update IP', success: null, status: 'pending', apiResponse: {}},
        { name: 'Patch Backups', success: null, status: 'pending', apiResponse: {}},
        { name: 'Sync Consul', success: null, status: 'pending', apiResponse: {}},
        { name: 'Update Hostbill Service', success: null, status: 'pending', apiResponse: {}},
        { name: 'Ensure old IP is accessible on new server', success: null, status: 'pending', apiResponse: {}},
        { name: 'Finish', success: null, status: 'pending', apiResponse: {}},
      ],
      rowsPerPageValue: 10,
      rowsPerPage: [
        {key: 10, value: 10, selected: true},
        {key: 30, value: 30, selected: false},
        {key: 50, value: 50, selected: false},
      ],
      searchBy: '',
      searchQuery: true,
      searchText: '',
      allRecords: [],
      allRecordsLoading: false,
      lxdLoader: true,
      items: [],
      loading: false,
      pageSize: 10,
      pageNumber: 0,
      currentPage: 0,
      canGoPrev: false,
      canGoNext: true,
      selectedSearch: '',
      activeTab: 'pending',
      checkinFilter: 'all',
      loader: false,
      hasNextPage: false,
      pendingListener: null,
      inProgressListener: null,
      completeListener: null,
      deferredListener: null,
      pendingData: [],
      inProgressData: [],
      deferredData: [],
      // Cursor history for UNCATEGORIZED pagination on pending tab.
      // Index N holds the startAfter cursor (createdAt) used to fetch page N.
      uncategorizedPageCursors: [null],
      priorityFilers: ['None',
        // 'R245','R250B', 'R252', 'R150B', 'UNCATEGORIZED', 'Steadfast'
      ],
      selectedPriorityFilter: '',
      selectedTeamFilter: null,
      showPlansDropdown: false,
      morningRack: '',
      nightRack: '',
      hovered: '',
      completeData: [],
      selectedIpGroup: 'all',
      selectedPlans: [],
      planOptions: [
        { label: 'Starter',        value: 'WPO Starter' },
        { label: 'Professional',   value: 'WPO Professional' },
        { label: 'Business',       value: 'WPO Business' },
        { label: 'Enterprise',     value: 'WPO Enterprise' },
        { label: 'VPS',            value: 'WPO VPS' },
        { label: 'Dedicated',      value: 'WPO Dedicated' },
        { label: 'MV Plan 1',      value: 'Mediavine Plan 1' },
        { label: 'MV Plan 2',      value: 'Mediavine Plan 2' },
        { label: 'MV Plan 3',      value: 'Mediavine Plan 3' },
        { label: 'Journey',        value: 'Journey Plan' },
      ],
      selectedNode: 'all',
      selectedRack: 'all',
      selectedStep: 'All',
      dnsTicketCreated: 'all',
      dnsProvided: 'all',
      // availableNodes: [],
      action: '',
      seeResponse: '',
      selectedIndex: -1,
      checkingServer: null,
      updateDiskStep: {},
      disk: {},
      dnsProvider: {},
      dnsProviderLoader: {},
      preserveIpEdit: {},
      preserveIpLoader: {},
      ensureOldIpEdit: {},
      ensureOldIpLoader: {},
      expandedRows: null, // Track expanded rows by item id
      checkInLoading: {}, // Track loading state for check-in/out by item id
      refreshCf: {},
      syncDomainLoader: {},
      isRenderingTable: false, // Flag to prevent conflicts during DataTable rendering
      tableIds: {
        'pending': 'pending-table',
        'in-progress': 'in-progress-table',
        'complete': 'complete-table',
        'deferred': 'deferred-table'
      },
      progress: {
        pageNumber: 0,
        pageSize: 10,

      },
      complete: {
        pageNumber: 0,
        pageSize: 10,

      },
      deferred: {
        pageNumber: 0,
        pageSize: 10,

      },
      selectedItemForNote: null,
      noteForm: {
        content: ''
      },
      savingNote: false,
      presetMacros: [],
      lxdSettingsSaving: false,
    }
  },
  computed: {
    selectedPlanValues() {
      return this.selectedPlans.map(p => p.value);
    },
    availableNodes() {
      const nodeRackMap = [{"node":"dedi104","rack":"R142"},{"node":"dedi107","rack":"R142"},{"node":"dedi110","rack":"R142"},{"node":"dedi113","rack":"R142"},{"node":"dedi122","rack":"R143"},{"node":"dedi125","rack":"R143"},{"node":"dedi130","rack":"R143"},{"node":"dedi132","rack":"R143"},{"node":"dedi135","rack":"R143"},{"node":"dedi143","rack":"R143"},{"node":"Dedi145","rack":"R139"},{"node":"Dedi147","rack":"R139"},{"node":"Dedi148","rack":"R139"},{"node":"Dedi150","rack":"R139"},{"node":"Dedi151","rack":"R139"},{"node":"Dedi152","rack":"R139"},{"node":"Dedi155","rack":"R139"},{"node":"Dedi159","rack":"R139"},{"node":"Dedi160","rack":"R139"},{"node":"Dedi161","rack":"R139"},{"node":"dedi166","rack":"R139"},{"node":"Dedi170","rack":"R139"},{"node":"dedi181","rack":"R141"},{"node":"dedi182","rack":"R141"},{"node":"dedi183","rack":"R141"},{"node":"dedi186","rack":"R141"},{"node":"dedi188","rack":"R141"},{"node":"dedi190","rack":"R141"},{"node":"dedi191","rack":"R141"},{"node":"dedi192","rack":"R141"},{"node":"dedi193","rack":"R141"},{"node":"dedi197","rack":"R141"},{"node":"dedi198","rack":"R141"},{"node":"Dedi2","rack":"R147"},{"node":"dedi200","rack":"R141"},{"node":"dedi201","rack":"R141"},{"node":"dedi204","rack":"R141"},{"node":"dedi205","rack":"R141"},{"node":"dedi206","rack":"R141"},{"node":"dedi207","rack":"R141"},{"node":"Dedi213","rack":"R144"},{"node":"Dedi215","rack":"R144"},{"node":"Dedi216","rack":"R144"},{"node":"Dedi217","rack":"R144"},{"node":"Dedi223","rack":"R144"},{"node":"Dedi225","rack":"R144"},{"node":"Dedi227","rack":"R144"},{"node":"Dedi228","rack":"R144"},{"node":"Dedi229","rack":"R144"},{"node":"Dedi230","rack":"R144"},{"node":"Dedi232","rack":"R144"},{"node":"Dedi234","rack":"R144"},{"node":"Dedi235","rack":"R144"},{"node":"Dedi236","rack":"R144"},{"node":"Dedi238","rack":"R144"},{"node":"Dedi240","rack":"R140"},{"node":"Dedi243","rack":"R140"},{"node":"dedi255","rack":"IC106"},{"node":"Dedi256","rack":"R140"},{"node":"Dedi257","rack":"R140"},{"node":"Dedi258","rack":"R140"},{"node":"Dedi260","rack":"R140"},{"node":"Dedi261","rack":"R140"},{"node":"Dedi263","rack":"R139"},{"node":"Dedi265","rack":"R243"},{"node":"Dedi266","rack":"R244"},{"node":"Dedi267","rack":"R244"},{"node":"Dedi269","rack":"R244"},{"node":"Dedi270","rack":"R244"},{"node":"Dedi272","rack":"R244"},{"node":"Dedi273","rack":"R244"},{"node":"Dedi275","rack":"R244"},{"node":"Dedi276","rack":"R241"},{"node":"Dedi277","rack":"R244"},{"node":"Dedi278","rack":"R244"},{"node":"Dedi279","rack":"R244"},{"node":"Dedi280","rack":"R244"},{"node":"Dedi281","rack":"R244"},{"node":"Dedi282","rack":"R244"},{"node":"Dedi283","rack":"R244"},{"node":"dedi286","rack":"R244"},{"node":"Dedi287","rack":"R244"},{"node":"Dedi288","rack":"R244"},{"node":"Dedi291","rack":"R244"},{"node":"Dedi292","rack":"R244"},{"node":"Dedi294","rack":"R244"},{"node":"Dedi295","rack":"R244"},{"node":"Dedi296","rack":"R241"},{"node":"Dedi297","rack":"R239"},{"node":"Dedi301","rack":"R239"},{"node":"dedi303","rack":"R253"},{"node":"Dedi306","rack":"R241"},{"node":"Dedi307","rack":"R241"},{"node":"Dedi309","rack":"R242"},{"node":"Dedi310","rack":"R247"},{"node":"Dedi311","rack":"R243"},{"node":"Dedi312","rack":"R239"},{"node":"Dedi314","rack":"R239"},{"node":"Dedi316","rack":"R241"},{"node":"Dedi317","rack":"R241"},{"node":"Dedi318","rack":"R239"},{"node":"Dedi319","rack":"R239"},{"node":"Dedi320","rack":"R239"},{"node":"dedi323","rack":"R253"},{"node":"dedi324","rack":"R141"},{"node":"dedi325","rack":"R253"},{"node":"dedi327","rack":"R253"},{"node":"dedi329","rack":"R253"},{"node":"Dedi330","rack":"R241"},{"node":"Dedi331","rack":"R241"},{"node":"Dedi334","rack":"R239"},{"node":"Dedi335","rack":"R241"},{"node":"Dedi336","rack":"R241"},{"node":"Dedi337","rack":"R241"},{"node":"dedi339","rack":"R253"},{"node":"dedi340","rack":"R253"},{"node":"Dedi341","rack":"R241"},{"node":"Dedi342","rack":"R242"},{"node":"dedi343","rack":"R253"},{"node":"dedi347","rack":"R253"},{"node":"Dedi501","rack":"R239"},{"node":"Dedi502","rack":"R239"},{"node":"Dedi503","rack":"R239"},{"node":"Dedi504","rack":"R239"},{"node":"dedi505","rack":"R253"},{"node":"dedi506","rack":"R253"},{"node":"dedi507","rack":"R253"},{"node":"dedi508","rack":"R253"},{"node":"dedi509","rack":"R253"},{"node":"Dedi510","rack":"R241"},{"node":"Dedi513","rack":"R241"},{"node":"Dedi514","rack":"R241"},{"node":"Dedi515","rack":"R242"},{"node":"Dedi516","rack":"R242"},{"node":"Dedi518","rack":"R242"},{"node":"Dedi520","rack":"R239"},{"node":"Dedi522","rack":"R239"},{"node":"Dedi524","rack":"R239"},{"node":"Dedi525","rack":"R241"},{"node":"Dedi527","rack":"R241"},{"node":"Dedi531","rack":"R242"},{"node":"Dedi532","rack":"R242"},{"node":"Dedi534","rack":"R242"},{"node":"dedi535","rack":"R253"},{"node":"dedi536","rack":"R253"},{"node":"dedi537","rack":"R253"},{"node":"dedi539","rack":"R253"},{"node":"dedi54","rack":"R146"},{"node":"Dedi540","rack":"R239"},{"node":"Dedi541","rack":"R239"},{"node":"Dedi546","rack":"R242"},{"node":"Dedi547","rack":"R242"},{"node":"Dedi549","rack":"R239"},{"node":"Dedi550","rack":"R242"},{"node":"Dedi555","rack":"R242"},{"node":"Dedi556","rack":"R242"},{"node":"Dedi557","rack":"R239"},{"node":"Dedi558","rack":"R239"},{"node":"Dedi559","rack":"R239"},{"node":"Dedi560","rack":"R239"},{"node":"Dedi562","rack":"R239"},{"node":"Dedi565","rack":"R243"},{"node":"Dedi566","rack":"R243"},{"node":"Dedi567","rack":"R243"},{"node":"Dedi568","rack":"R243"},{"node":"Dedi569","rack":"R243"},{"node":"Dedi570","rack":"R243"},{"node":"Dedi571","rack":"R243"},{"node":"Dedi572","rack":"R243"},{"node":"Dedi573","rack":"R243"},{"node":"Dedi575","rack":"R243"},{"node":"Dedi577","rack":"R247"},{"node":"Dedi578","rack":"R242"},{"node":"Dedi579","rack":"R242"},{"node":"Dedi580","rack":"R242"},{"node":"Dedi582","rack":"R242"},{"node":"Dedi583","rack":"R243"},{"node":"Dedi585","rack":"R243"},{"node":"Dedi586","rack":"R243"},{"node":"Dedi587","rack":"R243"},{"node":"Dedi588","rack":"R243"},{"node":"Dedi589","rack":"R243"},{"node":"Dedi590","rack":"R243"},{"node":"Dedi591","rack":"R243"},{"node":"Dedi592","rack":"R243"},{"node":"Dedi593","rack":"R243"},{"node":"Dedi594","rack":"R243"},{"node":"Dedi595","rack":"R243"},{"node":"Dedi596","rack":"R247"},{"node":"Dedi597","rack":"R247"},{"node":"Dedi6","rack":"R147"},{"node":"Dedi60","rack":"R145"},{"node":"Dedi601","rack":"R247"},{"node":"Dedi615","rack":"R247"},{"node":"dedi616","rack":"R253"},{"node":"dedi619","rack":"R251"},{"node":"dedi620","rack":"R251"},{"node":"dedi622","rack":"R251"},{"node":"dedi623","rack":"R251"},{"node":"dedi625","rack":"R251"},{"node":"Dedi63","rack":"R145"},{"node":"dedi641","rack":"R250B"},{"node":"dedi644","rack":"R250B"},{"node":"dedi646","rack":"R140"},{"node":"dedi647","rack":"R250B"},{"node":"dedi649","rack":"R250B"},{"node":"dedi651","rack":"R252"},{"node":"dedi652","rack":"R146"},{"node":"dedi663","rack":"R253"},{"node":"dedi665","rack":"R253"},{"node":"dedi667","rack":"R153"},{"node":"dedi671","rack":"R150B"},{"node":"dedi672","rack":"R150B"},{"node":"dedi673","rack":"R150B"},{"node":"dedi674","rack":"R150B"},{"node":"dedi675","rack":"R150B"},{"node":"dedi676","rack":"R150B"},{"node":"dedi678","rack":"R150B"},{"node":"dedi679","rack":"R150B"},{"node":"dedi680","rack":"R240"},{"node":"dedi682","rack":"R153"},{"node":"dedi683","rack":"R153"},{"node":"dedi685","rack":"R145"},{"node":"dedi686","rack":"R145"},{"node":"dedi687","rack":"R240"},{"node":"Dedi688","rack":"R139"},{"node":"dedi696","rack":"R254"},{"node":"dedi697","rack":"R254"},{"node":"dedi701","rack":"R153"},{"node":"dedi702","rack":"R153"},{"node":"dedi703","rack":"R153"},{"node":"dedi704","rack":"R153"},{"node":"dedi705","rack":"R153"},{"node":"dedi707","rack":"R150B"},{"node":"dedi708","rack":"R246"},{"node":"dedi709","rack":"R246"},{"node":"dedi710","rack":"R246"},{"node":"dedi713","rack":"R246"},{"node":"dedi714","rack":"R254"},{"node":"dedi716","rack":"R254"},{"node":"dedi721","rack":"R245"},{"node":"dedi723","rack":"R255"},{"node":"dedi724","rack":"R255"},{"node":"dedi725","rack":"R150B"},{"node":"dedi726","rack":"R150B"},{"node":"dedi729","rack":"R155"},{"node":"dedi730","rack":"R155"},{"node":"dedi731","rack":"R146"},{"node":"dedi732","rack":"R146"},{"node":"dedi733","rack":"R146"},{"node":"dedi734","rack":"R254"},{"node":"dedi735","rack":"R254"},{"node":"dedi736","rack":"R254"},{"node":"dedi738","rack":"R254"},{"node":"dedi739","rack":"R254"},{"node":"dedi740","rack":"R254"},{"node":"dedi745","rack":"R255"},{"node":"dedi746","rack":"R255"},{"node":"dedi747","rack":"R255"},{"node":"dedi748","rack":"R255"},{"node":"dedi752","rack":"R154"},{"node":"dedi758","rack":"R155"},{"node":"Dedi77","rack":"R145"},{"node":"dedi771","rack":"R155"},{"node":"Dedi82","rack":"R145"},{"node":"dedi95","rack":"R142"},{"node":"dedi98","rack":"R142"},{"node":"OVH - vape.co.uk","rack":"Remote-01"},{"node":"Voxility - 39591","rack":"Remote-01"},{"node":"Voxility - 45165","rack":"Remote-01"},{"node":"Voxility - 48060","rack":"Remote-01"},{"node":"VPS100","rack":"R239"},{"node":"VPS101","rack":"R239"},{"node":"VPS105","rack":"R241"},{"node":"VPS106","rack":"R241"},{"node":"VPS107","rack":"R241"},{"node":"VPS108","rack":"R242"},{"node":"VPS109","rack":"R242"},{"node":"VPS110","rack":"R243"},{"node":"VPS111","rack":"R243"},{"node":"VPS112","rack":"R243"},{"node":"VPS113","rack":"R247"},{"node":"VPS114","rack":"R247"},{"node":"VPS115","rack":"R247"},{"node":"VPS116","rack":"R247"},{"node":"VPS117","rack":"R247"},{"node":"VPS118","rack":"R247"},{"node":"VPS119","rack":"R247"},{"node":"VPS120","rack":"R247"},{"node":"VPS121","rack":"R247"},{"node":"VPS122","rack":"R144"},{"node":"VPS123","rack":"R247"},{"node":"VPS124","rack":"R139"},{"node":"VPS126","rack":"R247"},{"node":"vps127","rack":"R141"},{"node":"VPS128","rack":"R140"},{"node":"VPS129","rack":"R147"},{"node":"VPS13","rack":"R145"},{"node":"VPS130","rack":"R150A"},{"node":"VPS131","rack":"R150A"},{"node":"VPS132","rack":"R150A"},{"node":"VPS133","rack":"R144"},{"node":"vps134","rack":"R146"},{"node":"vps135","rack":"R146"},{"node":"vps136","rack":"R142"},{"node":"vps137","rack":"R146"},{"node":"VPS138","rack":"R150A"},{"node":"vps139","rack":"R251"},{"node":"VPS141","rack":"R145"},{"node":"vps142","rack":"R251"},{"node":"vps143","rack":"R251"},{"node":"vps144","rack":"R251"},{"node":"vps145","rack":"R251"},{"node":"vps146","rack":"R251"},{"node":"vps147","rack":"R251"},{"node":"vps148","rack":"R251"},{"node":"VPS149","rack":"R150A"},{"node":"vps150","rack":"R140"},{"node":"VPS150","rack":"R147"},{"node":"VPS151","rack":"R150A"},{"node":"VPS152","rack":"R150A"},{"node":"VPS153","rack":"R150A"},{"node":"VPS154 (Dedi258)","rack":"R140"},{"node":"VPS155","rack":"R150A"},{"node":"VPS156","rack":"R150A"},{"node":"vps157","rack":"R245"},{"node":"vps158","rack":"R245"},{"node":"vps159","rack":"R245"},{"node":"VPS16","rack":"R145"},{"node":"vps160","rack":"R245"},{"node":"vps161","rack":"R245"},{"node":"vps162","rack":"R245"},{"node":"vps163","rack":"R245"},{"node":"vps164","rack":"R250B"},{"node":"vps165","rack":"R250B"},{"node":"vps166","rack":"R250B"},{"node":"vps167","rack":"R250B"},{"node":"vps169","rack":"R252"},{"node":"VPS17","rack":"R145"},{"node":"VPS170","rack":"R147"},{"node":"VPS171","rack":"R147"},{"node":"VPS172","rack":"R147"},{"node":"VPS173","rack":"R147"},{"node":"vps174","rack":"R252"},{"node":"vps175","rack":"R252"},{"node":"vps176","rack":"R252"},{"node":"vps177","rack":"R252"},{"node":"vps178","rack":"R252"},{"node":"vps179","rack":"R252"},{"node":"vps18","rack":"R142"},{"node":"vps180","rack":"R252"},{"node":"vps181","rack":"R252"},{"node":"vps182","rack":"R252"},{"node":"vps183","rack":"R253"},{"node":"vps184","rack":"R150B"},{"node":"vps185","rack":"R150B"},{"node":"vps186","rack":"R150B"},{"node":"vps187","rack":"R150B"},{"node":"vps188","rack":"R150B"},{"node":"VPS19","rack":"R147"},{"node":"vps190","rack":"R142"},{"node":"vps191","rack":"R242"},{"node":"vps192","rack":"R240"},{"node":"vps193","rack":"R240"},{"node":"vps194","rack":"R240"},{"node":"vps195","rack":"R240"},{"node":"vps196","rack":"R240"},{"node":"vps197","rack":"R240"},{"node":"vps198","rack":"R240"},{"node":"vps20","rack":"R143"},{"node":"vps200","rack":"R246"},{"node":"vps209","rack":"R254"},{"node":"vps21","rack":"R143"},{"node":"vps210","rack":"R254"},{"node":"vps211","rack":"R254"},{"node":"vps22","rack":"R143"},{"node":"VPS23","rack":"R139"},{"node":"VPS24","rack":"R139"},{"node":"VPS25","rack":"R139"},{"node":"vps26","rack":"R141"},{"node":"VPS27","rack":"R244"},{"node":"vps28","rack":"R141"},{"node":"VPS29 (prev colo2)","rack":"R139"},{"node":"VPS30","rack":"R144"},{"node":"VPS31","rack":"R144"},{"node":"VPS33","rack":"R144"},{"node":"VPS34","rack":"R144"},{"node":"VPS35","rack":"R140"},{"node":"VPS36","rack":"R140"},{"node":"VPS37","rack":"R140"},{"node":"VPS38","rack":"R244"},{"node":"VPS39","rack":"R140"},{"node":"VPS40","rack":"R244"},{"node":"VPS41","rack":"R244"},{"node":"VPS42","rack":"R247"},{"node":"VPS43","rack":"R247"},{"node":"VPS44","rack":"R247"},{"node":"VPS45","rack":"R247"},{"node":"VPS46","rack":"R243"},{"node":"VPS47","rack":"R243"},{"node":"VPS48","rack":"R243"},{"node":"VPS49","rack":"R243"},{"node":"VPS50","rack":"R140"},{"node":"wpo175","rack":"R139"},{"node":"wpo176","rack":"R139"},{"node":"WPO208","rack":"R144"},{"node":"WPO246","rack":"R140"},{"node":"WPO264","rack":"R140"},{"node":"WPO602","rack":"R140"},{"node":"WPO603","rack":"R140"},{"node":"WPO604","rack":"R140"},{"node":"wpo605","rack":"R141"},{"node":"wpo606","rack":"R145"},{"node":"wpo607","rack":"R143"},{"node":"wpo608","rack":"R143"},{"node":"wpo609","rack":"R143"},{"node":"wpo610","rack":"R143"},{"node":"wpo611","rack":"R143"},{"node":"wpo612","rack":"R244"},{"node":"wpo614","rack":"R244"},{"node":"wpo626","rack":"R251"},{"node":"wpo627","rack":"R251"},{"node":"wpo628","rack":"R251"},{"node":"wpo629","rack":"R251"},{"node":"wpo630","rack":"R251"},{"node":"wpo631","rack":"R251"},{"node":"WPO632","rack":"R242"},{"node":"wpo633","rack":"R245"},{"node":"wpo634","rack":"R245"},{"node":"wpo636","rack":"R245"},{"node":"wpo637","rack":"R245"},{"node":"wpo638","rack":"R245"},{"node":"wpo639","rack":"R245"},{"node":"wpo640","rack":"R245"},{"node":"wpo649","rack":"R250B"},{"node":"wpo650","rack":"R250B"},{"node":"wpo651","rack":"R250B"},{"node":"wpo652","rack":"R245"},{"node":"wpo653","rack":"R245"},{"node":"wpo654","rack":"R245"},{"node":"wpo658","rack":"R253"},{"node":"wpo659","rack":"R253"},{"node":"wpo660","rack":"R253"},{"node":"wpo661","rack":"R253"},{"node":"wpo662","rack":"R253"},{"node":"wpo666","rack":"R150B"},{"node":"wpo667","rack":"R150B"},{"node":"wpo668","rack":"R253"},{"node":"wpo669","rack":"R150B"},{"node":"wpo670","rack":"R253"},{"node":"wpo671","rack":"R150B"},{"node":"wpo672","rack":"R150B"},{"node":"wpo673","rack":"R150B"},{"node":"wpo674","rack":"R150B"},{"node":"wpo675","rack":"R150B"},{"node":"wpo676","rack":"R240"},{"node":"wpo677","rack":"R240"},{"node":"wpo678","rack":"R240"},{"node":"wpo679","rack":"R240"},{"node":"wpo680","rack":"R153"},{"node":"wpo681","rack":"R153"},{"node":"wpo682","rack":"R153"},{"node":"wpo683","rack":"R153"},{"node":"wpo684","rack":"R255"},{"node":"wpo685","rack":"R255"},{"node":"wpo686","rack":"R255"},{"node":"wpo687","rack":"R255"},{"node":"wpo688","rack":"R255"}];
      const activeRack = (this.selectedPriorityFilter && this.selectedPriorityFilter !== 'None')
        ? this.selectedPriorityFilter
        : (this.selectedRack !== 'all' ? this.selectedRack : null);
      const filtered = activeRack
        ? nodeRackMap.filter(entry => entry.rack === activeRack)
        : nodeRackMap;
      return filtered.map(entry => entry.node).sort();
    },
    availableRacks() {
      return ['IC106', 'IG109', 'R139', 'R140', 'R141', 'R142', 'R143', 'R144', 'R145', 'R146', 'R147', 'R150A', 'R150B', 'R153', 'R154', 'R155', 'R239', 'R240', 'R241', 'R242', 'R243', 'R244', 'R245', 'R246', 'R247', 'R250B', 'R251', 'R252', 'R253', 'R254', 'R255', 'Remote-01']
    },
    pPageSize: {
      get() {
        if (this.activeTab === 'in-progress') {
          return this.progress.pageSize;
        } else if (this.activeTab === 'complete') {
          return this.complete.pageSize;
        } else if (this.activeTab === 'deferred') {
          return this.deferred.pageSize;
        }
        return this.progress.pageSize;
      },
      set(value) {
        if (this.activeTab === 'in-progress') {
          this.progress.pageSize = value;
        } else if (this.activeTab === 'complete') {
          this.complete.pageSize = value;
        } else if (this.activeTab === 'deferred') {
          this.deferred.pageSize = value;
        }
      }
    },
    progressPageCount() {
      let filteredGroups = this.filteredInProgressData
      let l = filteredGroups.length, s = this.progress.pageSize;
      return Math.ceil(l / s);
    },
    completePageCount() {
      let filteredGroups = this.filteredCompleteData
      let l = filteredGroups.length, s = this.complete.pageSize;
      return Math.ceil(l / s);
    },
    deferredPageCount() {
      let filteredGroups = this.filteredDeferredData
      let l = filteredGroups.length, s = this.deferred.pageSize;
      return Math.ceil(l / s);
    },
    last () {
      return (this.pendingData.length > 0) ? this.pendingData[this.pendingData.length-1] : null;
    },
    first () {
      return (this.pendingData.length > 0) ? this.pendingData[0] : null;
    },
    user() {
      return this.$store.getters.user
    },
    pendingCount() {
      let pending = this.allRecords.filter(el => el.status === 'pending');
      if(this.selectedIpGroup !== 'all' && pending.length > 0) {
        pending = pending.filter(item => {
          if(!item.ipGroup) return false
          return item.ipGroup.toLowerCase().includes(this.selectedIpGroup.toLowerCase());
        });
      }
      if(this.selectedPlanValues.length > 0 && pending.length > 0) {
        pending = pending.filter(item => {
          if(!item.planName) return false
          return this.selectedPlanValues.some(p => item.planName.toLowerCase().includes(p.toLowerCase()));
        });
      }
      if(this.selectedRack === 'UNCATEGORIZED' && pending.length > 0) {
        pending = pending.filter(item => !item.rack && !item.nodeName);
      } else {
        if(this.selectedRack !== 'all' && pending.length > 0) {
          pending = pending.filter(item => {
            if(!item.rack) return false
            return item.rack.toLowerCase().includes(this.selectedRack.toLowerCase());
          });
        }
        if(this.selectedNode !== 'all' && pending.length > 0) {
          pending = pending.filter(item => {
            if(!item.nodeName) return false
            return item.nodeName.toLowerCase().includes(this.selectedNode.toLowerCase());
          });
        }
      }
      if(this.dnsTicketCreated !== 'all' && pending.length > 0) {
        pending = pending.filter(item => {
          return item.dnsTicketCreated.toLowerCase().includes(this.dnsTicketCreated.toLowerCase())
        });
      }
      if(this.dnsProvided !== 'all' && pending.length > 0) {
        pending = pending.filter(item => {
          return (item.dnsProvided && item.dnsProvided.toLowerCase().includes(this.dnsProvided.toLowerCase())) 
        });
      }
      return pending ? pending.length : 0;
    },
    inProgressCount() {
      // Use inProgressData if available (more accurate and faster), otherwise fallback to allRecords
      let inprogress = this.allRecords.filter(el => el.status === 'in-progress');
      if(this.selectedIpGroup !== 'all' && inprogress.length > 0) {
        inprogress = inprogress.filter(item => {
          if(!item.ipGroup) return false
          return item.ipGroup.toLowerCase().includes(this.selectedIpGroup.toLowerCase());
        });
      }
      if(this.selectedPlanValues.length > 0 && inprogress.length > 0) {
        inprogress = inprogress.filter(item => {
          if(!item.planName) return false
          return this.selectedPlanValues.some(p => item.planName.toLowerCase().includes(p.toLowerCase()));
        });
      }if(this.selectedRack === 'UNCATEGORIZED' && inprogress.length > 0) {
        inprogress = inprogress.filter(item => !item.rack && !item.nodeName);
      } else {
        if(this.selectedRack !== 'all' && inprogress.length > 0) {
          console.log('record', inprogress)
          inprogress = inprogress.filter(item => {
            if(!item.rack) return false
            return item.rack.toLowerCase().includes(this.selectedRack.toLowerCase());
          });
        }
        if(this.selectedNode !== 'all' && inprogress.length > 0) {
          inprogress = inprogress.filter(item => {
            if(!item.nodeName) return false
            return item.nodeName.toLowerCase().includes(this.selectedNode.toLowerCase());
          });
        }
      }
      if(this.dnsTicketCreated !== 'all' && inprogress.length > 0) {
        inprogress = inprogress.filter(item => {
          return item.dnsTicketCreated.toLowerCase().includes(this.dnsTicketCreated.toLowerCase())
        });
      }      if(this.dnsProvided !== 'all' && inprogress.length > 0) {
        inprogress = inprogress.filter(item => {
          return item.dnsProvided && item.dnsProvided.toLowerCase().includes(this.dnsProvided.toLowerCase())
        });
      }
      return inprogress ? inprogress.length : 0;
    },
    completeCount() {
      // Use completeData if available (more accurate and faster), otherwise fallback to allRecords
      let complete = this.allRecords.filter(el => el.status === 'complete');
      if(this.selectedIpGroup !== 'all' && complete.length > 0) {
        complete = complete.filter(item => {
          if(!item.ipGroup) return false
          return item.ipGroup.toLowerCase().includes(this.selectedIpGroup.toLowerCase());
        });
      }
      if(this.selectedPlanValues.length > 0 && complete.length > 0) {
        complete = complete.filter(item => {
          if(!item.planName) return false
          return this.selectedPlanValues.some(p => item.planName.toLowerCase().includes(p.toLowerCase()));
        });
      }
      if(this.selectedRack === 'UNCATEGORIZED' && complete.length > 0) {
        complete = complete.filter(item => !item.rack && !item.nodeName);
      } else {
        if(this.selectedRack !== 'all' && complete.length > 0) {
          complete = complete.filter(item => {
            if(!item.rack) return false
            return item.rack.toLowerCase().includes(this.selectedRack.toLowerCase());
          });
        }
        if(this.selectedNode !== 'all' && complete.length > 0) {
          complete = complete.filter(item => {
            if(!item.nodeName) return false
            return item.nodeName.toLowerCase().includes(this.selectedNode.toLowerCase());
          });
        }
      }
      if(this.dnsTicketCreated !== 'all' && complete.length > 0) {
        complete = complete.filter(item => {
          return item.dnsTicketCreated.toLowerCase().includes(this.dnsTicketCreated.toLowerCase())
        });
      }      if(this.dnsProvided !== 'all' && complete.length > 0) {
        complete = complete.filter(item => {
          return item.dnsProvided && item.dnsProvided.toLowerCase().includes(this.dnsProvided.toLowerCase())
        });
      }
      return complete ? complete.length : 0;
    },
    deferredCount() {
      // Use deferredData if available (more accurate and faster), otherwise fallback to allRecords
      return this.allRecords.filter(el => el.status === 'deferred').length;
    },
    greenCFCount() {
      // Count plans where all domains have CF enabled and no nerdpress tag
      // Use pendingData if available (more accurate and faster), otherwise fallback to allRecords
      const sourceData = this.allRecords.filter(el => el.status === 'pending');
      let set = sourceData.filter(item => {
        // if (!item.domains || item.domains.length === 0) return false;
        return item.status === 'pending' && (item.dnsProvided === 'yes' || this.checkCFStatus(item));
      })
      if(this.selectedIpGroup !== 'all' && set.length > 0) {
        set = set.filter(item => {
          if(!item.ipGroup) return false
          return item.ipGroup.toLowerCase().includes(this.selectedIpGroup.toLowerCase());
        });
      }
      if(this.selectedPlanValues.length > 0 && set.length > 0) {
        set = set.filter(item => {
          if(!item.planName) return false
          return this.selectedPlanValues.some(p => item.planName.toLowerCase().includes(p.toLowerCase()));
        });
      }
      if(this.selectedRack === 'UNCATEGORIZED' && set.length > 0) {
        set = set.filter(item => !item.rack && !item.nodeName);
      } else {
        if(this.selectedRack !== 'all' && set.length > 0) {
          set = set.filter(item => {
            if(!item.rack) return false
            return item.rack.toLowerCase().includes(this.selectedRack.toLowerCase());
          });
        }
        if(this.selectedNode !== 'all' && set.length > 0) {
          set = set.filter(item => {
            if(!item.nodeName) return false
            return item.nodeName.toLowerCase().includes(this.selectedNode.toLowerCase());
          });
        }
      }
      if(this.dnsTicketCreated !== 'all' && set.length > 0) {
        set = set.filter(item => {
          return item.dnsTicketCreated.toLowerCase().includes(this.dnsTicketCreated.toLowerCase())
        });
      }      if(this.dnsProvided !== 'all' && set.length > 0) {
        set = set.filter(item => {
          return item.dnsProvided && item.dnsProvided.toLowerCase().includes(this.dnsProvided.toLowerCase())
        });
      }
      return set ? set.length : 0;
    },
    nonGreenCFCount() {
      // Count plans that don't have green CF status
      // Use pendingData if available (more accurate and faster), otherwise fallback to allRecords
      const sourceData = this.allRecords.filter(el => el.status === 'pending');
      let set = sourceData.filter(item => {
        // if (!item.domains || item.domains.length === 0) return true;
        return item.status === 'pending' && (item.dnsProvided === 'no' || (!item.dnsProvided && !this.checkCFStatus(item)));
      })
      if(this.selectedIpGroup !== 'all' && set.length > 0) {
        set = set.filter(item => {
          if(!item.ipGroup) return false
          return item.ipGroup.toLowerCase().includes(this.selectedIpGroup.toLowerCase());
        });
      }
      if(this.selectedPlanValues.length > 0 && set.length > 0) {
        set = set.filter(item => {
          if(!item.planName) return false
          return this.selectedPlanValues.some(p => item.planName.toLowerCase().includes(p.toLowerCase()));
        });
      }
      if(this.selectedRack === 'UNCATEGORIZED' && set.length > 0) {
        set = set.filter(item => !item.rack && !item.nodeName);
      } else {
        if(this.selectedRack !== 'all' && set.length > 0) {
          set = set.filter(item => {
            if(!item.rack) return false
            return item.rack.toLowerCase().includes(this.selectedRack.toLowerCase());
          });
        }
        if(this.selectedNode !== 'all' && set.length > 0) {
          set = set.filter(item => {
            if(!item.nodeName) return false
            return item.nodeName.toLowerCase().includes(this.selectedNode.toLowerCase());
          });
        }
      }
      if(this.dnsTicketCreated !== 'all' && set.length > 0) {
        set = set.filter(item => {
          return item.dnsTicketCreated.toLowerCase().includes(this.dnsTicketCreated.toLowerCase())
        });
      }      if(this.dnsProvided !== 'all' && set.length > 0) {
        set = set.filter(item => {
          return item.dnsProvided && item.dnsProvided.toLowerCase().includes(this.dnsProvided.toLowerCase())
        });
      }
      return set ? set.length : 0;
    },
    filteredPendingData() {
      return this.applyFiltersToData(this.pendingData);
    },
    filteredInProgressData() {
      return  this.applyFiltersToData(this.inProgressData);

    },
    modifiedProgress() {
      const start = this.progress.pageNumber * this.progress.pageSize, end = start + this.progress.pageSize;
      return this.filteredInProgressData.slice(start, end);
    },
    modifiedComplete() {
      const start = this.complete.pageNumber * this.complete.pageSize, end = start + this.complete.pageSize;
      return this.filteredCompleteData.slice(start, end);
    },
    modifiedDeferred() {
      const start = this.deferred.pageNumber * this.deferred.pageSize, end = start + this.deferred.pageSize;
      return this.filteredDeferredData.slice(start, end);
    },
    filteredCompleteData() {
      const data = this.completeData.sort((a,b) => new Date(b.completedAt).getTime() - new Date(a.completedAt).getTime());
      return this.applyFiltersToData(data);
    },
    filteredDeferredData() {
      return this.applyFiltersToData(this.deferredData);
    },
    stepNames() {
      return ['All', ...this.steps.map(step => step.name)];
    },
    topMigrationLeaders() {
      // Count completed migrations by checkedInByEmail
      const leaderCounts = {};
      
      this.allRecords
        .filter(item => item.status === 'complete' && item.checkedInByEmail)
        .forEach(item => {
          const email = item.checkedInByEmail;
          const name = item.checkedInBy || email;
          
          if (!leaderCounts[email]) {
            leaderCounts[email] = {
              email: email,
              name: name,
              count: 0
            };
          }
          leaderCounts[email].count++;
        });
      
      // Convert to array, sort by count (descending), and get top 4
      return Object.values(leaderCounts)
        .sort((a, b) => b.count - a.count)
        .slice(0, 4);
    }
  },
  watch: {
    "showPlansDropdown"(val) {
      if(val){
        console.log('opening', this.$refs.planMultiselect)
        this.$refs.planMultiselect.activate()
      }
    },
    selectedPriorityFilter(val) {
      // if(this.activeTab !== 'pending') return
      if(val) {
        if(val === 'Steadfast'){
          this.selectedIpGroup = 'Steadfast'
          this.selectedNode = 'all'
          this.selectedRack = 'all'
          this.selectedPlans = []
          this.dnsProvided = 'all'
          this.dnsTicketCreated = 'all'
        } else if(val === 'None') {
          this.selectedPlans = []
          this.selectedTeamFilter = ''
          this.selectedIpGroup = 'all'
          this.selectedRack= 'all'
          this.dnsProvided = 'all'
        } else if(val === 'UNCATEGORIZED') {
          // UNCATEGORIZED is a sentinel value meaning "records with no rack and no node"
          this.selectedIpGroup = 'all'
          this.selectedNode = 'all'
          this.selectedRack = 'UNCATEGORIZED'
        }
        else{
          this.selectedIpGroup = 'all'
          this.selectedRack= val
        }
      }
    },
    checkinFilter(){
      this.progress.pageNumber = 0
      this.complete.pageNumber = 0
    },
    searchText() {
      this.progress.pageNumber = 0
      this.complete.pageNumber = 0
      this.deferred.pageNumber = 0
      
    },
    selectedSearch() {
      this.fetchPending()
    },
    'progress.pageSize'() {
      this.progress.pageNumber = 0
    },'complete.pageSize'() {
      this.complete.pageNumber = 0
    },'deferred.pageSize'() {
      this.deferred.pageNumber = 0
    },
    selectedNode(val) {
      console.log(val)
      if(this.activeTab === 'pending') {
        this.searchQuery = true
        this.fetchPending()
      }
    },selectedRack(val) {
      console.log(val)
      if(this.priorityFilers.includes(val)) {
        this.selectedPriorityFilter = val
      }
      if(this.activeTab === 'pending') {
        this.searchQuery = true
        this.fetchPending()
      }
    },dnsProvided(val) {
      console.log(val)
      if(this.activeTab === 'pending') {
        this.searchQuery = true
        this.fetchPending()
      }
    },dnsTicketCreated(val) {
      console.log(val)
      if(this.activeTab === 'pending') {
        this.searchQuery = true
        this.fetchPending()
      }
    },
    selectedPlans() {
      if(this.activeTab === 'pending') {
        this.searchQuery = true
        this.fetchPending()
      }
    },
    selectedTeamFilter(val) {
      this.selectedPriorityFilter  = null
      if (val === 'morning') {
        this.selectedRack = this.lxdSettings.teams.morningRack || 'all';
        this.dnsProvided = this.lxdSettings.teams.morningDns || 'all'
        const morningValues = ['WPO Starter', 'WPO Professional', 'Mediavine Plan 1', 'Mediavine Plan 2', 'Journey Plan', 'WPO VPS']
        this.selectedPlans = this.planOptions.filter(p => morningValues.includes(p.value))
      } else if(val === 'night') {
        this.selectedRack = this.lxdSettings.teams.nightRack || 'all';
        const morningValues = ['WPO Starter', 'WPO Professional', 'Mediavine Plan 1', 'Mediavine Plan 2', 'Journey Plan', 'WPO VPS']
        this.selectedPlans = this.planOptions.filter(p => morningValues.includes(p.value))
        this.dnsProvided = this.lxdSettings.teams.nightDns || 'yes'
      }
    },
    selectedIpGroup() {
      if(this.activeTab === 'pending') {
        this.searchQuery = true
        this.fetchPending()
      }
    },
    searchQuery(val) {
      console.log('searchQuery', val)
      if(val) {
        this.fetchPending()
      }
    },
    pageSize() {
      this.fetchPending()
    },
    activeTab(newTab, oldTab) {
      this.searchText = ''
      this.cleanupTabListener(oldTab);
      // Initialize new tab listener
      this.initializeTabListener(newTab);
    },
    topMigrationLeaders() {
      this.$nextTick(() => {
        this.initializeLeaderTooltips();
      });
    },
  },
  async mounted() {
    // Auto-select team filter based on current EST time
    const estHour = new Date().toLocaleString('en-US', { timeZone: 'America/New_York', hour: 'numeric', hour12: false }) * 1;
    if (estHour >= 7 && estHour < 19) {
      this.selectedTeamFilter = 'morning';
    } else  {
      this.selectedTeamFilter = 'night';
    }
    // Initialize component
    this.allRecordsLoading = true
    this.lxdLoader = true
    await this.loadLxdSettings()
    await this.fetchPending()
    this.pendingjobs()
    // Load getAllRecords asynchronously in the background - counts will use listener data first
    // This allows UI to render immediately while data loads in background
    this.$nextTick(() => {
      // Load in background without blocking UI
      this.getAllRecords();
    });
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    // db.collection('vzToLxdMigration').doc('1rXaJKnS3rid8yO8S4Y9').update({steps: this.steps})
    // this.loadAvailableNodes();
    this.getPresetMacros()
    // this.initializeTable()
    this.$nextTick(() => {
      this.initializeLeaderTooltips();
      this.initCheckServerTooltips();
    });
  },

  beforeDestroy() {
    // Unsubscribe from all snapshot listeners
    this.cleanupTabListener('pending');
    this.cleanupTabListener('in-progress');
    this.cleanupTabListener('complete');
    this.cleanupTabListener('deferred');
    if(this.pendingListener) {
      this.pendingListener();
    }if(this.unsubscribeLxd) {
      this.unsubscribeLxd();
    }
    // Clean up tippy instances for leader avatars
    this.topMigrationLeaders.forEach((leader, index) => {
      const element = document.getElementById(`leader-avatar-${index}`);
      if (element && element._tippy) {
        element._tippy.destroy();
      }
    });
    // Clean up all DataTables
    const tableIds = ['pending-table', 'in-progress-table', 'complete-table'];
    tableIds.forEach(tableId => {
      try {
        const $table = $(`#${tableId}`);
        if ($table.length && $.fn.DataTable.isDataTable(`#${tableId}`)) {
          try {
            $table.DataTable().destroy();
          } catch (e) {
            // If destroy fails, just clear the reference
            $table.data('DataTable', null);
          }
        }
      } catch (e) {
        // Ignore cleanup errors
      }
    });
  },
  methods: {
    async callScript() {
      const ref = await db.collection('vzToLxdMigration').where('status', '==','pending').get();
      if(ref.size){
        for(const [i,row] of ref.docs.entries()){
          console.log(i, '/', ref.size)
          if(i <= 1100) continue
          await db.collection('vzToLxdMigration').doc(row.id).update({ preserveIp: 'yes', lxdCluster: 'egv'})
        }
      }
    },
    updateValue(){
      console.log('value', this.lxdSettings)
    },
    loadLxdSettings() {
      return new Promise((resolve) => {
        try {
          let resolved = false;
          this.unsubscribeLxd = db
              .collection('permissions')
              .doc('lxdMigrationSettings')
              .onSnapshot(
                  (doc) => {
                    if (doc.exists) {
                      const data = doc.data() || {};
                      this.lxdSettings = {
                        ...this.lxdSettings,
                        ...data,
                        teams: { morningRack: '', nightRack: '', morningDns: 'all', nightDns: 'yes', ...(data.teams || {}) },
                        other: { allowPreserveIpChange: false, allowDestinationChange: false, useNewApi: false, ...(data.other || {}) }
                      };
                      // Sync into local filter props
                      if(this.selectedTeamFilter === 'morning') {
                        this.selectedRack = this.lxdSettings.teams.morningRack || 'all';
                        this.dnsProvided = this.lxdSettings.teams.morningDns;
                      } else {
                        this.selectedRack   = this.lxdSettings.teams.nightRack   || 'all';
                        this.dnsProvided   = this.lxdSettings.teams.nightDns;
                      }
                    }

                    // turn off loader AFTER snapshot arrives
                    this.lxdLoader = false;
                    if (!resolved) { resolved = true; resolve(); }
                  },
                  (error) => {
                    console.error('loadLxdSettings error', error);
                    this.lxdLoader = false;
                    if (!resolved) { resolved = true; resolve(); }
                  }
              );
        } catch (e) {
          console.error('loadLxdSettings error', e);
          this.lxdLoader = false;
          resolve();
        }
      });
    },
    async saveLxdSettings() {
      this.lxdSettingsSaving = true;
      try {
        await db.collection('permissions').doc('lxdMigrationSettings').set(this.lxdSettings, { merge: true });
        this.showToast({
          message: `You have successfully updated settings for LXD.`,
          duration: 3000
        }, true, 'success');
      } catch (e) {
        console.error('saveLxdSettings error', e);
        this.showToast({
          message: `Error while updating settings for LXD: ${error.toString()}`,
          duration: 4000
        }, true, 'danger');
      }
      this.lxdSettingsSaving = false;
    },
    getTooltip(index, flag, tooltip) {
      if(flag) {
        tippy(`#createVM${index}`, {
          content: flag ? tooltip : '',
          allowHTML: true,
          theme: 'dark',
          placement: 'top'
        });
      }
    },
    initCheckServerTooltips() {
      this.$nextTick(() => {
        document.querySelectorAll('[id^="checkServerReady_"]').forEach(el => {
          if (el._tippy) el._tippy.destroy()
          tippy(el, {
            content: 'Please allow up to 10 minutes for server to be fully ready. This step will be marked completed automatically once server is prepared. Please click "Check Server Forcefully" if you don\'t see it complete in ~10 minutes.',
            allowHTML: false,
            theme: 'dark',
            placement: 'top',
            maxWidth: 320,
          })
        })
      })
    },
    async alertOnSlack(row) {
      console.log(row)
      if(row.alertForMigration) return
      await db.collection('vzToLxdMigration').doc(row.id).update({ alertForMigration: true })
    },
    initializeLeaderTooltips() {
      // Destroy existing tippy instances for leader avatars
      this.topMigrationLeaders.forEach((leader, index) => {
        const element = document.getElementById(`leader-avatar-${index}`);
        if (element) {
          const instance = element._tippy;
          if (instance) {
            instance.destroy();
          }
          tippy(`#leader-avatar-${index}`, {
            content: `${leader.name} - ${leader.count} migrations`,
            allowHTML: true,
            theme: 'dark',
            placement: 'top'
          });
        }
      });
    },
    loginAsUser(item) {
      window.open(`https://wpo.bigscoots.com/user/dashboard?id=${item.uid}`,'WPO-Bigscoots');
    },
    async deferMigration(item) {
      try {
        // Update status to deferred in Firestore
        await db.collection('vzToLxdMigration').doc(item.id).update({
          status: 'deferred',
          deferredAt: new Date().toISOString(),
          deferredBy: `${this.user.firstName} ${this.user.lastName}`,
          deferredByEmail: this.user.email,
          checkedIn: false,
          checkedInByEmail: '',
          checkedInBy: '',
          checkedInAt: '',
        });
        
        // Remove from current tab's data array
        if (this.activeTab === 'pending') {
          const index = this.pendingData.findIndex(el => el.id === item.id);
          if (index !== -1) {
            this.pendingData.splice(index, 1);
          }
        }
        const objIndex = this.allRecords.findIndex(el => el.id === item.id);
        if(objIndex !== -1) {
          this.$set(this.allRecords[objIndex], 'status', 'deferred');
        }
        // else if (this.activeTab === 'in-progress') {
        //   const index = this.inProgressData.findIndex(el => el.id === item.id);
        //   if (index !== -1) {
        //     this.inProgressData.splice(index, 1);
        //   }
        // }
        
        // Switch to deferred tab
        // this.changeTab('deferred');
        
        // Show success message
        this.showToast({
          message: `Migration for ${item.hostname} has been deferred`,
          duration: 3000
        }, true, 'success');
      } catch (error) {
        console.error('Error deferring migration:', error);
        this.showToast({
          message: `Error deferring migration: ${error.toString()}`,
          duration: 4000
        }, true, 'danger');
      }
    },
    formatDate(date) {
      return moment(date).format('DD MMM, YYYY HH:mm A')
    },
    togglePlan(plan) {
      const idx = this.selectedPlans.findIndex(p => p.value === plan.value);
      if (idx === -1) {
        this.selectedPlans = [...this.selectedPlans, plan];
      } else {
        this.selectedPlans = this.selectedPlans.filter(p => p.value !== plan.value);
      }
    },
    getBootstrapButtonClass(filter) {
      const isActive = this.selectedPriorityFilter === filter
      const colorMap = {
        'None': 'btn-primary',
        'R250B': 'btn-success',
        'R245': 'btn-info',
        'R252': 'btn-warning',
        'R147': 'btn-warning',
        'VPS152': 'btn-danger',
        'R150A': 'btn-danger',
        'R150B': 'btn-danger'
      }
      const baseClass = colorMap[filter] || 'btn-secondary'
      return isActive ? baseClass : `${baseClass} btn-link`
    },
    getStepButtonClass(step) {
      const isActive = this.selectedStep === step
      const colorMap = {
        'All': 'btn-default',
        'Create LXD VM': 'btn-primary',
        'Fetch Service Details': 'btn-success',
        'Update Disk': 'btn-info',
        'Start Migration': 'btn-warning',
        'Update IP': 'btn-danger',
        'Suspend VZ': 'btn-secondary',
        'Finish': 'btn-primary'
      }
      const baseClass = colorMap[step] || 'btn-secondary'
      return isActive ? baseClass : `${baseClass} btn-link`
    },
    toggleFilter(filter) {
      // toggle selected
      this.selectedPriorityFilter =
          this.selectedPriorityFilter === filter ? null : filter
    },
    getCurrentStep(item) {
      if(!item.steps) return
      const running = item.steps.find(el => el.status === 'running');
      const pending = item.steps.find(el => el.status === 'pending');
      const fail = item.steps.find(el => el.status === 'fail');
      if(running) {
        return running ? running : {}
      } else if(fail) {
        return fail ? fail : {}
      } else if(pending) {
        return pending ? pending : {}
      }
      return {name: '', status: ''};
    },
    async updateIP(item, row) {
      try {
        console.log(item, row)
        if(!row.cfEntIp) return
        this.$set(this.updateIpLoader, row.id, true)
        const resp = await this.$http.post('/lxd/n8n-apis-for-lxd-migration', {
          serviceId: item.serviceId,
          action: 'update-dns-record',
          grant_type: 'token',
          domain: row.domain,
          cfEntIp: row.cfEntIp,
        })
        console.log('resp', resp.data)
        row.cfEntResp = resp.data
        if(resp.data.success){
          await this.getIp(item,row)
          this.showToast({message: `You have successfully updated IP` , duration: 2000}, true, 'success')
        }
      } catch (e) {
        console.log('error',e)
        row.cfEntResp = e
        await db.collection('vzToLxdMigration').doc(item.id).update({domains: item.domains})
        this.$set(this.updateIpLoader, row.id, false)
      } finally {

      }

    },
    async getIp(item, row) {
      try {
        console.log(item)
        this.$set(this.updateIpLoader, row.id, true)
        const resp = await this.$http.post('/lxd/n8n-apis-for-lxd-migration', {
          action: 'get-dns-record',
          grant_type: 'token',
          domain: row.domain,
        })
        console.log('resp', resp.data)
        row.cfEntResp = resp.data
        row.cfEntIp = resp.data.current_ip
        if(resp.data.success){
          await db.collection('domains').doc(row.id).update({ cfEntIp: row.cfEntIp})
          await db.collection('vzToLxdMigration').doc(item.id).update({domains: item.domains})
        }
      } catch (e) {
        console.log('error',e)
        row.cfEntResp = e
        await db.collection('vzToLxdMigration').doc(item.id).update({domains: item.domains})
      } finally {
        this.$set(this.updateIpLoader, row.id, false)
        this.$set(this.updateIp, row.id, false)

      }

    },
    async getAllRecords() {
      // Only load records if allRecords is empty to avoid unnecessary reloads
      if (this.allRecords.length > 0) {
        this.allRecordsLoading = false;
        return;
      }
      
      this.allRecordsLoading = true;
      try {
        // Use a limit to prevent loading too many records at once
        // Only load what's needed for counts - we can aggregate from listeners instead
        const ref = await this.$patchStackService.post('/patchstack/fetch-migrations', {
          grant_type: 'token',
        })
        console.log('data for all records', ref.data)
        this.allRecords = ref.data.records
        // this.availableNodes = ref.data.nodes
      } catch (error) {
        console.error('Error loading all records:', error);
      } finally {
        this.allRecordsLoading = false;
      }
    },
    refreshData(data) {
      if(this.activeTab === 'pending') {
        console.log('data', data)
        const item = this.pendingData.find(el => el.id === data.id)
        if(item) {
          item.ticketAndNotes = data.ticketAndNotes
        }
        // this.getAllRecords()
      }
    },
    async getNameservers(domain) {
      try {
        const ns = await dns.resolveNs(domain);
        console.log('Nameservers:', ns);
        if(ns.length > 0) {
          const dt = ns[0]
          const parts = dt.split('.');
          const secondLast = parts[parts.length - 2];
          console.log(secondLast)
          return secondLast;
        }

        return ''
      } catch (err) {
        console.error('DNS lookup error:', err.message);
        return null;
      }
    },
    async checkServerForcefully(item) {
      try {
        this.checkingServer = item.id
        const resp = await this.$http.post('/lxd/check-server-forcefully', {
          grant_type: 'token',
          ip: item.lxdIp
        })
        console.log('resp of check server', resp.data.success)
        const stepIndex = item.steps.findIndex(el => el.name === 'Check if new server is ready')
        if (stepIndex !== -1) {
          if (resp.data && resp.data.success === 'true') {
            item.steps[stepIndex].status = 'complete'
            item.steps[stepIndex].apiResponse = JSON.stringify(resp.data)
          } else {
            item.steps[stepIndex].status = 'fail'
            item.steps[stepIndex].apiResponse = resp.data
          }
          await db.collection('vzToLxdMigration').doc(item.id).update({ steps: item.steps })
        }
      } catch (e) {
        console.error('checkServerForcefully', e)
        this.$notify({ group: 'foo', title: 'Error', text: 'Server check failed. Please try again.' })
      } finally {
        this.checkingServer = null
      }
    },
    async resetStep(item, row, stepIndex) {
      const fin = item.steps.find(el => el.name === row.name);
      if (fin) {
        fin.status = 'pending';
        this.$set(this.ensureOldIpEdit, `${item.id}_${stepIndex}`, false)
        this.$set(this.updateDiskStep, `${item.id}_${stepIndex}`, false)
        this.action = ''
        await db.collection('vzToLxdMigration').doc(item.id).update({steps: item.steps})
      }
    },
    async completeManually(item, row) {
      const fin = item.steps.find(el => el.name === row.name);
      if (fin) {
        fin.status = 'complete';
        fin.date = new Date().toISOString()
        await db.collection('vzToLxdMigration').doc(item.id).update({steps: item.steps})
      }
    },
    async saveNoteInTable(item, stepIndex) {
      this.$set(this.noteLoader, `${item.id}_${stepIndex}`, true)
      await db.collection('vzToLxdMigration').doc(item.id).update({ticketAndNotes: item.ticketAndNotes})
      this.$set(this.noteLoader, `${item.id}_${stepIndex}`, false)
      this.$set(this.enableNoteInput, `${item.id}_${stepIndex}`, false)
    },
    async saveDnsProvider(item, stepIndex) {
      this.$set(this.dnsProviderLoader, `${item.id}`, true)
      await db.collection('vzToLxdMigration').doc(item.id).update({dnsProvided: item.dnsProvided})
      this.getAllRecords()
      this.$set(this.dnsProviderLoader, `${item.id}`, false)
      this.$set(this.dnsProvider, `${item.id}`, false)
    },
    async savePreserveIp(item) {
      console.log('item', item)
      this.$set(this.preserveIpLoader, item.id, true)
      const preserveIp = !!item.preserveIp
      if(preserveIp) {
        const { location = '', lxdCluster = '', ipGroup = ''} = item
        if(location.toLowerCase() === 'ord' && lxdCluster.toLowerCase() === 'egv' && ipGroup.toLowerCase() !== 'steadfast') {
          item.steps = this.preserveIpSteps
          await db.collection('vzToLxdMigration').doc(item.id).update({ preserveIp, steps: this.preserveIpSteps  })
          this.getAllRecords()
        } else {
          item.preserveIp = !preserveIp
          swal(
              'Error!',
              `
              The IP can only be preserved if the following requirements are fulfilled:<br><br>
              <ul style="text-align:left;">
                <li>Source location must be <b>ORD</b></li>
                <li>IP group must not be <b>STEADFAST</b></li>
                <li>Destination location must be <b>EGV</b></li>
              </ul>
              `,
              'error'
          );
        }
      } else {
        await db.collection('vzToLxdMigration').doc(item.id).update({ preserveIp, steps: this.steps  })
        this.getAllRecords()
      }

      this.$set(this.preserveIpLoader, item.id, false)
      this.$set(this.preserveIpEdit, item.id, false)
    },
    openEnsureOldIpEdit(item, stepIndex) {
      if (!item.ensureOldIpAccessible) this.$set(item, 'ensureOldIpAccessible', 'no')
      this.$set(this.ensureOldIpEdit, `${item.id}_${stepIndex}`, true)
    },
    async saveEnsureOldIpAccessible(item, stepIndex) {
      const key = `${item.id}_${stepIndex}`
      this.$set(this.ensureOldIpLoader, key, true)
      try {
        await db.collection('vzToLxdMigration').doc(item.id).update({
          ensureOldIpAccessible: item.ensureOldIpAccessible === 'yes' ? 'yes' : 'no'
        })
        this.$set(this.ensureOldIpEdit, key, false)
        this.getAllRecords()
      } catch (e) {
        console.error('saveEnsureOldIpAccessible', e)
      }
      this.$set(this.ensureOldIpLoader, key, false)
    },
    async saveTargetHost(item, index) {
      this.$set(this.targetHostLoader, item.id, true)
      const resp = await this.$http.post('/lxd/add-target-host', {
        serviceId: item.serviceId,
        node: item.targetHostKey
      })
      console.log('resp', resp.data)
      if (resp.data.data.success) {
        await db.collection('vzToLxdMigration').doc(item.id).update({
          targetHost: item.targetHostKey,
          targetHostApiResponse: resp.data
        });
        this.$set(this.targetHostLoader, item.id, false)
        this.$set(this.addTargetHost, item.id, false)
      } else {
        this.$set(this.targetHostLoader, item.id, false)
        await db.collection('vzToLxdMigration').doc(item.id).update({targetHostApiResponse: resp.data});
      }
    },
    async saveLocation(item, index) {
      this.$set(this.setLocationLoader, item.id, true)
      if(!item.newLxdCluster) return
      item.lxdCluster = item.newLxdCluster;
      if(item.lxdCluster !== 'EGV' && item.preserveIp) {
        item.preserveIp = false
        item.steps = this.steps
        await db.collection('vzToLxdMigration').doc(item.id).update({
          lxdCluster: item.lxdCluster || 'IAD',
          preserveIp: item.preserveIp || false,
          steps: item.steps

        });
      } else {
        await db.collection('vzToLxdMigration').doc(item.id).update({
          lxdCluster: item.lxdCluster || 'IAD',
          preserveIp: item.lxdCluster === 'EGV' || false,
          steps: item.lxdCluster === 'EGV' ? this.preserveIpSteps : item.steps || this.steps
        });
      }

      this.$set(this.setLocationLoader, item.id, false)
      this.$set(this.setLocation, item.id, false)
    },
    async syncDomains(item) {

      this.$set(this.syncDomainLoader, item.id, true)
      const resp = await this.$http.post(`host-bill/sync-domains-for-vz-to-lxd-migration`, {
        grant_type: 'token',
        uid: item.uid,
        hostname: item.hostname,
        vzToLxdId: item.id,
        lxdIp: item.lxdIp,
        ip: item.ip,
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      console.log('resp', resp.data)
      if (this.activeTab === 'pending') {
        const ref = await db.collection('vzToLxdMigration').doc(item.id).get()
        const index = this.pendingData.findIndex(item => item.id === ref.id)
        if(index){
          this.$set(this.pendingData, index, {id: item.id, ...ref.data()});
        }
      }
      this.$set(this.syncDomainLoader, item.id, false)
      this.showToast({message: `You have successfully synchronized domains`, duration: 2000}, true, 'success')
    },
    progressGoToPage(pageNum) {
      this.progress.pageNumber = pageNum - 1;
    }, completeGoToPage(pageNum) {
      this.complete.pageNumber = pageNum - 1;
    },
    pendingjobs(docID) {
      if (this.pendingListener) {
        this.pendingListener()
      }
      console.log('running job')
      const query = db.collection('jobLogs')
          .where('jobName', 'in', ['update-ip', 'vz-to-lxd-migration'])

      this.pendingJobListener = query.onSnapshot(snapshot => {
        snapshot.docChanges().forEach((change) => {
          const {status} = change.doc.data()
          console.log('removing', change.type)
          if (status === 'Pending' || status === 'running') {
            if (change.type === 'added') {
              this.processingDomainList.push({...change.doc.data(), id: change.doc.id})
            }
          }
          if (change.type === 'removed' || change.type === 'modified') {
            if (status === 'complete') {
              this.processingDomainList = this.processingDomainList.filter(d => d.id !== change.doc.id)
            }
          }
        })
      });
    },

    getStartText(step, obj) {
      let text = ''
      return step.name
    },
    async initiateProcess(item, index) {
      this.selectedIndex = index;
      this.action = 'initialStart';
      await db.collection('vzToLxdMigration').doc(item.id).update({steps: this.steps})
      await this.handleAction(item, index, 'Create LXD VM')
    },
    async refreshCF(domainData, row, all = false) {
      console.log('refreshCF', domainData, row);
      if (all) {
        this.$set(this.refreshCf, row.id, true)
        const resp = await this.$http.post(`utilities/updateCFStatusForAllDomains`, {
          grant_type: 'token',
          uid: row.uid
        }, {
          headers: {
            'Content-Type': 'application/json',
          }
        });
        const finalDomain = []
        for (const d of row.domains) {
          const domainRef = await db.collection('domains').doc(d.id).get();
          if (domainRef.exists) {
            const {cf} = domainRef.data();
            console.log('cf', cf)
            d.cf = cf || false
          }
          finalDomain.push(d)
        }
        await db.collection('vzToLxdMigration').doc(row.id).update({domains: finalDomain});

        this.showToast({
          message: `You have successfully refreshed the CF status for the whole plan.`,
          duration: 2000
        }, true, 'success')

        this.$set(this.refreshCf, row.id, false)

      } else {
        this.$set(this.refreshCf, domainData.id, true)
        const res = await this.$http.post(`utilities/updateCFStatusForDomain`, {
          grant_type: 'token',
          domain: domainData.domain,
          uid: row.uid
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        const domainRef = await db.collection('domains').doc(domainData.id).get();
        if (domainRef.exists) {
          const {cf} = domainRef.data();
          console.log('cf', cf)
          const domainFromRow = row.domains.find(el => el.id === domainData.id)
          if (domainFromRow) {
            domainFromRow.cf = cf || false
            await db.collection('vzToLxdMigration').doc(row.id).update({domains: row.domains});
          }
        }
        this.showToast({
          message: `You have successfully refreshed the CF status for ${domainData.domain}.`,
          duration: 2000
        }, true, 'success')
        this.$set(this.refreshCf, domainData.id, false)
      }
    },
    async runQuery(ref, startAfterValue) {
      let q = ref.orderBy('createdAt', 'desc').limit(this.pageSize + 1);

      if (startAfterValue) {
        q = q.startAfter(startAfterValue);
      }
      const snap = await q.get();
      console.log('docs length',snap )
      if(snap.size > 0) {
        if (snap.size > this.pageSize) {
          this.hasNextPage = true;
          snap.docs.pop(); // remove extra record
        } else {
          this.hasNextPage = false;
        }
      }
      console.log('this.hasNextPage', this.hasNextPage)
      return snap.empty ? null : snap;
    },
    /**
     * Iteratively fetch pending records from Firestore in batches and collect
     * up to (pageSize + 1) matches that have no rack and no node. Used by the
     * UNCATEGORIZED priority filter, where Firestore can't directly query for
     * "missing field" with multiple conditions, so we over-fetch and filter
     * client-side. Returns up to pageSize+1 matching records (the +1 is used
     * by the caller to detect whether there's a next page).
     */
    async fetchUncategorizedPendingPage(startAfterValue) {
      const BATCH_SIZE = 100;
      const targetCount = this.pageSize + 1;
      const matches = [];

      let baseRef = db
          .collection('vzToLxdMigration')
          .where('status', '==', 'pending');

      if (this.selectedPlanValues.length === 1) {
        baseRef = baseRef.where('planName', '==', this.selectedPlanValues[0]);
      } else if (this.selectedPlanValues.length > 1) {
        baseRef = baseRef.where('planName', 'in', this.selectedPlanValues);
      }
      if (this.selectedIpGroup !== 'all') {
        baseRef = baseRef.where('ipGroup', '==', this.selectedIpGroup);
      }
      if (this.dnsProvided !== 'all') {
        baseRef = baseRef.where('dnsProvided', '==', this.dnsProvided);
      }
      if (this.dnsTicketCreated !== 'all') {
        baseRef = baseRef.where('dnsTicketCreated', '==', this.dnsTicketCreated);
      }

      let cursor = startAfterValue || null;
      let hasMoreServerData = true;

      while (matches.length < targetCount && hasMoreServerData) {
        let q = baseRef.orderBy('createdAt', 'desc').limit(BATCH_SIZE);
        if (cursor) {
          q = q.startAfter(cursor);
        }
        const snap = await q.get();

        if (snap.empty) {
          hasMoreServerData = false;
          break;
        }
        if (snap.size < BATCH_SIZE) {
          hasMoreServerData = false;
        }

        for (const doc of snap.docs) {
          const data = { id: doc.id, ...doc.data() };
          if (!data.rack && !data.nodeName) {
            matches.push(data);
            if (matches.length >= targetCount) break;
          }
        }

        // Advance cursor to the last RAW doc fetched (regardless of match)
        // so the next batch continues from there.
        cursor = snap.docs[snap.docs.length - 1].data().createdAt;
      }

      return matches;
    },
    async fetchPending() {
      this.loader = true;
      this.pageNumber = 0;
      this.noLogs = false;
      this.pendingData = [];

      const isUncategorized = this.selectedRack === 'UNCATEGORIZED';

      // UNCATEGORIZED pagination: dedicated batched fetch path.
      if (isUncategorized) {
        try {
          this.uncategorizedPageCursors = [null];
          const matches = await this.fetchUncategorizedPendingPage(null);
          this.hasNextPage = matches.length > this.pageSize;
          this.pendingData = matches.slice(0, this.pageSize);
          if (!this.pendingData.length) this.noLogs = true;
        } catch (err) {
          console.error('fetchPending (uncategorized) error:', err);
        } finally {
          this.loader = false;
          this.$nextTick(() => {
            $('[data-toggle="tooltip"]').tooltip();
          });
        }
        return;
      }

      try {
        let baseRef = db
            .collection('vzToLxdMigration')
            .where('status', '==', 'pending');

        // normal filters
        if (this.selectedPlanValues.length === 1) {
          baseRef = baseRef.where('planName', '==', this.selectedPlanValues[0]);
        } else if (this.selectedPlanValues.length > 1) {
          baseRef = baseRef.where('planName', 'in', this.selectedPlanValues);
        }
        if (!isUncategorized && this.selectedNode !== 'all') {
          baseRef = baseRef.where('nodeName', '==', this.selectedNode);
        }
        if (!isUncategorized && this.selectedRack !== 'all') {
          baseRef = baseRef.where('rack', '==', this.selectedRack);
        }
        if (this.selectedIpGroup !== 'all') {
          baseRef = baseRef.where('ipGroup', '==', this.selectedIpGroup);
        }
        if (this.dnsProvided !== 'all') {
          baseRef = baseRef.where('dnsProvided', '==', this.dnsProvided);
        }
        if (this.dnsTicketCreated !== 'all') {
          baseRef = baseRef.where('dnsTicketCreated', '==', this.dnsTicketCreated);
        }

        let docs = null;

        // 🔍 SEARCH FALLBACK LOGIC
        if (this.selectedSearch) {
          const searchFields = [
            'serviceId',
            'hostname',
            'ip',
            'lxdIp',
            'planName',
          ];

          for (const field of searchFields) {
            const ref = baseRef.where(field, '==', this.selectedSearch);
            console.log('ref made', ref, this.selectedSearch)
            docs = await this.runQuery(ref);
            if (docs) break; // stop at first match
          }
        } else {
          console.log('calling in else query')
          docs = await this.runQuery(baseRef);
        }
        if (!docs) {
          this.noLogs = true;
          return;
        }
        this.pendingData = []
        docs.forEach(doc => {
          this.pendingData.push({
            id: doc.id,
            ...doc.data()
        });
        });

        // UNCATEGORIZED sentinel: keep only records with no rack and no node
        if (isUncategorized) {
          this.pendingData = this.pendingData.filter(item => !item.rack && !item.nodeName);
        }

      } catch (err) {
        console.error(err);
      } finally {
        this.loader = false;
        this.$nextTick(() => {
          $('[data-toggle="tooltip"]').tooltip();
        });
      }
    },
    async nextPage() {
      if (!this.last) return;

      const isUncategorized = this.selectedRack === 'UNCATEGORIZED';

      // UNCATEGORIZED pagination: dedicated batched fetch path.
      if (isUncategorized) {
        if (!this.hasNextPage) return;
        const startAfter = this.last.createdAt;
        // Save the cursor that maps to the page we are about to load,
        // so prevPage can return to it.
        this.uncategorizedPageCursors[this.pageNumber + 1] = startAfter;
        this.pageNumber++;
        this.loader = true;
        this.noLogs = false;
        try {
          const matches = await this.fetchUncategorizedPendingPage(startAfter);
          this.hasNextPage = matches.length > this.pageSize;
          this.pendingData = matches.slice(0, this.pageSize);
          if (!this.pendingData.length) this.noLogs = true;
        } catch (err) {
          console.error('nextPage (uncategorized) error:', err);
        } finally {
          this.loader = false;
        }
        return;
      }

      this.pageNumber++;
        this.loader = true;
      this.noLogs = false;

      try {
        let baseRef = db
            .collection('vzToLxdMigration')
            .where('status', '==', 'pending');

        // normal filters
            if (this.selectedPlanValues.length === 1) {
          baseRef = baseRef.where('planName', '==', this.selectedPlanValues[0]);
        } else if (this.selectedPlanValues.length > 1) {
          baseRef = baseRef.where('planName', 'in', this.selectedPlanValues);
        }
        if (!isUncategorized && this.selectedNode !== 'all') {
          baseRef = baseRef.where('nodeName', '==', this.selectedNode);
        }if (!isUncategorized && this.selectedRack !== 'all') {
          baseRef = baseRef.where('rack', '==', this.selectedRack);
        }
        if (this.selectedIpGroup !== 'all') {
          baseRef = baseRef.where('ipGroup', '==', this.selectedIpGroup);
        }
        if (this.dnsProvided !== 'all') {
          baseRef = baseRef.where('dnsProvided', '==', this.dnsProvided);
        }
        if (this.dnsTicketCreated !== 'all') {
          baseRef = baseRef.where('dnsTicketCreated', '==', this.dnsTicketCreated);
        }

        let docs = null;

        // 🔍 SEARCH FALLBACK
        if (this.selectedSearch) {
          const searchFields = ['servicsId','hostname', 'ip', 'lxdIp', 'planName'];

          for (const field of searchFields) {
            const ref = baseRef.where(field, '==', this.selectedSearch);
            docs = await this.runQuery(ref, this.last.createdAt);
            if (docs) break;
          }
          } else {
          docs = await this.runQuery(baseRef, this.last.createdAt);
        }

        if (!docs) {
            this.noLogs = true;
          return;
          }

          this.pendingData = [];
          docs.forEach(doc => {
            this.pendingData.push({
              id: doc.id,
              ...doc.data()
          });
        });

        // UNCATEGORIZED sentinel: keep only records with no rack and no node
        if (isUncategorized) {
          this.pendingData = this.pendingData.filter(item => !item.rack && !item.nodeName);
        }

        // update cursor
        // this.last = docs.docs[docs.docs.length - 1];

        } catch (err) {
        console.error('nextPage error:', err);
        } finally {
        this.loader = false;
      }
    },
    async prevPage() {
      if (!this.first) return;

      const isUncategorized = this.selectedRack === 'UNCATEGORIZED';

      // UNCATEGORIZED pagination: dedicated batched fetch path.
      if (isUncategorized) {
        if (this.pageNumber === 0) return;
        this.pageNumber--;
        this.loader = true;
        this.noLogs = false;
        try {
          const startAfter = this.uncategorizedPageCursors[this.pageNumber] || null;
          const matches = await this.fetchUncategorizedPendingPage(startAfter);
          this.hasNextPage = matches.length > this.pageSize;
          this.pendingData = matches.slice(0, this.pageSize);
          if (!this.pendingData.length) this.noLogs = true;
        } catch (err) {
          console.error('prevPage (uncategorized) error:', err);
        } finally {
          this.loader = false;
        }
        return;
      }

      this.pageNumber--;
        this.loader = true;
      this.noLogs = false;

      try {
        let baseRef = db
            .collection('vzToLxdMigration')
            .where('status', '==', 'pending');

        // common filters
            if (this.selectedPlanValues.length === 1) {
          baseRef = baseRef.where('planName', '==', this.selectedPlanValues[0]);
        } else if (this.selectedPlanValues.length > 1) {
          baseRef = baseRef.where('planName', 'in', this.selectedPlanValues);
        }
        if (!isUncategorized && this.selectedNode !== 'all') {
          baseRef = baseRef.where('nodeName', '==', this.selectedNode);
        } if (!isUncategorized && this.selectedRack !== 'all') {
          baseRef = baseRef.where('rack', '==', this.selectedRack);
        }
        if (this.selectedIpGroup !== 'all') {
          baseRef = baseRef.where('ipGroup', '==', this.selectedIpGroup);
        }
        if (this.dnsProvided !== 'all') {
          baseRef = baseRef.where('dnsProvided', '==', this.dnsProvided);
        }
        if (this.dnsTicketCreated !== 'all') {
          baseRef = baseRef.where('dnsTicketCreated', '==', this.dnsTicketCreated);
        }

        let docs = null;

        // 🔍 SEARCH FALLBACK
        if (this.selectedSearch) {
          const searchFields = ['serviceId','hostname', 'ip', 'lxdIp', 'planName'];

          for (const field of searchFields) {
            const ref = baseRef.where(field, '==', this.selectedSearch);

            const snap = await ref
                .orderBy('createdAt', 'desc')
                .endBefore(this.first.createdAt)
                .limitToLast(this.pageSize + 1)
                .get();

            if (!snap.empty) {
              docs = snap;
              break;
            }
          }
          } else {
          docs = await baseRef
              .orderBy('createdAt', 'desc')
                .endBefore(this.first.createdAt)
                .limitToLast(this.pageSize + 1)
              .get();
          }

        if (!docs || docs.empty) {
            this.noLogs = true;
          return;
          }
        if (docs.size > this.pageSize) {
          this.hasNextPage = true;
          docs.docs.shift(); // remove the extra first doc for correct page
        } else {
          this.hasNextPage = false;
        }
        console.log('docs of next page', this.hasNextPage)
          this.pendingData = [];
          docs.forEach(doc => {
            this.pendingData.push({
              id: doc.id,
              ...doc.data()
          });
        });

        // UNCATEGORIZED sentinel: keep only records with no rack and no node
        if (isUncategorized) {
          this.pendingData = this.pendingData.filter(item => !item.rack && !item.nodeName);
        }

        // update cursors
        // this.first = docs.docs[0];
        // this.last = docs.docs[docs.docs.length - 1];

      } catch (err) {
        console.error('prevPage error:', err);
      } finally {
        this.loader = false;
      }
    },
    checkCFStatus(item) {
      if (!item.domains || item.domains.length === 0) return false;
      const bigscootsDomains = item.domains.filter(el => el.tagCategories && el.tagCategories.find(tag => tag.tag.toLowerCase() === 'bigscoots'));
      const cfFlags = bigscootsDomains.every(el => el.cf)
      // const nerdPressTag = item.domains.find(el => el.tagCategories && el.tagCategories.find(tag => tag.tag.toLowerCase() === 'nerdpress'))
      return cfFlags
    },
    emailHashGravatar(email) {
      if (!email) {
        return null
      } else {
        return md5(email.trim().toLowerCase()).toString()
      }
    },
    getTitle(item, index) {
      if (this.action === 'start' && this.selectedIndex === index) {
        return 'Creating LXD VM'
      } else if (this.action === 'run_bash') {
        return 'Running Bash for Migration'
      }
    },
    getStep(title, item) {
      if (!item.steps) {
        item.steps = [];
      }
      const obj = item.steps.find(el => el.name === title && el.status === 'complete')
      return !!obj
    },
    getStepFromTitle(title, item) {
      if (!item.steps) {
        item.steps = [];
      }
      const obj = item.steps.find(el => el.name === title)
      return obj
    },
    changeTab(tab) {
      this.activeTab = tab;
    },
    getCurrentTableId() {
      const tableIds = {
        'pending': 'pending-table',
        'in-progress': 'in-progress-table',
        'complete': 'complete-table'
      };
      return tableIds[this.activeTab] || 'pending-table';
    },
    getVzDisk(disk) {
      const used = (disk.used / Math.pow(1024, 3)).toFixed(2) + 'GB';
      const total = (disk.total / Math.pow(1024, 3)).toFixed(2) + 'GB';
      return `${used} / ${total}`;
    },
    convertDisk(disk = 0) {
      return Number((disk / Math.pow(1024, 3)).toFixed(2));
    },
    initializeTable() {
      // Initialize nodes list from all data
      this.loadAvailableNodes();
      // Initialize the active tab listener
      this.initializeTabListener(this.activeTab);
    },
    cleanupTabListener(tab) {
      console.log('cleanupTabListener', tab);
      if (tab === 'in-progress' && this.inProgressListener) {
        this.inProgressListener();
        this.inProgressListener = null;
      } else if (tab === 'complete' && this.completeListener) {
        this.completeListener();
        this.completeListener = null;
      } else if (tab === 'deferred' && this.deferredListener) {
        this.deferredListener();
        this.deferredListener = null;
      }
    },
    initializeTabListener(tab) {
      this.loader = true;
      if (tab === 'pending') {
        this.fetchPending()
        // this.setupPendingListener();
      } else if (tab === 'in-progress') {
        this.setupInProgressListener();
      } else if (tab === 'complete') {
        this.setupCompleteListener();
      } else if (tab === 'deferred') {
        this.setupDeferredListener();
      }
    },
    async setupPendingListener() {
      if (this.pendingListener) return; // Already set up
      this.pendingData = []
      this.pendingListener = await db.collection('vzToLxdMigration').where('status', '==', 'pending').limit(100).onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(changeDoc => {
          if (changeDoc.type === 'added') {
            this.pendingData.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
          }
          if (changeDoc.type === 'modified') {
            const data = {id: changeDoc.doc.id, ...changeDoc.doc.data()}
            let taskToUpdate = this.pendingData.find((task) => task.id === data.id);
            const allKeys = Object.keys(data);
            for (const key of allKeys) {
              taskToUpdate[key] = data[key];
            }
          }
          if (changeDoc.type === 'removed') {
            this.pendingData = this.pendingData.filter(el => el.id !== changeDoc.doc.id)
          }

        });
        this.loader = false;
      });
      // Listen to all documents and filter by status client-side
    },
    async setupInProgressListener() {
      if (this.inProgressListener) return; // Already set up
      this.inProgressData = []
      this.inProgressListener = await db.collection('vzToLxdMigration').where('status', '==', 'in-progress').onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(changeDoc => {
          const {vz} = changeDoc.doc.data();

          if (changeDoc.type === 'added') {
            this.inProgressData.push({
              id: changeDoc.doc.id, ...changeDoc.doc.data(),
              updatedDisk: vz && vz.hdd ? vz.total : 0
            })
          }
          if (changeDoc.type === 'modified') {
            const data = {id: changeDoc.doc.id, ...changeDoc.doc.data()}
            let taskToUpdate = this.inProgressData.find((task) => task.id === data.id);
            const preservedDisk = taskToUpdate ? taskToUpdate.updatedDisk : (vz && vz.hdd ? vz.total : 0);

            const allKeys = Object.keys(data);
            for (const key of allKeys) {
              taskToUpdate[key] = data[key];
            }
            taskToUpdate['updatedDisk'] = preservedDisk;
          }
          if (changeDoc.type === 'removed') {
            this.inProgressData = this.inProgressData.filter(el => el.id !== changeDoc.doc.id)
          }

        });
        this.loader = false;
      });
    },
    async setupCompleteListener() {
      if (this.completeListener) return; // Already set up

      this.completeData = []
      this.completeListener = await db.collection('vzToLxdMigration').where('status', '==', 'complete').onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(changeDoc => {
          if (changeDoc.type === 'added') {
            this.completeData.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
          }
          if (changeDoc.type === 'modified') {
            const data = {id: changeDoc.doc.id, ...changeDoc.doc.data()}
            let taskToUpdate = this.completeData.find((task) => task.id === data.id);
            const allKeys = Object.keys(data);
            for (const key of allKeys) {
              taskToUpdate[key] = data[key];
            }
          }
          if (changeDoc.type === 'removed') {
            this.completeData = this.completeData.filter(el => el.id !== changeDoc.doc.id)
          }

        });
        this.loader = false;
      });
    },
    async setupDeferredListener() {
      if (this.deferredListener) return; // Already set up

      this.deferredData = []
      this.deferredListener = await db.collection('vzToLxdMigration').where('status', '==', 'deferred').onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(changeDoc => {
          const {vz} = changeDoc.doc.data();

          if (changeDoc.type === 'added') {
            this.deferredData.push({
              id: changeDoc.doc.id, ...changeDoc.doc.data(),
              updatedDisk: vz && vz.hdd ? vz.total : 0
            })
          }
          if (changeDoc.type === 'modified') {
            const data = {id: changeDoc.doc.id, ...changeDoc.doc.data()}
            let taskToUpdate = this.deferredData.find((task) => task.id === data.id);
            const preservedDisk = taskToUpdate ? taskToUpdate.updatedDisk : (vz && vz.hdd ? vz.total : 0);

            const allKeys = Object.keys(data);
            for (const key of allKeys) {
              taskToUpdate[key] = data[key];
            }
            taskToUpdate['updatedDisk'] = preservedDisk;
          }
          if (changeDoc.type === 'removed') {
            this.deferredData = this.deferredData.filter(el => el.id !== changeDoc.doc.id)
          }

        });
        this.loader = false;
      });
    },

    renderDatatable(tableId) {
      // Prevent multiple simultaneous renders
      if (this.isRenderingTable) {
        return;
      }
      
      const self = this; // Capture Vue instance
      // this.isRenderingTable = true;

      // Ensure DataTable is fully destroyed safely
      if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
        $(`#${tableId}`).DataTable().destroy();
      }
      
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });

      // Wait for Vue to update DOM, then initialize DataTable with current DOM state
      setTimeout(function () {
        $(`#${tableId}`).dataTable({
          pagingType: "full_numbers",
          paging: true,
          destroy: true,
          retrieve: true,
          deferRender: true,
          stateSave: false,
          "bInfo": false,
          "ordering": true,
          "columnDefs": [
            {"orderable": false, "targets": [0]} // Disable sorting on the first and third columns
          ],
          initComplete: function () {
            let api = this.api();
            $('.dataTables_filter input').on('input', function () {
              let newValue = $(this).val().replace(/\s/g, ''); // Remove spaces
              $(this).val(newValue);
              api.search(newValue).draw();
            });
          }
        });
      }, 0)
    },
    getStatusClass(status) {
      const statusLower = (status || '').toLowerCase()
      if (statusLower === 'complete' || statusLower === 'active') {
        return 'badge badge-pill badge-rounded badge-success'
      } else if (statusLower === 'pending') {
        return 'badge badge-pill badge-rounded badge-warning'
      } else if (statusLower === 'in-progress' || statusLower === 'in progress') {
        return 'badge badge-pill badge-rounded badge-info'
      } else if (statusLower === 'failed' || statusLower === 'error') {
        return 'badge badge-pill badge-rounded badge-danger'
      }
      return 'badge badge-pill badge-rounded badge-secondary'
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    async fetchServiceDetailsWithRetry(item, steps) {
      const maxRetries = 3; // total attempts
      let attempt = 0;

      while (attempt < maxRetries) {
        attempt++;

        console.log(`🔄 Attempt ${attempt} to fetch service details...`);

        const resp = await this.$http.post('/host-bill/get-service-details', {
          grant_type: 'token',
          serviceId: item.serviceId
        });

        if (resp.data.success) {
          const data = resp.data.data;

          // If lxdIp or lxdNode found → SUCCESS, return data
          if (data.lxdIp && data.lxdNode) {
            console.log("✅ Got full service details");
            return data;
          }

          // If missing → wait & retry
          console.log(`⚠ Missing lxdIp or lxdNode. Waiting 20 seconds before retry...`);

          if (attempt < maxRetries) {
            await this.sleep(20000);
            continue;
          }

          console.log("❌ Missing even after retry");
          return null;
        }

        // API itself failed → retry
        console.log("⚠ API failed. Waiting 20 sec before retry...");
        await this.sleep(20000);
      }

      console.log("❌ Failed after 2 attempts");
      return null;
    },
    async updateStep(title, item, step) {
      console.log(title)
      const index = item.steps.findIndex(el => el.name === title);
      if (index !== -1) {
        item.steps.splice(index, 1, step); // replace without shifting
      }
      await db.collection('vzToLxdMigration').doc(item.id).update({steps: item.steps })
    },
    isStepDisabled(index, item) {
      const obj = this.processingDomainList.find(el => el.jobData.UID === item.uid);
      for (let i = 0; i < index; i++) {
        if (item.steps[i].status !== 'complete' || !!obj) return true;
      }
      return false;
    },
    /** True if Create LXD VM is running on any other item (blocks starting it elsewhere until complete) */
    isCreateLxdVmRunningOnOtherItem(currentItem) {
      const allItemsWithSteps = [...this.inProgressData, ...this.completeData, ...this.deferredData];
      const createStepName = 'Create LXD VM';
      return allItemsWithSteps.some(other => {
        if (other.id === currentItem.id) return false;
        const step = other.steps && other.steps.find(s => s.name === createStepName);
        return step && step.status === 'running' && this.user.email !== 'khan@bigscoots.com' && other.checkedInBy === `${this.user.firstName} ${this.user.lastName}` ;
      });
    },
    checkLxdSettings(item) {
      let flag = false
      const {planName, lxdCluster} = item;
      if(lxdCluster && lxdCluster.toLowerCase() === 'iad') {
        if((this.wpoNodesPlans.includes(planName) && !this.lxdSettings.iad.wpoNodes) ||
            (!this.wpoNodesPlans.includes(planName) && !this.lxdSettings.iad.vpsNodes)) {
          flag = true;
        }
      }if(lxdCluster && lxdCluster.toLowerCase() === 'egv') {
        console.log('inside func',!this.wpoNodesPlans.includes(planName)  )
        if((this.wpoNodesPlans.includes(planName) && !this.lxdSettings.egv.wpoNodes) ||
            (!this.wpoNodesPlans.includes(planName) && !this.lxdSettings.egv.vpsNodes)) {
          flag = true;
        }
      }
      console.log('flag for lxd', flag)
      return flag;
    },
    async fetchServiceDetailStep(item, index, title, resolveForcefully = false) {
      const fetchServiceDets = this.getStepFromTitle('Fetch Service Details', item)
      try {
        fetchServiceDets.status = 'running'
        fetchServiceDets.start = new Date().toISOString()
        await this.updateStep('Fetch Service Details', item, fetchServiceDets)
        const responseData = await this.fetchServiceDetailsWithRetry(item);
        if (responseData) {
          fetchServiceDets.status = 'complete'
          fetchServiceDets.end = new Date().toISOString()
          fetchServiceDets.apiResponse = responseData;
          item.lxdIp = responseData.lxdIp || '';
          item.lxdNode = responseData.lxdNode || '';
          const consul = await this.$http.post('/lxd/n8n-apis-for-lxd-migration', {
            action: 'get-info-from-consul',
            serviceId: item.serviceId,
            grant_type: 'token',
            vzToLxdId: item.id
          })
          if(consul.data.success) {
            const { ServiceMeta } = consul.data.data
            item.lxdName = ServiceMeta.lxd_instance_name || '';
            item.lxdCluster = ServiceMeta.datacenter;
            // item.location = ServiceMeta.datacenter;
          }
          if(item.lxdCluster && item.lxdCluster.toLowerCase() !== 'egv' && item.preserveIp) {
            item.steps = [...item.steps.slice(0,4), ...this.steps.slice(-3)]
            item.preserveIp = false
          }
          await db.collection('vzToLxdMigration').doc(item.id).update(item)
        } else {
          fetchServiceDets.status = 'fail'
          fetchServiceDets.end = new Date().toISOString()
          fetchServiceDets.apiResponse = responseData;
        }
        await this.updateStep('Fetch Service Details', item, fetchServiceDets)
      } catch (e) {
        fetchServiceDets.apiResponse = e || {};
        fetchServiceDets.status = 'fail'
        fetchServiceDets.end = new Date().toISOString()

        await this.updateStep('Fetch Service Details', item, fetchServiceDets)

      } finally {
        this.action = '';
      }
      // return item;

    },
    async suspendVZStep(title, item, resolveForcefully) {
      const suspend = this.getStepFromTitle(title, item)
      if (resolveForcefully) {
        suspend.status = 'complete'
        suspend.start = new Date().toISOString()
        suspend.end = new Date().toISOString()
        await this.updateStep(title, item, suspend)
        this.action = ''
        return
      }
      suspend.status = 'complete'
      suspend.start = new Date().toISOString()
      await this.updateStep(title, item, suspend)
      
      const resp = await this.$http.post('host-bill/suspend-vz', {
        grant_type: "token",
        solusVpsId: item.vz.solusVM_VPS_ID || '',
        hostname: item.hostname,
        action: 'suspend'
      });
      suspend.apiResponse = resp.data;
      suspend.status = 'complete'
      suspend.end = new Date().toISOString()
      await this.updateStep(title, item, suspend)
      this.action = ''
    },
    async runARPing(title, item) {
      const step = this.getStepFromTitle(title, item)
      try {
        step.status = 'running'
        step.start = new Date().toISOString()
        await this.updateStep(title, item, step)
        const resp = await this.$http.post('/lxd/preserve-ip-bash-commands', {
          grant_type: 'token',
          action: 'arping',
          ip: item.ip,
          newIP: item.lxdIp,
          UID: item.uid,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          vzToLxdId: item.id,
        })
        if(resp.data.success) {
          step.status = 'complete'
          step.apiResponse = resp.data
          step.end = new Date().toISOString()
          await this.updateStep(title, item, step)
        }
      } catch (e) {
        step.apiResponse = e || {};
        step.status = 'fail'
        step.end = new Date().toISOString()

        await this.updateStep(title, item, step)
      } finally {
        this.action = ''
      }

    },
    async openUpdateDisk(item, stepIndex) {
      this.$set(item, 'fetchingDisk', true)
      this.$set(this.updateDiskStep, `${item.id}_${stepIndex}`, true)
      try {
        const resp = await this.$http.post('/lxd/get-disk-size', {
          grant_type: 'token',
          ip: item.ip,
        })
        if (resp.data && resp.data.diskSizeGB) {
          this.$set(item, 'updatedDisk', resp.data.diskSizeGB)
        }
      } catch (e) {
        console.error('get-disk-size error', e)
      } finally {
        this.$set(item, 'fetchingDisk', false)
      }
    },
    async handleAction(item, index, title, resolveForcefully = false, newMigrationScript = false) {
      console.log(item, title);
      // Handle action button click
      this.selectedIndex = index;
      this.action = title
      let disk = 0
      if(title === 'Update Disk') {
        disk = item.updatedDisk
      }
      console.log('Action clicked for:', item)
      if (title === 'Create LXD VM') {
        if(item.ip && item.lxdIp && item.lxdIp === item.ip) {
          this.showToast({message: 'It appears to already exist in LXD.', duration: 2000}, true, 'danger');
          return
        }
        let steps = []
        const getStep = this.getStepFromTitle(title, item);
        getStep.status = 'running'
        getStep.start = new Date().toISOString()
        await this.updateStep(title, item, getStep)
        console.log('starting the initial step')
        try {
          const response = await this.$http.post('/lxd/n8n-apis-for-lxd-migration', {
            action: 'create-lxd-vm',
            grant_type: 'token',
            serviceId: item.serviceId,
            datacenter: item.lxdCluster || 'IAD',
            vzToLxdId: item.id
          })
          if (response.data.success) {
            getStep.status = 'complete'
            getStep.apiResponse = response.data
            getStep.end = new Date().toISOString()
            await this.updateStep(title, item, getStep)
            console.log(item)
            this.action = 'Fetch Service Details'
            await this.fetchServiceDetailStep(item,index,title,resolveForcefully)
            } else {
            getStep.status = 'fail'
            getStep.apiResponse = response.data
            getStep.end = new Date().toISOString()
            await this.updateStep(title, item, getStep)
          }
        } catch (e) {
          console.log('error on step 1', e)
          getStep.status = 'fail'
          getStep.end = new Date().toISOString()
          await this.updateStep(title, item, getStep)
        }
        this.action = '';
      } else if (title === 'Fetch Service Details') {
        await this.fetchServiceDetailStep(item,index,title,resolveForcefully)
      } else if (title === 'Update Disk') {
        const updatedisk = this.getStepFromTitle(title, item)
        if (resolveForcefully) {
          updatedisk.status = 'complete'
          updatedisk.start = new Date().toISOString()
          updatedisk.end = new Date().toISOString()
          await this.updateStep(title, item, updatedisk)
          this.action = ''
          return
        }
        updatedisk.status = 'running'
        updatedisk.start = new Date().toISOString()
        await this.updateStep(title, item, updatedisk)
        console.log(item.updatedDisk)
        console.log(disk, item.updatedDisk)
        const respofdisk = await this.$http.post('/lxd/instance/action', {
          grant_type: 'token',
          action: 'resize',
          cluster: item.lxdCluster,
          name: item.lxdName,
          useNewApi: this.lxdSettings.other.useNewApi,
          vzToLxdId: item.id,
          data: {
            size: disk,
          }
        })
        if (respofdisk.data.success) {
          updatedisk.status = 'complete'
          updatedisk.end = new Date().toISOString()
          updatedisk.apiResponse = respofdisk.data
          await this.updateStep(title, item, updatedisk)
          item.lxdDisk = {
            ...item.lxdDisk,
            disk: respofdisk.data.data.new_size
          }
          await db.collection('vzToLxdMigration').doc(item.id).update({lxdDisk: item.lxdDisk})
        }
        this.action = ''
      } else if (title === 'Capture Backup Cron') {
        const step = this.getStepFromTitle(title, item)
        step.status = 'running'
        step.start = new Date().toISOString()
        await this.updateStep(title, item, step)
        try {
          const resp = await this.$http.post('/lxd/backup-cron', {
            grant_type: 'token',
            ip: item.ip,
            vzToLxdId: item.id,
          })
          if (resp.data.success) {
            step.status = 'complete'
            step.apiResponse = resp.data
            step.end = new Date().toISOString()
            await this.updateStep(title, item, step)
          } else {
            step.status = 'fail'
            step.apiResponse = resp.data
            step.end = new Date().toISOString()
            await this.updateStep(title, item, step)
          }
        } catch (e) {
          step.status = 'fail'
          step.apiResponse = { success: false, error: e.message }
          step.end = new Date().toISOString()
          await this.updateStep(title, item, step)
        }
        this.action = ''
      } else if (title === 'Start Migration') {
        const startMigration = this.getStepFromTitle(title, item)
        startMigration.status = 'running'
        startMigration.start = new Date().toISOString()
        await this.updateStep(title, item, startMigration)
        const migrationBash = await this.$http.post('/host-bill/run-bash-for-migration2', {
          grant_type: 'token',
          sourceIp: item.ip,
          destinationIp: item.lxdIp,
          ip: item.ip,
          vzToLxdId: item.id,
          UID: item.uid,
          sourceUid: item.uid,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          newMigrationScript
        })
        // if(migrationBash.data.success) {x
        //   startMigration.status = 'complete'
        //   startMigration.apiResponse = migrationBash.data
        //   await this.updateStep(title, item, startMigration)
        // }
        this.action = ''
      } else if (title === 'Add OLD IP as Secondary') {
        const step = this.getStepFromTitle(title, item)
        step.status = 'running'
        step.start = new Date().toISOString()
        await this.updateStep(title, item, step)
        const resp = await this.$http.post('/lxd/n8n-apis-for-lxd-migration', {
          grant_type: 'token',
          action: 'add-old-ip-as-secondary',
          useNewApi: this.lxdSettings.other.useNewApi,
          instance: item.lxdName,
          cluster: item.lxdCluster,
          ip: item.ip,
          UID: item.uid,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          vzToLxdId: item.id,
        })
        if(resp.data.success) {
          step.status = 'complete'
          step.apiResponse = resp.data
          step.end = new Date().toISOString()
          await this.updateStep(title, item, step)
        }
        this.action = ''
      } else if (title === 'Shutdown VZ') {
        const step = this.getStepFromTitle(title, item)
        step.status = 'running'
        step.start = new Date().toISOString()
        await this.updateStep(title, item, step)
        // const resp = await this.$http.post('host-bill/suspend-vz', {
        //   grant_type: "token",
        //   solusVpsId: item.vz.solusVM_VPS_ID,
        //   hosname: item.hostname,
        //   action: 'stop',
        //   UID: item.uid,
        //   firstName: this.user.firstName,
        //   lastName: this.user.lastName,
        // });
        const resp = await this.$http.post('/lxd/preserve-ip-bash-commands', {
          grant_type: 'token',
          action: 'shutdown-vz',
          ip: item.ip,
          UID: item.uid,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          vzToLxdId: item.id,
        })
        if(resp.data.success) {
          step.status = 'complete'
          step.apiResponse = resp.data
          step.end = new Date().toISOString()
          await this.updateStep(title, item, step)
          this.action = 'Suspend VZ'
          await this.suspendVZStep('Suspend VZ', item, resolveForcefully)
        }
        this.action = ''
      } else if(title === 'Suspend VZ') {
        console.log('in else')
        this.action = 'Suspend VZ'
        await this.suspendVZStep('Suspend VZ', item, resolveForcefully)
        this.action = ''
      } else if (title === 'Run ARPING') {
        await this.runARPing('Run ARPING', item)
      } else if (title === 'Promote Secondary IP to Primary') {
        const step = this.getStepFromTitle(title, item)
        step.status = 'running'
        step.start = new Date().toISOString()
        await this.updateStep(title, item, step)
        const resp = await this.$http.post('/lxd/n8n-apis-for-lxd-migration', {
          grant_type: 'token',
          action:'promote-secondary-ip-to-primary',
          instance: item.lxdName,
          cluster: item.lxdCluster,
          UID: item.uid,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          useNewApi: this.lxdSettings.other.useNewApi,
          vzToLxdId: item.id,
        })
        if(resp.data.success) {
          step.status = 'complete'
          step.apiResponse = resp.data
          step.end = new Date().toISOString()
          await this.updateStep(title, item, step)
        }
        this.action = ''
      }
      else if (title === 'Ensure old IP is accessible on new server') {
        const step = this.getStepFromTitle(title, item)
        step.status = 'running'
        step.start = new Date().toISOString()
        await this.updateStep(title, item, step)
        step.status = item.ensureOldIpAccessible === 'yes' ? 'complete' : 'fail'
        step.apiResponse = item.ensureOldIpAccessible === 'yes' ? { verified: true} : { verified: false }
        step.end = new Date().toISOString()
        await this.updateStep(title, item, step)
        this.action = ''
      }else if (title === 'Sync Consul') {
        const step = this.getStepFromTitle(title, item)
        step.status = 'running'
        step.start = new Date().toISOString()
        await this.updateStep(title, item, step)
        const resp = await this.$http.post('/lxd/n8n-apis-for-lxd-migration', {
          grant_type: 'token',
          action: 'update-consul-info',
          ip: item.ip,
          serviceId: item.serviceId,
          UID: item.uid,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          vzToLxdId: item.id,
        })
        if(resp.data.success) {
          step.status = 'complete'
          step.apiResponse = resp.data
          step.end = new Date().toISOString()
          await this.updateStep(title, item, step)
        }
        this.action = ''
      } else if (title === 'Update Hostbill Service') {
        const step = this.getStepFromTitle(title, item)
        step.status = 'running'
        step.start = new Date().toISOString()
        await this.updateStep(title, item, step)
        const resp = await this.$http.post('/lxd/n8n-apis-for-lxd-migration', {
          grant_type: 'token',
          action: 'update-hostbill-ip',
          ip: item.ip,
          serviceId: item.serviceId,
          UID: item.uid,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          vzToLxdId: item.id,
        })
        if (resp.data.success) {
          step.status = 'complete'
          step.apiResponse = resp.data
          step.end = new Date().toISOString()
          await this.updateStep(title, item, step)
        }
        this.action = ''
      }else if (title === 'Update IP') {
        try {
          const updateip = this.getStepFromTitle(title, item)
          updateip.status = 'running'
          updateip.start = new Date().toISOString()
          await this.updateStep(title, item, updateip)
          const hsRef = await db.collection('hostingAccounts').doc(item.uid).get()
          console.log('hsRef', hsRef.exists)
          if (hsRef.exists) {
            const {accounts} = hsRef.data();
            const selectedAcc = accounts.find(el => el.primary.hbHostname === item.hostname || el.primary.serverIP === item.ip)
            console.log('selectedAcc', selectedAcc)
            if (selectedAcc) {
              const planIndex = accounts.findIndex(el => el.primary.hbHostname === item.hostname || el.primary.serverIP === item.ip)
              const userRef = await db.collection('users').doc(item.uid).get()
              let customerId = ''
              if (userRef.exists) {
                customerId = userRef.data().customerID
              }
              const resp = await this.$http.post('utilities/update-ip', {
                grant_type: "token",
                ip: item.preserveIp ? item.ip : item.lxdIp,
                planIndex,
                UID: item.uid,
                sourceUid: item.uid,
                firstName: this.user.firstName,
                lastName: this.user.lastName,
                custId: customerId,
                domain: selectedAcc.primary.domain,
                vzToLxdId: item.id
              });
              return
            } else {
              updateip.status = 'fail'
              updateip.end = new Date().toISOString()
              updateip.apiResponse = {success: false, error: 'Could not find service in wpo'}
              await this.updateStep(title, item, updateip)
            }

          }
        } catch (e) {
          console.log('error in update i', e)
        }

        // updateip.status = 'complete'
        // await this.updateStep(title, item, updateip)
      } else if (title === 'Patch Backups') {
        const step = this.getStepFromTitle(title, item)
        step.status = 'running'
        step.start = new Date().toISOString()
        await this.updateStep(title, item, step)
        try {
          const resp = await this.$http.post('/lxd/n8n-apis-for-lxd-migration', {
            grant_type: 'token',
            action: 'patch-backups',
            ip: item.preserveIp ? item.ip : item.lxdIp,
            vzToLxdId: item.id,
            backup_cron: item.backupCronOutput ? item.backupCronOutput.replace(/\n/g, '') : '',
            serviceId: item.serviceId,
            hostname: item.hostname
          })
          if (resp.data.success) {
            step.status = 'complete'
            step.apiResponse = resp.data
            step.end = new Date().toISOString()
            await this.updateStep(title, item, step)
          } else {
            step.status = 'fail'
            step.apiResponse = resp.data
            step.end = new Date().toISOString()
            await this.updateStep(title, item, step)
          }
        } catch (e) {
          step.status = 'fail'
          step.apiResponse = { success: false, error: e.message }
          step.end = new Date().toISOString()
          await this.updateStep(title, item, step)
        }
        this.action = ''
      } else if (title === 'Sync FTP & SSH') {
        const step = this.getStepFromTitle(title, item)
        step.status = 'running'
        step.start = new Date().toISOString()
        await this.updateStep(title, item, step)
        try {
          const resp = await this.$http.post('ftp/notify-server', {
            grant_type: 'token',
            ip: item.lxdIp,
          })
          if (resp.data.success) {
            step.status = 'complete'
            step.apiResponse = resp.data
            step.end = new Date().toISOString()
            await this.updateStep(title, item, step)
          } else {
            step.status = 'fail'
            step.apiResponse = resp.data
            step.end = new Date().toISOString()
            await this.updateStep(title, item, step)
          }
        } catch (e) {
          step.status = 'fail'
          step.apiResponse = { success: false, error: e.message }
          step.end = new Date().toISOString()
          await this.updateStep(title, item, step)
        }
        this.action = ''
      } else if (title === 'Suspend VZ') {
        await this.suspendVZStep(title, item, resolveForcefully)

      } else if (title === 'Finish') {
        const finish = this.getStepFromTitle(title, item)
        finish.status = 'complete'
        finish.start = new Date().toISOString()
        finish.end = new Date().toISOString()
        await this.updateStep(title, item, finish)
        try{
          const ref = await db.collection('users').where('email', '==', item.checkedInByEmail).limit(1).get();
          if(ref.size) {
            const data = ref.docs[0].data()
            await this.incrementCountBasedOnType({...data, uid: ref.docs[0].id}, 'internalMigration')
          }
        }catch (e) {
          console.log('line 1023', e.toString())
        }
        await db.collection('vzToLxdMigration').doc(item.id).update({status: 'complete', completedAt: new Date().toISOString()})
        try {
          const backupFlag = await db.collection('newBackupFlags').where('hbServiceID', '==', item.serviceId).limit(1).get();
          if(backupFlag.empty) {
            await db.collection('newBackupFlags').add({
              new_backup: true,
              old_backup: true,
              uid: item.uid,
              hbServiceID: item.serviceId,
              ip: item.lxdIp,
              hbHostname: item.hostname,
              createdAt: new Date().toISOString(),
            });
          }
        } catch (e) {
          console.log('error in new backup flag', e.toString())
        }
      }
      this.selectedIndex = -1
      this.action = ''
    },
    async handleCheckIn(item) {
      try {
        // Set loading state
        this.$set(this.checkInLoading, item.id, true);
        
        // Update the item in Firestore
        await db.collection('vzToLxdMigration').doc(item.id).update({
          status: 'in-progress',
          checkedIn: true,
          checkedInByEmail: this.user.email,
          checkedInBy: `${this.user.firstName} ${this.user.lastName}` || 'unknown',
          checkedInAt: new Date().toISOString(),
          steps:  (item.preserveIp ? this.preserveIpSteps : this.steps)
        })
        console.log('Checked in:', item.hostname)
        const index = this.pendingData.findIndex(el => el.id === item.id)
        this.pendingData.splice(index, 1);
        const obj = this.allRecords.find(el => el.hostname === item.hostname)
        if(obj)  {
          obj.status = 'in-progress'
          
        }
        // await this.fetchPending()
        this.$set(this.checkInLoading, item.id, false);
      } catch (error) {
        console.error('Error checking in:', error)
        this.$set(this.checkInLoading, item.id, false);
      } finally {
        // Clear loading state
        this.$set(this.checkInLoading, item.id, false);
      }
    },
    async handleCheckOut(item) {
      try {
        // Set loading state
        this.$set(this.checkInLoading, item.id, true);
        
        // Update the item in Firestore
        await db.collection('vzToLxdMigration').doc(item.id).update({
          checkedIn: false,
          checkedOutAt: new Date().toISOString(),
          checkedInByEmail: '',
          checkedInBy: '',
          status: 'pending'
        })
        const obj = this.allRecords.find(el => el.hostname === item.hostname)
        obj.status = 'pending'
        console.log('Checked out:', item.hostname)
      } catch (error) {
        console.error('Error checking out:', error)
      } finally {
        // Clear loading state
        this.$set(this.checkInLoading, item.id, false);
      }
    },
    applyFiltersToData(data) {
      let filtered = [...data];
      if (this.activeTab === 'pending') {
        console.log('data of ending', data)
        return filtered;
      }
      // Filter by IP Group
      if (this.selectedIpGroup !== 'all') {
        // You'll need to map IP groups based on your data structure
        // This is a placeholder - adjust based on your actual data
        filtered = filtered.filter(item => {
          // Add logic to determine IP group from item data
          // For now, return true as placeholder
          return item.ipGroup.toLowerCase().includes(this.selectedIpGroup.toLowerCase());
        });
      }
      // if (this.selectedTeamFilter) {
      //   filtered = filtered.filter(item => item.assignedTeam === this.selectedTeamFilter);
      // }
      if (this.checkinFilter !== 'all') {
        // You'll need to map IP groups based on your data structure
        // This is a placeholder - adjust based on your actual data
        filtered = filtered.filter(item => {
          // Add logic to determine IP group from item data
          // For now, return true as placeholder
          return item.checkedInBy === this.checkinFilter;
        });
      }
      // Filter by Step
      if (this.selectedStep && this.activeTab === 'in-progress' && this.selectedStep !== 'All') {
        filtered = filtered.filter(item => {
          const currentStep = this.getCurrentStep(item);
          return currentStep && currentStep.name === this.selectedStep;
        });
      }
      // Filter by Plan
      if (this.selectedPlanValues.length > 0) {
        filtered = filtered.filter(item => {
          if (!item.planName) return false;
          return this.selectedPlanValues.some(p => item.planName.toLowerCase().includes(p.toLowerCase()));
        });
      }
      
      // Filter by Node / Rack — UNCATEGORIZED is a sentinel meaning "no rack and no node"
      if (this.selectedRack === 'UNCATEGORIZED') {
        filtered = filtered.filter(item => !item.rack && !item.nodeName);
      } else {
        if (this.selectedNode !== 'all') {
          filtered = filtered.filter(item => {
            if (!item.nodeName) return false;
            return item.nodeName.toLowerCase() === this.selectedNode.toLowerCase();
          });
        }
        if (this.selectedRack !== 'all') {
          filtered = filtered.filter(item => {
            if (!item.rack) return false;
            return item.rack.toLowerCase() === this.selectedRack.toLowerCase();
          });
        }
      }
      if (this.dnsTicketCreated !== 'all') {
        if (this.dnsTicketCreated === 'yes') {
          filtered = filtered.filter(item => {
            return item.ticketAndNotes && !!item.ticketAndNotes.find(el => el.ticketId)
          })
        } else if (this.dnsTicketCreated === 'no') {
          filtered = filtered.filter(item => {
            return !item.ticketAndNotes || !!item.ticketAndNotes.find(el => !el.ticketId)
          })
        }
      }
      if (this.dnsProvided !== 'all') {
        if (this.dnsProvided === 'yes') {
          filtered = filtered.filter(item => {
            return (item.dnsProvided && item.dnsProvided === 'yes') || this.checkCFStatus(item)
          })
        } else if (this.dnsProvided === 'no') {
          filtered = filtered.filter(item => {
            return (item.dnsProvided && item.dnsProvided === 'no') || !this.checkCFStatus(item)
          })
        }
      }
      filtered = filtered.map(el => {
        const {vz} = el
        el.updatedDisk = vz && vz.hdd ? this.convertDisk(vz.hdd.total) : 0
        return el
      })
      if (this.searchText) {
        filtered = filtered.filter(el => {
          const sq = this.searchText.toLowerCase().trim()
          return el.ip.toLowerCase().includes(sq) || el.hostname.toLowerCase().includes(sq) || (el.nodeName && el.nodeName.toLowerCase().includes(sq)) || (el.lxdNode && el.lxdNode.includes(sq)) || (el.lxdIp && el.lxdIp.includes(sq))
        })
      }
      return filtered;
    },
    resetFilters() {
      this.selectedNode = 'all';
      this.selectedRack = 'all';
      this.selectedPlans = [];
      this.selectedIpGroup = 'all'
      this.dnsProvided = 'all'
      this.dnsTicketCreated = 'all'
      if (this.activeTab === 'pending') {
        this.searchQuery = false
        this.fetchPending()
      }

    },
    toggleRow(itemId) {
      // Toggle expanded state for the row

      this.$set(this.expandedRows, itemId, !this.expandedRows[itemId]);
      // Ensure expanded row is positioned correctly after toggle
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            try {
              const parentRow = $(`tr[data-row-id="${itemId}"]`);
              const expandedRow = $(`tr[data-parent-id="${itemId}"]`);

              if (!expandedRow.length || !parentRow.length) return;

              const parentNode = parentRow[0];
              const expandedNode = expandedRow[0];

              // Verify both nodes exist and are in the same parent
              if (!parentNode || !expandedNode) return;
              if (!parentNode.parentNode || !expandedNode.parentNode) return;
              if (parentNode.parentNode !== expandedNode.parentNode) return;

              // Check if already in correct position
              if (parentNode.nextSibling === expandedNode) {
                return; // Already in correct position
              }

              // Use native DOM methods for safer manipulation
              const tbody = parentNode.parentNode;
              if (tbody && parentNode.nextSibling) {
                tbody.insertBefore(expandedNode, parentNode.nextSibling);
              } else {
                tbody.appendChild(expandedNode);
              }
            } catch (e) {
              // Silently handle errors - Vue will handle the rendering
            }
          }, 50);
        });
      })
    },
    async getPresetMacros() {
      try {
        const ticketRef = await db
            .collection("permissions")
            .doc("preset_macros_domain")
            .get();
        if (ticketRef.exists) {
          this.presetMacros = ticketRef.data().replies || []
        }
      } catch (e) {
        console.error('Error loading preset macros:', e)
      }
    },
    copyAllDomains(tab) {
      let data = [];
      if (tab === 'pending') {
        data = this.filteredPendingData;
      } else if (tab === 'in-progress') {
        data = this.filteredInProgressData;
      } else if (tab === 'complete') {
        data = this.filteredCompleteData;
      }
      
      const allDomains = [];
      data.forEach(item => {
        if (item.domains && item.domains.length > 0) {
          item.domains.forEach(domain => {
            if (domain.domain) {
              allDomains.push(domain.domain);
            }
          });
        }
      });
      
      if (allDomains.length === 0) {
        this.showToast({message: 'No domains found', duration: 2000}, true, 'warning');
        return;
      }
      
      const domainsText = allDomains.join(', ');
      this.doCopy(domainsText);
    },
    copyDomainsWithoutCF(tab) {
      let data = [];
      if (tab === 'pending') {
        data = this.filteredPendingData;
      } else if (tab === 'in-progress') {
        data = this.filteredInProgressData;
      } else if (tab === 'complete') {
        data = this.filteredCompleteData;
      }
      
      const domainsWithoutCF = [];
      data.forEach(item => {
        if (item.domains && item.domains.length > 0) {
          item.domains.forEach(domain => {
            // Check if domain doesn't have active CF status (cf is false or undefined)
            if (domain.domain && !domain.cf) {
              domainsWithoutCF.push(domain.domain);
            }
          });
        }
      });
      
      if (domainsWithoutCF.length === 0) {
        this.showToast({message: 'No domains without active CF status found', duration: 2000}, true, 'warning');
        return;
      }
      
      const domainsText = domainsWithoutCF.join(', ');
      this.doCopy(domainsText);
    },
    copyAllDomainsForItem(item) {
      if (!item.domains || item.domains.length === 0) {
        this.showToast({message: 'No domains found', duration: 2000}, true, 'warning');
        return;
      }
      
      const allDomains = item.domains
        .filter(domain => domain.domain)
        .map(domain => domain.domain);
      
      if (allDomains.length === 0) {
        this.showToast({message: 'No domains found', duration: 2000}, true, 'warning');
        return;
      }
      
      const domainsText = allDomains.join(', ');
      this.doCopy(domainsText);
    },
    copyDomainsWithoutCFForItem(item) {
      if (!item.domains || item.domains.length === 0) {
        this.showToast({message: 'No domains found', duration: 2000}, true, 'warning');
        return;
      }
      
      const domainsWithoutCF = item.domains
        .filter(domain => domain.domain && !domain.cf)
        .map(domain => domain.domain);
      
      if (domainsWithoutCF.length === 0) {
        this.showToast({message: 'No domains without active CF status found', duration: 2000}, true, 'warning');
        return;
      }
      
      const domainsText = domainsWithoutCF.join(', ');
      this.doCopy(domainsText);
    },
    copyDomainsByNameserver(item, nameserver) {
      if (!item.domains || item.domains.length === 0) {
        this.showToast({message: 'No domains found', duration: 2000}, true, 'warning');
        return;
      }

      if (!nameserver) {
        this.showToast({message: 'No nameserver specified', duration: 2000}, true, 'warning');
        return;
      }

      const domainsByNameserver = item.domains
          .filter(domain => domain.domain && domain.dnsServer && domain.dnsServer.toLowerCase() === nameserver.toLowerCase())
          .map(domain => domain.domain);

      if (domainsByNameserver.length === 0) {
        this.showToast({message: `No domains found with nameserver: ${nameserver}`, duration: 2000}, true, 'warning');
        return;
      }

      const domainsText = domainsByNameserver.join(', ');
      this.doCopy(domainsText);
    },
    copyAllDomainsGroupedByNameserver(item) {
      if (!item.domains || item.domains.length === 0) {
        this.showToast({message: 'No domains found', duration: 2000}, true, 'warning');
        return;
      }

      // Group domains by nameserver
      const domainsByNameserver = {};
      item.domains.forEach(domain => {
        if (domain.domain && domain.dnsServer) {
          const ns = domain.dnsServer.toLowerCase();
          if (!domainsByNameserver[ns]) {
            domainsByNameserver[ns] = [];
          }
          domainsByNameserver[ns].push(domain.domain);
        }
      });

      if (Object.keys(domainsByNameserver).length === 0) {
        this.showToast({message: 'No domains with nameservers found', duration: 2000}, true, 'warning');
        return;
      }

      // Format domains grouped by nameserver
      let domainsText = '';
      Object.keys(domainsByNameserver).forEach(ns => {
        // Get the original nameserver name (preserve case from first occurrence)
        const foundDomain = item.domains.find(d => d.dnsServer && d.dnsServer.toLowerCase() === ns);
        const originalNs = (foundDomain && foundDomain.dnsServer) || ns;
        domainsText += `\n${originalNs}: ${domainsByNameserver[ns].join(', ')}\n`;
      });

      this.doCopy(domainsText.trim());
    },
    getUniqueNameservers(item) {
      if (!item.domains || item.domains.length === 0) {
        return [];
      }

      const nameserversMap = {};
      item.domains.forEach(domain => {
        if (domain.dnsServer) {
          const ns = domain.dnsServer.toLowerCase();
          if (!nameserversMap[ns]) {
            // Preserve original case from first occurrence
            nameserversMap[ns] = domain.dnsServer;
          }
        }
      });

      return Object.values(nameserversMap);
    },
    getNameserverColor(nameserver) {
      // Array of vibrant, colorful colors for nameserver badges
      const colors = [
        '#667eea', // Indigo
        '#764ba2', // Purple
        '#f093fb', // Pink
        '#4facfe', // Sky Blue
        '#43e97b', // Bright Green
        '#fa709a', // Rose
        '#fee140', // Yellow
        '#30cfd0', // Turquoise
        '#ff6b6b', // Coral Red
        '#4ecdc4', // Teal
        '#ffe66d', // Light Yellow
        '#ff8a80', // Light Red
        '#81d4fa', // Light Blue
        '#a5d6a7', // Light Green
        '#ce93d8', // Light Purple
        '#ffb74d', // Orange
        '#90caf9', // Light Sky Blue
        '#f48fb1', // Light Pink
        '#b39ddb', // Lavender
        '#64b5f6', // Blue
      ];

      if (!nameserver) return colors[0];

      // Create a simple hash from the nameserver string
      let hash = 0;
      const nsLower = nameserver.toLowerCase();
      for (let i = 0; i < nsLower.length; i++) {
        hash = nsLower.charCodeAt(i) + ((hash << 5) - hash);
      }

      // Use the hash to pick a color (always returns positive index)
      const colorIndex = Math.abs(hash) % colors.length;
      return colors[colorIndex];
    },
    darkenColor(hexColor, percent = 40) {
      // Remove # if present
      let hex = hexColor.replace('#', '');

      // Convert to RGB
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      // Darken by reducing each RGB component (maintains color hue better)
      const darkenedR = Math.max(0, Math.floor(r * (1 - percent / 100)));
      const darkenedG = Math.max(0, Math.floor(g * (1 - percent / 100)));
      const darkenedB = Math.max(0, Math.floor(b * (1 - percent / 100)));

      // Convert back to hex
      const toHex = (n) => {
        const hex = n.toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      };

      return `#${toHex(darkenedR)}${toHex(darkenedG)}${toHex(darkenedB)} !important`;
    },
    getTextColor(hexColor) {
      // Remove # if present
      let hex = hexColor.replace('#', '');

      // Convert to RGB
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      // Calculate brightness using relative luminance formula
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;

      // Use white text on dark backgrounds, dark text on light backgrounds
      // But for colorful badges, prefer white text for better contrast
      // Only use dark text if background is very light (brightness > 200)
      if (brightness > 200) {
        return this.darkenColor(hexColor, 50);
      }
      return '#ffffff';
    },
    lightenColor(hexColor, percent = 50) {
      // Remove # if present
      let hex = hexColor.replace('#', '');
      
      // Convert to RGB
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      
      // Lighten by increasing each RGB component towards white
      const lightenedR = Math.min(255, Math.floor(r + (255 - r) * (percent / 100)));
      const lightenedG = Math.min(255, Math.floor(g + (255 - g) * (percent / 100)));
      const lightenedB = Math.min(255, Math.floor(b + (255 - b) * (percent / 100)));
      
      // Convert back to hex
      const toHex = (n) => {
        const hex = n.toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      };
      
      return `#${toHex(lightenedR)}${toHex(lightenedG)}${toHex(lightenedB)}`;
    },
    getFilterColor(filter) {
      // Reuse the same color method as nameservers for consistency
      return this.getNameserverColor(filter);
    },
    getPriorityFilterColor(filter) {
      const color = this.getNameserverColor(filter)
      if(this.hovered === filter) {
        return `${color} !important`;
      }
      // Reuse the same color method as nameservers for consistency
      return color;
    },
    handlePriorityFilterHover(event, filter, isHovering) {
      this.hovered = filter;
      const el = event.currentTarget;
      const baseColor = this.getPriorityFilterColor(filter);

      if (this.selectedPriorityFilter === filter) {
        el.style.backgroundColor = baseColor;
        el.style.color = '#fff';
        return;
      }
      console.log('basecolor', baseColor)
      if (isHovering) {
        el.style.backgroundColor = baseColor;
        el.style.color = '#fff';
      } else {
        el.style.backgroundColor = 'transparent';
        el.style.color = baseColor;
      }
    },
    removePriorityFilter(filter) {
      // Check if it's the selectedIpGroup
      if (this.selectedIpGroup !== 'all' && this.selectedIpGroup === filter) {
        this.selectedIpGroup = 'all';
      }
      // Check if it's in selectedNode array
      else if (this.selectedNode && this.selectedNode.length > 0) {
        const index = this.selectedNode.indexOf(filter);
        if (index > -1) {
          this.selectedNode.splice(index, 1);
        }
      }
    },
    openCreateDnsTicketModal(item) {
      if (this.$refs.dnsTicketModal) {
        this.$refs.dnsTicketModal.load(this.presetMacros, {
          ...item
        });
      }
    },
    openAddNoteModal(item) {
      this.selectedItemForNote = item;
      this.noteForm = {
        content: ''
      };
      this.$nextTick(() => {
        $('#addNoteModal').modal('show');
      });
    },
    closeAddNoteModal() {
      $('#addNoteModal').modal('hide');
      this.selectedItemForNote = null;
      this.noteForm = {
        content: ''
      };
    },
    async saveNote(item) {
      try {
        this.savingNote = true;
        // Save note to Firestore
        if (!this.selectedItemForNote.ticketAndNotes) {
          this.selectedItemForNote.ticketAndNotes = []
        }
        this.selectedItemForNote.ticketAndNotes.push({
          content: this.noteForm.content,
          createdBy: `${this.user.firstName} ${this.user.lastName}`,
          createdByEmail: this.user.email,
          createdAt: new Date().toISOString()
        });
        
        await db.collection('vzToLxdMigration').doc(this.selectedItemForNote.id).update({
          ticketAndNotes: this.selectedItemForNote.ticketAndNotes
        });
        if (this.activeTab === 'pending') {
          const selected = this.pendingData.find(el => el.id === this.selectedItemForNote.id);
          if (selected) {
            selected.ticketAndNotes = this.selectedItemForNote.ticketAndNotes
          }
        }
        this.showToast({message: 'Note added successfully', duration: 2000}, true, 'success');
        this.closeAddNoteModal();
      } catch (error) {
        console.error('Error saving note:', error);
        this.showToast({message: 'Failed to save note', duration: 2000}, true, 'danger');
      } finally {
        this.savingNote = false;
      }
    }
  }
}
</script>

<style scoped>
.card {
  margin: 20px
}

.status-item {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  cursor: pointer;
  border: 1.5px solid #e9ecef;
  border-left: 4px solid #e9ecef;
  border-radius: 8px;
  margin-right: 10px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  height: 100%;
  min-height: 90px;
}

.status-item-pending {
  border-color: #fbc658;
  border-left-width: 4px;
  background: linear-gradient(to right, rgba(251, 198, 88, 0.05), #ffffff);
}

.status-item-pending .status-label {
  color: #fbc658;
}

.status-item-inprogress {
  border-color: #51cbce;
  border-left-width: 4px;
  background: linear-gradient(to right, rgba(81, 203, 206, 0.05), #ffffff);
}

.status-item-inprogress .status-label {
  color: #51cbce;
}

.status-item-complete {
  border-color: #6bd098;
  border-left-width: 4px;
  background: linear-gradient(to right, rgba(107, 208, 152, 0.05), #ffffff);
}

.status-item-complete .status-label {
  color: #6bd098;
}

.status-item-deferred {
  border-color: #ff9800;
  border-left-width: 4px;
  background: linear-gradient(to right, rgba(255, 152, 0, 0.05), #ffffff);
}

.status-item-deferred .status-label {
  color: #ff9800;
}

.status-item-cf-green {
  border-color: #fb6c40;
  border-left-width: 4px;
  background: linear-gradient(to right, rgba(251, 181, 64, 0.05), #ffffff);
}

.status-item-cf-green .status-label {
  color: #fb6c40;
}

.status-item-cf-red {
  border-color: #9e9e9e;
  border-left-width: 4px;
  background: linear-gradient(to right, rgba(158, 158, 158, 0.05), #ffffff);
}

.status-item-cf-red .status-label {
  color: #9e9e9e;
}

.status-icon {
  font-size: 22px;
  margin-right: 14px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  flex-shrink: 0;
}

.status-icon-pending {
  color: #fbc658;
  background: rgba(251, 198, 88, 0.1);
}

.status-icon-inprogress {
  color: #51cbce;
  background: rgba(81, 203, 206, 0.1);
}

.status-icon-complete {
  color: #6bd098;
  background: rgba(107, 208, 152, 0.1);
}

.status-item-deferred {
  border-color: #ff9800;
  border-left-width: 4px;
  background: linear-gradient(to right, rgba(255, 152, 0, 0.05), #ffffff);
}

.status-item-deferred .status-label {
  color: #ff9800;
}

.status-icon-deferred {
  color: #ff9800;
  background: rgba(255, 152, 0, 0.1);
}

.status-icon-cf-green {
  color: #fb6c40;
  background: rgba(251, 181, 64, 0.1);
}

.status-icon-cf-red {
  color: #9e9e9e;
  background: rgba(158, 158, 158, 0.1);
}

.status-content {
  flex: 1;
  min-width: 0;
}

.status-label {
  font-size: 11px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 4px;
  line-height: 1.3;
  word-wrap: break-word;
}

.status-count {
  font-size: 24px;
  font-weight: 700;
  color: #6c757d;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

.main-header {
  background-color: #f8f9fa;
  font-weight: 600;
}
.sub-header{
  th{
    text-transform: capitalize !important;
  }
}

.main-header th {
  border-bottom: 1px solid #dee2e6;
  padding: 12px;
  color: #4B5563;
}

.main-header th:first-child {
  border-right: 1px solid #dee2e6;
}

.main-header th:nth-child(2) {
  border-right: 1px solid #dee2e6;
}

.badge-success {
  background-color: #ddf6e8;
  color: #6bd098;
  font-weight: 700;
}

.badge-warning {
  background-color: #fff0e1;
  color: #fbc658;
  font-weight: 700;
}

.cursor-pointer {
  cursor: pointer;
}

.badge-danger {
  background-color: #FDEEED;
  color: #EE8157;
  font-weight: 700;
}

.badge-default {
  background-color: #e9ecef;
  color: #6c757d;
  font-weight: 700;
}

.migration-rules {
  display: flex;
  justify-content: center;
  border-radius: 0.5rem;
  border: 1px solid #e2e8f0;
  background: #f9fafb;
  max-width: 100%;
  font-size: 16px;
}

.migration-rules h5 {
  font-weight: 600;
  color: #1f2933;
}

.migration-rules .rules-pill {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  background: #edf2ff;
  color: #3b82f6;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.migration-rules ul li {
  margin-bottom: 0.25rem;
}

.migration-rules ul li strong {
  color: #111827;
}

.table thead th {
  background-color: #f8f9fa;
  font-weight: 600;
  vertical-align: middle;
  color: #4B5563;
}

.table thead tr:last-child th:nth-child(7),
.table thead tr:last-child th:nth-child(12) {
  border-right: 1px solid #dee2e6;
}

.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
    border: 0;
}

.nav-tabs {
    border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
    border: 1px solid transparent !important;
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
}

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    color: #495057;
    background-color: #fff;
    border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
    color: #5B7CFB;
}

.expanded-row {
  background-color: #f8f9fa !important;
}

.expanded-row td {
  border-top: 2px solid #dee2e6;
}

.domain-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.domain-item {
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
}

.domain-item:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.clickable-row:hover {
  background-color: #f8f9fa;
}

.btn-light {
  color: black;
  border: 1px solid lightgray;
  border-radius: 4px;
}

.expanded-table {
  th {
    background: darkgray;
    opacity: 0.6;
    color: black;
  }
}

.json-container {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-family: monospace;
  white-space: pre-wrap !important; /* Preserve line breaks for readability */
  word-wrap: break-word !important; /* Avoid overflow */
  max-width: 500px;
  width: 200px;
  overflow-wrap: break-word !important;
  overflow-x: auto;
}
::v-deep .multiselect__tag {
  display: none !important;
}
/* ══════════════════════════════════════════
   Plans filter card
══════════════════════════════════════════ */
.plans-card {
  border: 1.5px solid #e4e7f0;
  border-radius: 12px;
  background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-shadow: 0 1px 4px rgba(91,108,240,0.06);
  position: relative;
}
.plans-card:hover,
.plans-card--open {
  //border-color: #5b6cf0;
  box-shadow: 0 2px 16px rgba(91,108,240,0.13);
}

/* Header */
.plans-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 14px;
  cursor: pointer;
  background: linear-gradient(90deg, #f5f6ff 0%, #fff 100%);
  user-select: none;
  gap: 8px;
  border-radius: 11px
}
.plans-card-header:hover { background: linear-gradient(90deg, #edeffe 0%, #f9f9ff 100%); }
.plans-card-header-left  { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; flex: 1; min-width: 0; }
.plans-card-header-right { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }

.plans-card-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: linear-gradient(135deg, #5b6cf0, #8b5cf6);
  color: #fff;
  font-size: 11px;
  flex-shrink: 0;
}
.plans-card-title {
  font-size: 13px;
  font-weight: 700;
  color: #2d2f3e;
  letter-spacing: 0.2px;
}
.plans-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: linear-gradient(135deg, #5b6cf0, #8b5cf6);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  box-shadow: 0 2px 6px rgba(91,108,240,0.35);
}

/* Collapsed preview chips */
.plans-preview-chips { display: inline-flex; flex-wrap: wrap; gap: 4px; }
.plans-preview-chip {
  padding: 2px 9px;
  border-radius: 12px;
  background: linear-gradient(135deg, #5b6cf0, #8b5cf6);
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.plans-clear-x {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fee2e2;
  color: #ef4444;
  font-size: 10px;
  cursor: pointer;
  transition: background 0.15s;
}
.plans-clear-x:hover { background: #ef4444; color: #fff; }

.plans-chevron i {
  font-size: 11px;
  color: #8b92b8;
  transition: transform 0.25s ease;
  display: block;
}
.plans-chevron--open i { transform: rotate(180deg); }

/* Body */
.plans-card-body {
  padding: 10px 12px 12px;
  border-top: 1px solid #eef0f8;
  background: #fafbff;
  overflow: visible;
  border-radius: 11px;
}

/* Multiselect overrides */
::v-deep .plans-multiselect { width: 100%; }
::v-deep .plans-multiselect .multiselect__tags {
  border: 1.5px solid #dde0f5;
  border-radius: 10px;
  padding: 8px 40px 8px 8px;
  min-height: 46px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 5px;
  background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
}
::v-deep .plans-multiselect.multiselect--active .multiselect__tags {
  border-color: #5b6cf0;
  box-shadow: 0 0 0 3px rgba(91,108,240,0.12);
}
::v-deep .plans-multiselect .multiselect__tag {
  display: inline-flex !important;
  align-items: center;
  margin: 0;
  padding: 4px 24px 4px 11px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 20px;
  background: linear-gradient(135deg, #5b6cf0, #8b5cf6);
  color: #fff;
  box-shadow: 0 2px 6px rgba(91,108,240,0.25);
}
::v-deep .plans-multiselect .multiselect__tag-icon { line-height: 21px; width: 20px; }
::v-deep .plans-multiselect .multiselect__tag-icon:after { color: rgba(255,255,255,0.75); font-size: 12px; }
::v-deep .plans-multiselect .multiselect__tag-icon:hover { background: rgba(0,0,0,0.15); border-radius: 0 20px 20px 0; }
::v-deep .plans-multiselect .multiselect__content-wrapper {
  border: 1.5px solid #dde0f5;
  border-top: none;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 8px 24px rgba(91,108,240,0.12);
  z-index: 9999 !important;
  position: absolute;
}
::v-deep .plans-multiselect .multiselect__option {
  font-size: 13px;
  padding: 10px 14px;
}
::v-deep .plans-multiselect .multiselect__option--highlight {
  background: linear-gradient(90deg, #5b6cf0, #8b5cf6);
  color: #fff;
}
::v-deep .plans-multiselect .multiselect__option--selected {
  background: #eef0fd;
  color: #3949ab;
  font-weight: 600;
}
::v-deep .plans-multiselect .multiselect__option--selected::after {
  color: #5b6cf0;
}
::v-deep .plans-multiselect .multiselect__option--selected.multiselect__option--highlight {
  background: linear-gradient(90deg, #3949ab, #6d28d9);
  color: #fff;
}
::v-deep .plans-multiselect .multiselect__input,
::v-deep .plans-multiselect .multiselect__placeholder {
  font-size: 13px;
  color: #9ca3af;
  margin: 0;
  padding: 3px 0;
}
::v-deep .plans-multiselect .multiselect__select {
  top: 10px;
}

/* Animations */
.plans-expand-enter-active { transition: max-height 0.25s ease, opacity 0.2s ease; }
.plans-expand-leave-active  { transition: max-height 0.2s ease,  opacity 0.15s ease; }
.plans-expand-enter, .plans-expand-leave-to { max-height: 0; opacity: 0; }
.plans-expand-enter-to, .plans-expand-leave { max-height: 400px; opacity: 1; }

.plans-slide-enter-active, .plans-slide-leave-active { transition: opacity 0.18s ease; }
.plans-slide-enter, .plans-slide-leave-to { opacity: 0; }

.plans-badge-pop-enter-active { transition: transform 0.2s cubic-bezier(.34,1.56,.64,1), opacity 0.15s; }
.plans-badge-pop-enter { transform: scale(0); opacity: 0; }
.priority-filter-btn {
  margin-right: 0.5rem;
}


.leaders-bar {
  background: linear-gradient(to right, #ffe5d0, #fff5e6);
  border-radius: 50px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-height: 50px;
}

.leader-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.leader-avatar:hover {
  transform: scale(1.1);
  z-index: 1;
  position: relative;
}

/* Racks for Teams */
.team-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 8px;
}
.team-row--morning {
  background: #fffbeb;
  border: 1px solid #fde68a;
}
.team-row--night {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
}
.team-row__label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 52px;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}
.team-row--morning .team-row__label .fa {
  font-size: 18px;
  color: #f59e0b;
}
.team-row--night .team-row__label .fa {
  font-size: 18px;
  color: #6366f1;
}
.team-row__fields {
  display: flex;
  flex: 1;
  gap: 10px;
}
.team-row__field {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.team-row__field--dns {
  max-width: 110px;
}
.team-row__field-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
  margin-bottom: 4px;
}
.team-row__select {
  height: 34px !important;
  border-radius: 6px !important;
  font-size: 13px !important;
}
</style>

